import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  CampaignPreviewTheme: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  GeoJSON: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONB: { input: any; output: any; }
  Long: { input: any; output: any; }
  Mixed: { input: any; output: any; }
  PropertyMetricKey: { input: any; output: any; }
  SequelizeJSON: { input: any; output: any; }
  UUID: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type Account = {
  accountType?: Maybe<AccountObject>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  auditLog: AccountAuditLogConnection;
  branchOffice?: Maybe<Scalars['Boolean']['output']>;
  campaigns?: Maybe<CampaignEdges>;
  canonicalId: Scalars['ID']['output'];
  changeParent?: Maybe<Scalars['Boolean']['output']>;
  /** Get specific contact */
  contact?: Maybe<Contact>;
  contacts?: Maybe<AccountContactEdges>;
  createdBy?: Maybe<User_V2>;
  discount: AccountDiscount;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  foldername?: Maybe<Scalars['String']['output']>;
  fontFamilies?: Maybe<Array<Maybe<AccountFontFamily>>>;
  /** @deprecated Use canonicalId instead for a globally unique account identifier across tenants. */
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  imprintUrl?: Maybe<Scalars['String']['output']>;
  industrySector?: Maybe<IndustrySectorType>;
  isAgency?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Will be removed in future versions */
  isBookable?: Maybe<Scalars['Boolean']['output']>;
  isDirectClient?: Maybe<Scalars['Boolean']['output']>;
  isReference?: Maybe<Scalars['Boolean']['output']>;
  isReseller?: Maybe<Scalars['Boolean']['output']>;
  isSales?: Maybe<Scalars['Boolean']['output']>;
  isUsed?: Maybe<Scalars['Boolean']['output']>;
  legalUrl?: Maybe<Scalars['String']['output']>;
  list?: Maybe<AccountList>;
  lists?: Maybe<AccountListEdges>;
  locationshortcut?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Media>;
  media?: Maybe<MediaEdges>;
  meta?: Maybe<Scalars['SequelizeJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<AccountNote>;
  number?: Maybe<Scalars['String']['output']>;
  oldNumber?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Account>;
  phone?: Maybe<Scalars['String']['output']>;
  privacyUrl?: Maybe<Scalars['String']['output']>;
  publishers?: Maybe<AccountPublisherConnection>;
  revenueType?: Maybe<AccountRevenueType>;
  updatedBy?: Maybe<User_V2>;
  vat?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};


export type AccountAddressArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type: Array<Scalars['String']['input']>;
};


export type AccountCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountContactArgs = {
  id: Scalars['ID']['input'];
};


export type AccountContactsArgs = {
  contactType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountFontFamiliesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountListArgs = {
  id: Scalars['ID']['input'];
};


export type AccountListsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountMediaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type AccountPublishersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type AccountAuditLog = {
  comment?: Maybe<Scalars['String']['output']>;
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy: User_V2;
  diff?: Maybe<Array<Maybe<AccountDiscountDiff>>>;
  payload: Array<AccountAuditLogPayload>;
  type: Scalars['String']['output'];
};

export type AccountAuditLogConnection = {
  edges: Array<Maybe<AccountAuditLogEdge>>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountAuditLogEdge = {
  cursor: Scalars['String']['output'];
  node: AccountAuditLog;
};

export type AccountAuditLogPayload = AccountDiscountGeneralAgreement | AccountDiscountInventory | AccountDiscountResearch | AccountDiscountSkonto | AccountDiscountSurcharge;

export type AccountContact = {
  account?: Maybe<Account>;
  contact?: Maybe<Contact>;
  contactType?: Maybe<AccountObject>;
};

export type AccountContactEdges = {
  edges?: Maybe<Array<Maybe<AccountContactNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountContactNode = {
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<AccountContact>;
};

export type AccountDiscount = {
  generalAgreement?: Maybe<Array<AccountDiscountGeneralAgreement>>;
  inventory?: Maybe<Array<AccountDiscountInventory>>;
  research?: Maybe<Array<AccountDiscountResearch>>;
  skonto?: Maybe<Array<AccountDiscountSkonto>>;
  surcharge?: Maybe<Array<AccountDiscountSurcharge>>;
};

export type AccountDiscountDiff = {
  newObject?: Maybe<AccountDiscountDiffObject>;
  oldObject?: Maybe<AccountDiscountDiffObject>;
};

export type AccountDiscountDiffObject = {
  discount?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  props?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  tiers?: Maybe<Array<Maybe<AccountDiscountDiffTier>>>;
  type?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['String']['output']>;
  validTo?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountDiffTier = {
  newObject?: Maybe<AccountDiscountDiffTierObject>;
  oldObject?: Maybe<AccountDiscountDiffTierObject>;
};

export type AccountDiscountDiffTierObject = {
  breakpoint?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  props?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountGeneralAgreement = {
  account?: Maybe<Account>;
  discount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  retroactive?: Maybe<Scalars['Boolean']['output']>;
  tiers?: Maybe<Array<AccountDiscountTiered>>;
  type: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountGraphqlInputType = {
  discount: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
};

export type AccountDiscountInventory = {
  account?: Maybe<Account>;
  disableSkonto?: Maybe<Scalars['Boolean']['output']>;
  discount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountResearch = {
  account?: Maybe<Account>;
  discount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  tiers?: Maybe<Array<AccountDiscountTiered>>;
  type: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountSkonto = {
  account?: Maybe<Account>;
  deadline: Scalars['String']['output'];
  discount: Scalars['String']['output'];
  gracePeriod: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountSurcharge = {
  account?: Maybe<Account>;
  discount: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  validFrom: Scalars['String']['output'];
  validTo: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type AccountDiscountTiered = {
  breakpoint: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  value: Scalars['Float']['output'];
};

export type AccountEdges = {
  edges?: Maybe<Array<Maybe<AccountNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountFont = {
  id: Scalars['ID']['output'];
  media?: Maybe<Media>;
  type?: Maybe<AccountFontType>;
};

export type AccountFontFamily = {
  createdBy?: Maybe<User_V2>;
  /** Get assigned Fonts */
  fonts?: Maybe<Array<Maybe<AccountFont>>>;
  fontstretch?: Maybe<Scalars['String']['output']>;
  fontstyle?: Maybe<Scalars['String']['output']>;
  fontweight?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedBy?: Maybe<User_V2>;
};

export type AccountFontFamilyInput = {
  fonts?: InputMaybe<Array<InputMaybe<AccountFontInput>>>;
  fontstretch?: InputMaybe<Scalars['String']['input']>;
  fontstyle?: InputMaybe<Scalars['String']['input']>;
  fontweight?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type AccountFontInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<AccountFontType>;
};

export enum AccountFontType {
  Eot = 'EOT',
  Otf = 'OTF',
  Svg = 'SVG',
  Woff = 'WOFF',
  Woff2 = 'WOFF2'
}

export type AccountInput = {
  accountType?: InputMaybe<Scalars['ID']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['ID']['input']>;
  branchOffice?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  discounts?: InputMaybe<Array<InputMaybe<AccountDiscountGraphqlInputType>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  foldername?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imprintUrl?: InputMaybe<Scalars['String']['input']>;
  industrySector?: InputMaybe<Scalars['ID']['input']>;
  isBookable?: InputMaybe<Scalars['Boolean']['input']>;
  isReference?: InputMaybe<Scalars['Boolean']['input']>;
  isSales?: InputMaybe<Scalars['Boolean']['input']>;
  legalUrl?: InputMaybe<Scalars['String']['input']>;
  locationshortcut?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['Mixed']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  oldNumber?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  revenueType?: InputMaybe<Scalars['ID']['input']>;
  upsertAddress?: InputMaybe<AddressInput>;
  vat?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type AccountList = {
  account?: Maybe<Account>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AccountListEdges = {
  edges?: Maybe<Array<Maybe<AccountListNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type AccountListInput = {
  account: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  type: AccountListType;
};

export type AccountListNode = {
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<AccountList>;
};

export enum AccountListType {
  Blacklist = 'BLACKLIST',
  Whitelist = 'WHITELIST'
}

export type AccountMutation = {
  addAccountContact?: Maybe<AddAccountContactPayload>;
  /** copy existing account */
  copy?: Maybe<CopyAccountPayload>;
  createContact?: Maybe<Contact>;
  createListBulk?: Maybe<ImportBatchPayload>;
  remove?: Maybe<RemoveAccountPayload>;
  removeAccountContact?: Maybe<RemoveAccountContactPayload>;
  removeFontFamily?: Maybe<Scalars['Boolean']['output']>;
  removeList?: Maybe<RemoveAccountListPayload>;
  upsert?: Maybe<Account>;
  upsertDiscount?: Maybe<UpsertAccountDiscountOutput>;
  upsertFontFamily?: Maybe<AccountFontFamily>;
  upsertList?: Maybe<UpsertAccountListPayload>;
  upsertNote?: Maybe<UpsertAccountNotePayload>;
};


export type AccountMutationAddAccountContactArgs = {
  contact: Scalars['ID']['input'];
  contactType?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountMutationCopyArgs = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  contacts?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<AccountInput>;
  discounts?: InputMaybe<Scalars['Boolean']['input']>;
  fontFamilies?: InputMaybe<Scalars['Boolean']['input']>;
  lists?: InputMaybe<Scalars['Boolean']['input']>;
  publishers?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccountMutationCreateContactArgs = {
  contactType?: InputMaybe<Scalars['ID']['input']>;
  data: ContactInput;
};


export type AccountMutationCreateListBulkArgs = {
  data?: InputMaybe<Array<AccountListInput>>;
};


export type AccountMutationRemoveAccountContactArgs = {
  contact: Scalars['ID']['input'];
  contactType?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AccountMutationRemoveFontFamilyArgs = {
  id: Scalars['ID']['input'];
};


export type AccountMutationRemoveListArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type AccountMutationUpsertArgs = {
  data: AccountInput;
};


export type AccountMutationUpsertDiscountArgs = {
  data: UpsertAccountDiscountInput;
};


export type AccountMutationUpsertFontFamilyArgs = {
  data: AccountFontFamilyInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type AccountMutationUpsertListArgs = {
  data: AccountListInput;
};


export type AccountMutationUpsertNoteArgs = {
  data: AccountNoteInput;
};

export type AccountNode = {
  node?: Maybe<Account>;
};

export type AccountNote = {
  content?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type AccountNoteInput = {
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type AccountObject = {
  active?: Maybe<Scalars['Boolean']['output']>;
  childs?: Maybe<Array<Maybe<AccountObject>>>;
  deepLink?: Maybe<Scalars['String']['output']>;
  formName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  menuVisible?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pluralName?: Maybe<Scalars['String']['output']>;
  type: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type AccountPublisherConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AccountPublisherEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type AccountPublisherEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Publisher>;
};

export type AccountRevenueType = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AclQuery = {
  /** When user and role is not defined, it returns all available permissions */
  permissions?: Maybe<Array<Maybe<Permission>>>;
};


export type AclQueryPermissionsArgs = {
  role?: InputMaybe<Scalars['ID']['input']>;
  user?: InputMaybe<Scalars['ID']['input']>;
};

export type AddAccountContactPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddCampaignComponentPayload = MutationResponse & {
  campaignComponent?: Maybe<CampaignComponent>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type AddCreativeRevisionFromHashInput = {
  brandSafetyTracking?: InputMaybe<Scalars['String']['input']>;
  clickTracking: Scalars['String']['input'];
  creativeId: Scalars['ID']['input'];
  hash: Scalars['String']['input'];
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
  viewTracking?: InputMaybe<Scalars['String']['input']>;
};

export type AddCreativeRevisionFromHashPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Creative>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type Address = {
  additional?: Maybe<Scalars['String']['output']>;
  /** Get assigned Address Category */
  category?: Maybe<AddressCategory>;
  city: Scalars['String']['output'];
  /** Get assigned Country */
  country?: Maybe<Country>;
  createdBy?: Maybe<User_V2>;
  id: Scalars['ID']['output'];
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  partialMatch: Scalars['Boolean']['output'];
  street?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<User_V2>;
  zip: Scalars['String']['output'];
};

export type AddressCategory = {
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type AddressComponents = {
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  additional?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type AddressQuery = {
  geocode?: Maybe<Array<Maybe<Address>>>;
};


export type AddressQueryGeocodeArgs = {
  additional?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type AdslotDayList = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Ad-Slot */
  adPlacementType: Scalars['String']['output'];
  /** Day */
  day: Scalars['String']['output'];
  /** Unique billable interactions or Adserver clicks for external products */
  interaction: Scalars['Int']['output'];
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
};

export type AdtechMutation = {
  migrator?: Maybe<AdtechMutationMigrator>;
};

export type AdtechMutationMigrator = {
  product?: Maybe<AdtechMutationMigratorProduct>;
};


export type AdtechMutationMigratorProductArgs = {
  input: AdtechMutationMigratorProductInput;
};

export type AdtechMutationMigratorProduct = {
  migratedProducts: Scalars['Int']['output'];
  updated: Scalars['DateTime']['output'];
};

export type AdtechMutationMigratorProductInput = {
  password: Scalars['String']['input'];
  resellerSource: Scalars['Int']['input'];
  resellerTarget: Scalars['Int']['input'];
  sourceUrl: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type AdvancedMapFilter = MapFilterBase & {
  filters: Array<MapFilterNode>;
  manualZips?: Maybe<Array<Scalars['String']['output']>>;
  zips: Array<Scalars['String']['output']>;
};

export type AdvancedMapFilterInput = {
  filters: Array<MapFilterNodeInput>;
  manualZips?: InputMaybe<Array<Scalars['String']['input']>>;
  zips: Array<Scalars['String']['input']>;
};

/** Agreement details structure */
export type AgreementDetailsInput = {
  approvedAt?: InputMaybe<Scalars['String']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AreasFilter = {
  and?: InputMaybe<Array<AreasFilter>>;
  areaCode?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<AreasFilter>;
  or?: InputMaybe<Array<AreasFilter>>;
};

export type AreasGeoData = {
  areaCode: Scalars['String']['output'];
  centroid?: Maybe<Scalars['GeoJSON']['output']>;
  countryCode: Scalars['String']['output'];
  featureId?: Maybe<Scalars['BigInt']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  onSurfaceCentroid?: Maybe<Scalars['GeoJSON']['output']>;
  zips: Array<ZipsGeoData>;
};

export type AreasOrderByField = {
  direction: OrderDirection;
  field: AreasOrderableFields;
};

export enum AreasOrderableFields {
  AreaCode = 'AREA_CODE',
  Id = 'ID',
  Name = 'NAME'
}

export type AttachStoreToStoresGroupInput = {
  storeId: Scalars['UUID']['input'];
  storesGroupId: Scalars['UUID']['input'];
};

export type AttachStoreToStoresGroupResult = {
  attached: Scalars['Boolean']['output'];
};

export type AttachTagToStoreInput = {
  storeId: Scalars['UUID']['input'];
  tagId: Scalars['UUID']['input'];
};

export type AttachTagToStoreResult = {
  attached: Scalars['Boolean']['output'];
};

export type BasicMapFilter = MapFilterBase & {
  filters?: Maybe<Scalars['SequelizeJSON']['output']>;
  manualZips?: Maybe<Array<Scalars['String']['output']>>;
  zips: Array<Scalars['String']['output']>;
};

export type BasicMapFilterInput = {
  filters?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  manualZips?: InputMaybe<Array<Scalars['String']['input']>>;
  zips: Array<Scalars['String']['input']>;
};

export type BigIntFilter = {
  equals?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThan?: InputMaybe<Scalars['BigInt']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  lowerThan?: InputMaybe<Scalars['BigInt']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['BigInt']['input']>;
  not?: InputMaybe<Scalars['BigInt']['input']>;
  notIn?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

export type BookingDefault = {
  branches?: Maybe<Array<Maybe<Branch>>>;
  budgetThresholdPercentage?: Maybe<Scalars['Float']['output']>;
  delayDays?: Maybe<Scalars['Int']['output']>;
  playoutSchedule?: Maybe<CampaignPlayoutScheduleEnum>;
  productCode?: Maybe<Scalars['String']['output']>;
};

export type BookingDefaultInput = {
  branches?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  budgetThresholdPercentage?: InputMaybe<Scalars['Float']['input']>;
  delayDays?: InputMaybe<Scalars['Int']['input']>;
  playoutSchedule?: InputMaybe<CampaignPlayoutScheduleEnum>;
  productCode?: InputMaybe<Scalars['String']['input']>;
};

export type BooleanFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BoundingBox = {
  northEast: Coordinate;
  southWest: Coordinate;
};

export type BoundingBoxInput = {
  northEast: CoordinateInput;
  southWest: CoordinateInput;
  zoom: Scalars['Float']['input'];
};

export type BpTriggerCount = {
  /** Count */
  count: Scalars['Int']['output'];
  /** Trigger name */
  trigger: Scalars['String']['output'];
};

export type Branch = {
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  hasOpeningHours?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Media>;
  imprintUrl?: Maybe<Scalars['String']['output']>;
  legalUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Media>;
  mapMarker?: Maybe<Media>;
  meta?: Maybe<Scalars['SequelizeJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['Float']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type BranchGoal = {
  /** Booked KPI target */
  bookedKpi: Scalars['Int']['output'];
  /** Fulfillment Rate: delivered KPI / expected KPI */
  fulfillmentRate: Scalars['Float']['output'];
  /** KPI code */
  kpiCode: KpiCode;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export type CalculationByTargetDeviceGroupInput = {
  DESKTOP?: InputMaybe<Scalars['String']['input']>;
  DOOH?: InputMaybe<Scalars['String']['input']>;
  MOBILE?: InputMaybe<Scalars['String']['input']>;
  MULTI?: InputMaybe<Scalars['String']['input']>;
};

export type Campaign = {
  /** Get assigned Account */
  account?: Maybe<Account>;
  accountPrefix?: Maybe<Scalars['String']['output']>;
  adGapId?: Maybe<Scalars['String']['output']>;
  additionalTracking?: Maybe<Scalars['String']['output']>;
  adserverId?: Maybe<Scalars['String']['output']>;
  blacklist?: Maybe<Scalars['String']['output']>;
  /** Get specific assigned Branch */
  branch?: Maybe<CampaignBranch>;
  /** Get assigned Branches */
  branches?: Maybe<Array<Maybe<CampaignBranch>>>;
  /** Get assigned products */
  branchesPaging?: Maybe<CampaignBranchEdges>;
  brand?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  campaignBaseData?: Maybe<CampaignBaseData>;
  /** Get specific assigned campaignStage */
  campaignStage?: Maybe<CampaignStage>;
  campaignStages?: Maybe<Array<Maybe<CampaignStage>>>;
  /** Get assigned stages */
  campaignStagesPaging?: Maybe<CampaignStageEdges>;
  categories?: Maybe<Array<Maybe<CampaignCategory>>>;
  category?: Maybe<CampaignCategory>;
  clientServiceContact?: Maybe<User_V2>;
  clientServiceContactExternal?: Maybe<Contact>;
  componentFields?: Maybe<Scalars['Mixed']['output']>;
  componentInstance?: Maybe<CampaignComponentInstance>;
  componentInstances?: Maybe<Array<Maybe<CampaignComponentInstance>>>;
  components?: Maybe<Array<Maybe<CampaignComponent>>>;
  conditionsUrl?: Maybe<Scalars['String']['output']>;
  copiedFrom?: Maybe<Campaign>;
  country?: Maybe<Country>;
  cpe?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User_V2>;
  creatives?: Maybe<Array<Maybe<Creative>>>;
  defaultFieldValues?: Maybe<Scalars['Mixed']['output']>;
  deployments?: Maybe<Array<Maybe<CampaignDeployment>>>;
  end?: Maybe<Scalars['DateTime']['output']>;
  everyTrackingPixel?: Maybe<Scalars['String']['output']>;
  f11Id?: Maybe<Scalars['String']['output']>;
  hasDeployments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Get assigned image */
  image?: Maybe<Media>;
  inShowroom: Scalars['Boolean']['output'];
  isBooked?: Maybe<Scalars['Boolean']['output']>;
  linkOutDefault?: Maybe<Scalars['String']['output']>;
  linkoutTrackingPixel?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaEdges>;
  meta?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** @deprecated Not needed anymore. Every campaign is a multi campaign. */
  multi: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  pathKalkuTool?: Maybe<Scalars['String']['output']>;
  playoutRange?: Maybe<CampaignPlayoutRangeEnum>;
  playoutSchedule?: Maybe<CampaignPlayoutScheduleEnum>;
  previewHash?: Maybe<Scalars['String']['output']>;
  /** Get specific assigned product */
  product?: Maybe<CampaignProduct>;
  productFamily: ProductFamily;
  /** Get Product Parent List */
  productParents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productVariant: ProductVariant;
  /** Get assigned products */
  products?: Maybe<Array<Maybe<CampaignProduct>>>;
  /** Get assigned products */
  productsPaging?: Maybe<CampaignProductEdges>;
  report?: Maybe<CampaignReportState>;
  reporting?: Maybe<CampaignReporting>;
  reportingEngine?: Maybe<Scalars['String']['output']>;
  reportingSchemaVersion?: Maybe<Scalars['String']['output']>;
  searchNoResultsLink?: Maybe<Scalars['String']['output']>;
  showCustomerReport?: Maybe<Scalars['Boolean']['output']>;
  showTotalReport?: Maybe<Scalars['Boolean']['output']>;
  stageGrids?: Maybe<Array<Maybe<Grid>>>;
  start?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CampaignStatus>;
  theme?: Maybe<Scalars['SequelizeJSON']['output']>;
  themeJs?: Maybe<Scalars['String']['output']>;
  themeScss?: Maybe<Scalars['String']['output']>;
  uniqueTrackingPixel?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<User_V2>;
  viewTracking?: Maybe<Scalars['String']['output']>;
  watchlaterSubject?: Maybe<Scalars['String']['output']>;
  watchlaterTemplate?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  zipCount?: Maybe<Scalars['Int']['output']>;
};


export type CampaignBranchArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBranchesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBranchesPagingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignCampaignStageArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignCampaignStagesPagingArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type CampaignCategoriesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignCategoryArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignComponentInstanceArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignComponentInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<ComponentSectionType>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignComponentsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<ComponentSectionType>;
  tags?: InputMaybe<Array<InputMaybe<ComponentTagType>>>;
};


export type CampaignDeploymentsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignMediaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignProductsArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignProductsPagingArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignStageGridsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignBaseData = {
  /** Get assigned Account */
  account?: Maybe<Account>;
  accountPrefix?: Maybe<Scalars['String']['output']>;
  adserverId?: Maybe<Scalars['String']['output']>;
  baseReporting?: Maybe<CampaignBaseDataReporting>;
  blacklist?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  budget?: Maybe<Scalars['Float']['output']>;
  clientServiceContact?: Maybe<User_V2>;
  clientServiceContactExternal?: Maybe<Contact>;
  conditionsUrl?: Maybe<Scalars['String']['output']>;
  copiedFrom?: Maybe<CampaignBaseData>;
  country?: Maybe<Country>;
  cpe?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User_V2>;
  creativesExternal?: Maybe<CampaignBaseDataCreativesExternalConnection>;
  creativesInternal?: Maybe<CampaignBaseDataCreativesInternalConnection>;
  defaultFieldValues?: Maybe<Scalars['Mixed']['output']>;
  end: Scalars['DateTime']['output'];
  f11Id?: Maybe<Scalars['String']['output']>;
  hasDeployments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /** Get assigned image */
  image?: Maybe<Media>;
  inShowroom: Scalars['Boolean']['output'];
  isBookable?: Maybe<Scalars['Boolean']['output']>;
  isBooked?: Maybe<Scalars['Boolean']['output']>;
  isBookmarked?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  pathKalkuTool?: Maybe<Scalars['String']['output']>;
  playoutRange?: Maybe<CampaignPlayoutRangeEnum>;
  playoutSchedule?: Maybe<CampaignPlayoutScheduleEnum>;
  previewBundles?: Maybe<Array<Maybe<CampaignBaseDataPreviewBundle>>>;
  previewHash?: Maybe<Scalars['String']['output']>;
  previews?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
  productFamily?: Maybe<ProductFamily>;
  productParents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productVariant?: Maybe<ProductVariant>;
  products?: Maybe<CampaignBaseDataProductConnection>;
  report?: Maybe<CampaignReportState>;
  reporting?: Maybe<CampaignReporting>;
  reportingEngine?: Maybe<Scalars['String']['output']>;
  reportingSchemaVersion?: Maybe<Scalars['String']['output']>;
  showCustomerReport?: Maybe<Scalars['Boolean']['output']>;
  showTotalReport?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<CampaignStatus>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User_V2>;
  whitelist?: Maybe<Scalars['String']['output']>;
  zipCount?: Maybe<Scalars['Int']['output']>;
};


export type CampaignBaseDataBaseReportingArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
};


export type CampaignBaseDataCreativesExternalArgs = {
  filter?: InputMaybe<CampaignBaseDataCreativeExternalFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type CampaignBaseDataCreativesInternalArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignBaseDataAddCreativesExternalInput = {
  creativeIds: Array<Scalars['ID']['input']>;
};

export type CampaignBaseDataAddCreativesExternalPayload = MutationResponse & {
  campaign?: Maybe<CampaignBaseData>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataBookmarkInput = {
  bookmark?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataBookmarkPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataCopyInput = {
  branches?: InputMaybe<Scalars['Boolean']['input']>;
  componentInstanceSection?: InputMaybe<ComponentSectionType>;
  creativesInternal?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  layoutContent?: InputMaybe<Scalars['Boolean']['input']>;
  layoutFooter?: InputMaybe<Scalars['Boolean']['input']>;
  layoutHeader?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  products?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreateOrderPayload = MutationResponse & {
  campaign?: Maybe<CampaignBaseData>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataCreativeExternal = {
  adPlacementCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Get current creative revision by stage */
  currentRevision?: Maybe<CampaignBaseDataCreativeExternalRevision>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revisions?: Maybe<Array<Maybe<CampaignBaseDataCreativeExternalRevision>>>;
  status?: Maybe<CreativeExternalStatus>;
  targetDeviceCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type CampaignBaseDataCreativeExternalCurrentRevisionArgs = {
  stage: CampaignBaseDataCreativeRevisionStageEnum;
};

export type CampaignBaseDataCreativeExternalAddRevisionFromHashInput = {
  brandSafetyTracking?: InputMaybe<Scalars['String']['input']>;
  clickTracking: Scalars['String']['input'];
  hash: Scalars['String']['input'];
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
  viewTracking?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataCreativeExternalAddRevisionFromHashPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creativeExternal?: Maybe<CampaignBaseDataCreativeExternal>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataCreativeExternalCreateFromHashDaypartsInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  weekday: Scalars['String']['input'];
};

export type CampaignBaseDataCreativeExternalCreateFromHashInput = {
  /** Also known as adslot */
  adGapId?: InputMaybe<Scalars['String']['input']>;
  adPlacementCode: Scalars['String']['input'];
  brandSafetyTracking?: InputMaybe<Scalars['String']['input']>;
  /** This field is not supported in combination with redirectHtmlCode */
  clickTracking?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
  targetDeviceCode: Scalars['String']['input'];
  targeting?: InputMaybe<CampaignBaseDataCreativeExternalCreateWithOrderTargetingInput>;
  /** This field is not supported in combination with redirectHtmlCode */
  viewTracking?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignBaseDataCreativeExternalCreateFromHashPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<CampaignBaseDataCreativeExternal>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataCreativeExternalCreateWithOrderTargetingInput = {
  dayparts?: InputMaybe<Array<CampaignBaseDataCreativeExternalCreateFromHashDaypartsInput>>;
};

export type CampaignBaseDataCreativeExternalEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  /** node: Creative */
  node?: Maybe<CampaignBaseDataCreativeExternal>;
};

export type CampaignBaseDataCreativeExternalFilter = {
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CampaignBaseDataCreativeExternalMutation = {
  addRevisionFromHash?: Maybe<CampaignBaseDataCreativeExternalAddRevisionFromHashPayload>;
  createFromHash?: Maybe<CampaignBaseDataCreativeExternalCreateFromHashPayload>;
  remove?: Maybe<CampaignBaseDataCreativeExternalRemovePayload>;
  removeRevision?: Maybe<CampaignBaseDataRemoveCreativeExternalRevisionPayload>;
  update?: Maybe<CampaignBaseDataUpdateCreativeExternalPayload>;
  uploadTemp?: Maybe<CampaignBaseDataUploadCreativeExternalTempPayload>;
};


export type CampaignBaseDataCreativeExternalMutationAddRevisionFromHashArgs = {
  input: CampaignBaseDataCreativeExternalAddRevisionFromHashInput;
};


export type CampaignBaseDataCreativeExternalMutationCreateFromHashArgs = {
  input: CampaignBaseDataCreativeExternalCreateFromHashInput;
};


export type CampaignBaseDataCreativeExternalMutationRemoveRevisionArgs = {
  input: CampaignBaseDataRemoveCreativeExternalRevisionInput;
};


export type CampaignBaseDataCreativeExternalMutationUpdateArgs = {
  input: CampaignBaseDataUpdateCreativeExternalInput;
};


export type CampaignBaseDataCreativeExternalMutationUploadTempArgs = {
  adPlacementCode?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataCreativeExternalRemovePayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataCreativeExternalRevision = {
  adGapId?: Maybe<Scalars['String']['output']>;
  brandSafetyTracking?: Maybe<Scalars['String']['output']>;
  clickTracking?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  redirectHtmlCode?: Maybe<Scalars['String']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<CampaignBaseDataCreativeRevisionStageEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  viewTracking?: Maybe<Scalars['String']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignBaseDataCreativeInternal = {
  adGapId?: Maybe<Scalars['String']['output']>;
  additionalTracking?: Maybe<Scalars['String']['output']>;
  /** Adserver Werbemittel Id */
  adserverId?: Maybe<Scalars['String']['output']>;
  branches?: Maybe<CampaignBaseDataCreativesInternalBranchesConnection>;
  budget?: Maybe<Scalars['Float']['output']>;
  categories?: Maybe<CampaignBaseDataCreativesInternalCategoriesConnection>;
  componentFields?: Maybe<Scalars['Mixed']['output']>;
  componentInstances?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponentInstance>>>;
  components?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponent>>>;
  conditionsUrl?: Maybe<Scalars['String']['output']>;
  copiedFrom?: Maybe<Campaign>;
  country?: Maybe<Country>;
  cpe?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User_V2>;
  defaultFieldValues?: Maybe<Scalars['Mixed']['output']>;
  deployments?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalDeployment>>>;
  end: Scalars['DateTime']['output'];
  everyTrackingPixel?: Maybe<Scalars['String']['output']>;
  f11Id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Get assigned image */
  image?: Maybe<Media>;
  inShowroom: Scalars['Boolean']['output'];
  isBooked?: Maybe<Scalars['Boolean']['output']>;
  linkOutDefault?: Maybe<Scalars['String']['output']>;
  linkoutTrackingPixel?: Maybe<Scalars['String']['output']>;
  media?: Maybe<MediaEdges>;
  meta?: Maybe<Scalars['SequelizeJSON']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Order>;
  pathKalkuTool?: Maybe<Scalars['String']['output']>;
  playoutRange?: Maybe<CreativeInternalPlayoutRangeEnum>;
  playoutSchedule?: Maybe<CreativeInternalPlayoutScheduleEnum>;
  previewHash?: Maybe<Scalars['String']['output']>;
  previews?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
  productFamily?: Maybe<ProductFamily>;
  /** Get Product Parent List */
  productParents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  productVariant?: Maybe<ProductVariant>;
  products?: Maybe<CampaignBaseDataCreativesInternalProductsConnection>;
  revision?: Maybe<Scalars['Int']['output']>;
  searchNoResultsLink?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<CampaignBaseDataCreativesInternalStagesConnection>;
  start: Scalars['DateTime']['output'];
  status?: Maybe<CreativeInternalStatus>;
  theme?: Maybe<Scalars['SequelizeJSON']['output']>;
  themeJs?: Maybe<Scalars['String']['output']>;
  themeScss?: Maybe<Scalars['String']['output']>;
  uniqueTrackingPixel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<User_V2>;
  viewTracking?: Maybe<Scalars['String']['output']>;
  watchlaterSubject?: Maybe<Scalars['String']['output']>;
  watchlaterTemplate?: Maybe<Scalars['String']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  zipCount?: Maybe<Scalars['Int']['output']>;
};


export type CampaignBaseDataCreativeInternalBranchesArgs = {
  filter?: InputMaybe<CampaignBaseDataCreativeInternalBranchesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignBaseDataCreativeInternalCategoriesArgs = {
  filter?: InputMaybe<CampaignBaseDataCreativeInternalCategoriesFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignBaseDataCreativeInternalComponentInstancesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<ComponentSectionType>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBaseDataCreativeInternalComponentsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  section?: InputMaybe<ComponentSectionType>;
  tags?: InputMaybe<Array<InputMaybe<ComponentTagType>>>;
};


export type CampaignBaseDataCreativeInternalDeploymentsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBaseDataCreativeInternalMediaArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBaseDataCreativeInternalPreviewsArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type CampaignBaseDataCreativeInternalProductsArgs = {
  filter?: InputMaybe<CampaignBaseDataCreativeInternalProductsFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignBaseDataCreativeInternalStagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignBaseDataCreativeInternalBranchInput = {
  active: Scalars['Boolean']['input'];
  address: AddressInput;
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  hasOpeningHours: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imprintUrl?: InputMaybe<Scalars['String']['input']>;
  legalUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  mapMarker?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['Mixed']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataCreativeInternalBranchMutation = {
  remove?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalBranch>>>;
  upsert?: Maybe<CampaignBaseDataCreativesInternalBranch>;
};


export type CampaignBaseDataCreativeInternalBranchMutationRemoveArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalBranchMutationUpsertArgs = {
  input: CampaignBaseDataCreativeInternalBranchInput;
};

export type CampaignBaseDataCreativeInternalBranchesFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<NumberFilter>;
};

export type CampaignBaseDataCreativeInternalCategoriesFilter = {
  id?: InputMaybe<NumberFilter>;
};

export type CampaignBaseDataCreativeInternalCategoryInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  colorcode?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignBaseDataCreativeInternalCategoryMutation = {
  remove?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalCategory>>>;
  upsert?: Maybe<CampaignBaseDataCreativesInternalCategory>;
};


export type CampaignBaseDataCreativeInternalCategoryMutationRemoveArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalCategoryMutationUpsertArgs = {
  input: CampaignBaseDataCreativeInternalCategoryInput;
};

export type CampaignBaseDataCreativeInternalComponent = {
  active?: Maybe<Scalars['Boolean']['output']>;
  children?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponent>>>;
  component: CreativeInternalComponentComponent;
  id: Scalars['ID']['output'];
  stages?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponentInstance>>>;
};

export type CampaignBaseDataCreativeInternalComponentInstance = {
  children?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponentInstance>>>;
  column: Scalars['Int']['output'];
  component?: Maybe<Component>;
  /** Get assigned CreativeInternal Component */
  creativeInternalComponent: CampaignBaseDataCreativeInternalComponent;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Mixed']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['ID']['output']>;
  /** Get assigned Product */
  product?: Maybe<CampaignBaseDataCreativesInternalProduct>;
  section?: Maybe<ComponentSectionType>;
  sorting: Scalars['Int']['output'];
  /** Get assigned Stage */
  stage?: Maybe<CampaignBaseDataCreativesInternalStage>;
  start?: Maybe<Scalars['Date']['output']>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceMetaArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  def?: InputMaybe<Scalars['Boolean']['input']>;
  merge?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceProductArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceStageArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativeInternalComponentInstanceCopyInput = {
  column: Scalars['Int']['input'];
  componentInstanceId: Scalars['ID']['input'];
  stageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CampaignBaseDataCreativeInternalComponentInstanceInput = {
  column: Scalars['Int']['input'];
  creativeInternalComponent: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['Date']['input']>;
  meta?: InputMaybe<Scalars['Mixed']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<CampaignProductInput>;
  section?: InputMaybe<ComponentSectionType>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignBaseDataCreativeInternalComponentInstanceMutation = {
  copy: Array<CampaignComponentInstance>;
  remove?: Maybe<CampaignComponentInstance>;
  upsert?: Maybe<CampaignBaseDataCreativeInternalComponentInstance>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceMutationCopyArgs = {
  input: Array<CampaignBaseDataCreativeInternalComponentInstanceCopyInput>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceMutationRemoveArgs = {
  input?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignBaseDataCreativeInternalComponentInstanceMutationUpsertArgs = {
  input: CampaignBaseDataCreativeInternalComponentInstanceInput;
  updateSorting?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativeInternalComponentMutation = {
  add?: Maybe<AddCampaignComponentPayload>;
  update?: Maybe<CampaignBaseDataCreativeInternalComponent>;
};


export type CampaignBaseDataCreativeInternalComponentMutationUpdateArgs = {
  input?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativeInternalCopyInput = {
  branches?: InputMaybe<Scalars['Boolean']['input']>;
  componentInstanceSection?: InputMaybe<ComponentSectionType>;
  customCSS?: InputMaybe<Scalars['Boolean']['input']>;
  layoutContent?: InputMaybe<Scalars['Boolean']['input']>;
  layoutFooter?: InputMaybe<Scalars['Boolean']['input']>;
  layoutHeader?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['Boolean']['input']>;
  products?: InputMaybe<Scalars['Boolean']['input']>;
  render?: InputMaybe<Scalars['Boolean']['input']>;
  runtime?: InputMaybe<Scalars['Boolean']['input']>;
  theme?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativeInternalDeactivateResult = {
  id?: Maybe<Scalars['Int']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type CampaignBaseDataCreativeInternalDeployment = {
  account?: Maybe<Scalars['String']['output']>;
  assetManifest?: Maybe<Scalars['SequelizeJSON']['output']>;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User_V2>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['SequelizeJSON']['output']>;
  preview?: Maybe<CampaignBaseDataCreativeInternalPreview>;
  progress?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<CreativeInternalDeploymentStage>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<CreativeInternalDeploymentState>;
  updatedBy?: Maybe<User_V2>;
};

export type CampaignBaseDataCreativeInternalDeploymentMigratorOptionsInput = {
  queue?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentRenderingQueue>;
};

export type CampaignBaseDataCreativeInternalDeploymentMutation = {
  production?: Maybe<CampaignBaseDataCreativeInternalDeploymentMutationResult>;
  upsert?: Maybe<CampaignBaseDataCreativeInternalDeploymentMutationResult>;
};


export type CampaignBaseDataCreativeInternalDeploymentMutationProductionArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentProductionInput>;
};


export type CampaignBaseDataCreativeInternalDeploymentMutationUpsertArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentUpsertInput>;
};

export type CampaignBaseDataCreativeInternalDeploymentMutationResult = {
  account?: Maybe<Scalars['String']['output']>;
  assetManifest?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** Get assigned Campaign */
  campaign: Campaign;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User_V2>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  preview?: Maybe<CampaignPreview>;
  progress?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<CampaignDeploymentStage>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<CampaignDeploymentState>;
  updatedBy?: Maybe<User_V2>;
};

export type CampaignBaseDataCreativeInternalDeploymentProductionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  revision: Scalars['ID']['input'];
};

export enum CampaignBaseDataCreativeInternalDeploymentRenderingQueue {
  Default = 'DEFAULT',
  Reserved = 'RESERVED'
}

export enum CampaignBaseDataCreativeInternalDeploymentStage {
  Preview = 'PREVIEW',
  Production = 'PRODUCTION'
}

export enum CampaignBaseDataCreativeInternalDeploymentState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type CampaignBaseDataCreativeInternalDeploymentUpsertInput = {
  assetManifest?: InputMaybe<Scalars['Mixed']['input']>;
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  disableCompression?: InputMaybe<Scalars['Boolean']['input']>;
  disableResize?: InputMaybe<Scalars['Boolean']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  info?: InputMaybe<Scalars['Mixed']['input']>;
  migratorOptions?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentMigratorOptionsInput>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentStage>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<CampaignBaseDataCreativeInternalDeploymentState>;
};

export type CampaignBaseDataCreativeInternalMediaMutation = {
  remove?: Maybe<Array<Maybe<Media>>>;
  removeAll?: Maybe<Scalars['Boolean']['output']>;
};


export type CampaignBaseDataCreativeInternalMediaMutationRemoveArgs = {
  input: Array<Scalars['ID']['input']>;
};

export type CampaignBaseDataCreativeInternalMutation = {
  branch?: Maybe<CampaignBaseDataCreativeInternalBranchMutation>;
  category?: Maybe<CampaignBaseDataCreativeInternalCategoryMutation>;
  component?: Maybe<CampaignBaseDataCreativeInternalComponentMutation>;
  componentInstance?: Maybe<CampaignBaseDataCreativeInternalComponentInstanceMutation>;
  copy?: Maybe<CampaignBaseDataCreativeInternal>;
  deactivate?: Maybe<CampaignBaseDataCreativeInternalDeactivateResult>;
  deployment?: Maybe<CampaignBaseDataCreativeInternalDeploymentMutation>;
  media?: Maybe<CampaignBaseDataCreativeInternalMediaMutation>;
  product?: Maybe<CampaignBaseDataCreativeInternalProductMutation>;
  remove?: Maybe<CampaignBaseDataCreativeInternal>;
  stage?: Maybe<CampaignBaseDataCreativeInternalStageMutation>;
  upsert?: Maybe<CampaignBaseDataCreativeInternal>;
};


export type CampaignBaseDataCreativeInternalMutationBranchArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationComponentArgs = {
  id: Scalars['ID']['input'];
};


export type CampaignBaseDataCreativeInternalMutationComponentInstanceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationCopyArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalCopyInput>;
};


export type CampaignBaseDataCreativeInternalMutationDeploymentArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationMediaArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationStageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalMutationUpsertArgs = {
  input: CampaignBaseDataCreativeInternalUpsertInput;
};

export type CampaignBaseDataCreativeInternalPreview = {
  adPlacementTypes?: Maybe<Array<Maybe<CreativeInternalPreviewAdPlacementType>>>;
  bundleHash?: Maybe<Scalars['String']['output']>;
  campaignBaseData?: Maybe<CampaignBaseData>;
  clientServiceContact?: Maybe<User_V2>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User_V2>;
  creativeInternal?: Maybe<CampaignBaseDataCreativeInternal>;
  /** Get assigned deployment */
  deployment?: Maybe<CampaignBaseDataCreativeInternalDeployment>;
  features?: Maybe<Scalars['SequelizeJSON']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  previewSites?: Maybe<Array<PreviewSite>>;
  theme?: Maybe<Scalars['CampaignPreviewTheme']['output']>;
};

export type CampaignBaseDataCreativeInternalPreviewInput = {
  adPlacementTypes?: InputMaybe<Array<Scalars['ID']['input']>>;
  clientServiceContact?: InputMaybe<Scalars['ID']['input']>;
  creativeInternal: Scalars['ID']['input'];
  deployment: Scalars['ID']['input'];
  features?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  preview?: InputMaybe<Scalars['ID']['input']>;
  previewSites: Array<InputMaybe<Scalars['ID']['input']>>;
  theme?: InputMaybe<Scalars['CampaignPreviewTheme']['input']>;
};

export type CampaignBaseDataCreativeInternalPreviewMutation = {
  remove?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
  upsert?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
};


export type CampaignBaseDataCreativeInternalPreviewMutationRemoveArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};


export type CampaignBaseDataCreativeInternalPreviewMutationUpsertArgs = {
  bundleHash?: InputMaybe<Scalars['String']['input']>;
  input: Array<CampaignBaseDataCreativeInternalPreviewInput>;
};

export type CampaignBaseDataCreativeInternalProductInput = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataCreativeInternalProductMutation = {
  remove?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalProduct>>>;
  removeAll?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalProduct>>>;
  upsert?: Maybe<CampaignBaseDataCreativesInternalProduct>;
};


export type CampaignBaseDataCreativeInternalProductMutationRemoveArgs = {
  input: Array<Scalars['ID']['input']>;
};


export type CampaignBaseDataCreativeInternalProductMutationUpsertArgs = {
  input: CampaignBaseDataCreativeInternalProductInput;
};

export type CampaignBaseDataCreativeInternalProductsFilter = {
  branch?: InputMaybe<NumberFilter>;
  id?: InputMaybe<NumberFilter>;
};

export type CampaignBaseDataCreativeInternalStageCopyInput = {
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignBaseDataCreativeInternalStageInput = {
  campaignComponentInstances?: InputMaybe<Array<InputMaybe<CampaignBaseDataCreativeInternalComponentInstanceInput>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  grid?: InputMaybe<Scalars['ID']['input']>;
  gridCode?: InputMaybe<Scalars['String']['input']>;
  linkOutDefault?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['Boolean']['input']>;
  previewImage?: InputMaybe<Scalars['ID']['input']>;
  /** order of stages */
  sorting?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataCreativeInternalStageMutation = {
  copy?: Maybe<CampaignBaseDataCreativesInternalStage>;
  remove?: Maybe<CampaignBaseDataCreativesInternalStage>;
  removeComponents: Scalars['Int']['output'];
  upsert?: Maybe<CampaignBaseDataCreativesInternalStage>;
};


export type CampaignBaseDataCreativeInternalStageMutationCopyArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalStageCopyInput>;
};


export type CampaignBaseDataCreativeInternalStageMutationRemoveComponentsArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalStageRemoveComponentsInput>;
};


export type CampaignBaseDataCreativeInternalStageMutationUpsertArgs = {
  input?: InputMaybe<CampaignBaseDataCreativeInternalStageInput>;
};

export type CampaignBaseDataCreativeInternalStageRemoveComponentsInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  column?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignBaseDataCreativeInternalUpsertInput = {
  account?: InputMaybe<Scalars['ID']['input']>;
  adGapId?: InputMaybe<Scalars['String']['input']>;
  additionalTracking?: InputMaybe<Scalars['String']['input']>;
  adserverId?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  blacklist?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['Int']['input']>;
  clientServiceContact?: InputMaybe<Scalars['ID']['input']>;
  clientServiceContactExternal?: InputMaybe<Scalars['ID']['input']>;
  conditionsUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  cpe?: InputMaybe<Scalars['String']['input']>;
  creative?: InputMaybe<Scalars['ID']['input']>;
  customer?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  everyTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  f11Id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  inShowroom?: InputMaybe<Scalars['Boolean']['input']>;
  linkOutDefault?: InputMaybe<Scalars['String']['input']>;
  linkoutTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  multi?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pathKalkuTool?: InputMaybe<Scalars['String']['input']>;
  playoutRange?: InputMaybe<CampaignPlayoutRangeEnum>;
  playoutSchedule?: InputMaybe<CampaignPlayoutScheduleEnum>;
  productFamily?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<Scalars['ID']['input']>;
  productVariant?: InputMaybe<Scalars['ID']['input']>;
  searchNoResultsLink?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CampaignStatus>;
  targeting?: InputMaybe<CreateWithOrderTargetingInput>;
  theme?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  themeJs?: InputMaybe<Scalars['String']['input']>;
  themeScss?: InputMaybe<Scalars['String']['input']>;
  uniqueTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  viewTracking?: InputMaybe<Scalars['String']['input']>;
  watchlaterSubject?: InputMaybe<Scalars['String']['input']>;
  watchlaterTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  whitelist?: InputMaybe<Scalars['String']['input']>;
};

export enum CampaignBaseDataCreativeRevisionStageEnum {
  Preview = 'PREVIEW',
  Production = 'PRODUCTION'
}

export type CampaignBaseDataCreativesExternalConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativeExternalEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalBranch = {
  active: Scalars['Boolean']['output'];
  /** Get assigned Address */
  address?: Maybe<Address>;
  /** Get assigned CreativeInternal */
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  hasOpeningHours: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Get assigned image */
  image?: Maybe<Media>;
  imprintUrl?: Maybe<Scalars['String']['output']>;
  legalUrl?: Maybe<Scalars['String']['output']>;
  /** Get assigned logo */
  logo?: Maybe<Media>;
  mapMarker?: Maybe<Media>;
  meta?: Maybe<Scalars['Mixed']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  privacyUrl?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignBaseDataCreativesInternalBranchesConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalBranchesEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalBranchesEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataCreativesInternalBranch>;
};

export type CampaignBaseDataCreativesInternalCategoriesConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalCategoriesEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalCategoriesEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataCreativesInternalCategory>;
};

export type CampaignBaseDataCreativesInternalCategory = {
  alias?: Maybe<Scalars['String']['output']>;
  colorcode?: Maybe<Scalars['String']['output']>;
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalProduct>>>;
  sorting?: Maybe<Scalars['Int']['output']>;
  stages?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalStage>>>;
};


export type CampaignBaseDataCreativesInternalCategoryStagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignBaseDataCreativesInternalConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataCreativeInternal>;
};

export type CampaignBaseDataCreativesInternalProduct = {
  branch?: Maybe<Scalars['ID']['output']>;
  /** This field was added for backward compatibility and will be substituted by branch when the refresh ui will be merged to all the tenants */
  branchData?: Maybe<CampaignBaseDataCreativesInternalBranch>;
  /** Get assigned Category */
  category?: Maybe<CampaignCategory>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use used instead. */
  isUsed?: Maybe<MediaIsUsedEdges>;
  meta?: Maybe<Scalars['Mixed']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  used?: Maybe<Scalars['Boolean']['output']>;
};


export type CampaignBaseDataCreativesInternalProductMetaArgs = {
  def?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativesInternalProductsConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalProductsEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalProductsEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataCreativesInternalProduct>;
};

export type CampaignBaseDataCreativesInternalStage = {
  /** Get assigned Product Category */
  category?: Maybe<CampaignBaseDataCreativesInternalCategory>;
  /** Get assigned Campaign Component Instances */
  componentInstances?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalComponentInstance>>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  /** Get assigned Grid */
  grid: Grid;
  id: Scalars['ID']['output'];
  linkOutDefault?: Maybe<Scalars['String']['output']>;
  meta: Scalars['SequelizeJSON']['output'];
  name: Scalars['String']['output'];
  payout?: Maybe<Scalars['Boolean']['output']>;
  /** Get assigned image */
  previewImage?: Maybe<Media>;
  sorting: Scalars['Int']['output'];
  start?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type CampaignBaseDataCreativesInternalStageComponentInstancesArgs = {
  flatChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataCreativesInternalStagesConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataCreativesInternalStagesEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataCreativesInternalStagesEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataCreativesInternalStage>;
};

export type CampaignBaseDataInput = {
  account?: InputMaybe<Scalars['ID']['input']>;
  adserverId?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  blacklist?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['Int']['input']>;
  clientServiceContact?: InputMaybe<Scalars['ID']['input']>;
  clientServiceContactExternal?: InputMaybe<Scalars['ID']['input']>;
  conditionsUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  f11Id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  inShowroom?: InputMaybe<Scalars['Boolean']['input']>;
  linkOutDefault?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pathKalkuTool?: InputMaybe<Scalars['String']['input']>;
  playoutRange?: InputMaybe<CampaignPlayoutRangeEnum>;
  playoutSchedule?: InputMaybe<CampaignPlayoutScheduleEnum>;
  productFamily?: InputMaybe<Scalars['ID']['input']>;
  productType?: InputMaybe<Scalars['ID']['input']>;
  productVariant?: InputMaybe<Scalars['ID']['input']>;
  searchNoResultsLink?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CampaignStatus>;
  targeting?: InputMaybe<CreateWithOrderTargetingInput>;
  theme?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  themeJs?: InputMaybe<Scalars['String']['input']>;
  themeScss?: InputMaybe<Scalars['String']['input']>;
  uniqueTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  watchlaterSubject?: InputMaybe<Scalars['String']['input']>;
  watchlaterTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  whitelist?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataMutation = {
  addCreativesExternal?: Maybe<CampaignBaseDataAddCreativesExternalPayload>;
  bookmark?: Maybe<CampaignBaseDataBookmarkPayload>;
  copy?: Maybe<CampaignBaseData>;
  createWithOrder?: Maybe<CampaignBaseDataCreateOrderPayload>;
  creativeExternal?: Maybe<CampaignBaseDataCreativeExternalMutation>;
  creativeInternal?: Maybe<CampaignBaseDataCreativeInternalMutation>;
  preview?: Maybe<CampaignBaseDataCreativeInternalPreviewMutation>;
  remove?: Maybe<CampaignBaseData>;
  upsert?: Maybe<CampaignBaseData>;
};


export type CampaignBaseDataMutationAddCreativesExternalArgs = {
  input: CampaignBaseDataAddCreativesExternalInput;
};


export type CampaignBaseDataMutationBookmarkArgs = {
  input: CampaignBaseDataBookmarkInput;
};


export type CampaignBaseDataMutationCopyArgs = {
  input: CampaignBaseDataCopyInput;
};


export type CampaignBaseDataMutationCreateWithOrderArgs = {
  input: CampaignBaseDataOrderInput;
};


export type CampaignBaseDataMutationCreativeExternalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataMutationCreativeInternalArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type CampaignBaseDataMutationUpsertArgs = {
  input: CampaignBaseDataInput;
};

export type CampaignBaseDataOrderInput = {
  ais: Scalars['Long']['input'];
  campaignBaseData: CampaignBaseDataInput;
  channel?: InputMaybe<ChannelInput>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  creativeFromHash?: InputMaybe<Array<CreateCreativeFromHashInput>>;
  productCode: Scalars['String']['input'];
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignBaseDataPreviewBundle = {
  bundleHash?: Maybe<Scalars['String']['output']>;
  previews?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
};

export type CampaignBaseDataProduct = {
  branch?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Mixed']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
};


export type CampaignBaseDataProductMetaArgs = {
  def?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignBaseDataProductConnection = {
  edges?: Maybe<Array<Maybe<CampaignBaseDataProductEdges>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignBaseDataProductEdges = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseDataProduct>;
};

export type CampaignBaseDataProductFilter = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBaseDataRemoveCreativeExternalRevisionInput = {
  id: Scalars['ID']['input'];
};

export type CampaignBaseDataRemoveCreativeExternalRevisionPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creativesExternal?: Maybe<Array<Maybe<CampaignBaseDataCreativeExternal>>>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataReporting = {
  billingTypeCode?: Maybe<Scalars['String']['output']>;
  bookedKpi?: Maybe<Scalars['Int']['output']>;
  costPerKpiUnit?: Maybe<Scalars['Float']['output']>;
  deliveredKpi?: Maybe<Scalars['Int']['output']>;
  fulfillmentRate?: Maybe<Scalars['Float']['output']>;
  guaranteesStatus?: Maybe<Array<Maybe<GuaranteeFulfillment>>>;
  kpiCode?: Maybe<Scalars['String']['output']>;
  kpiName?: Maybe<Scalars['String']['output']>;
  spentBudget?: Maybe<Scalars['Float']['output']>;
  spentBudgetPerDay?: Maybe<Scalars['Float']['output']>;
  totalBudget?: Maybe<Scalars['Float']['output']>;
};

export type CampaignBaseDataUpdateCreativeExternalInput = {
  name: Scalars['String']['input'];
};

export type CampaignBaseDataUpdateCreativeExternalPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creativesExternal?: Maybe<CampaignBaseDataCreativeExternal>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataUploadCreativeExternalTempPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creativeExternal?: Maybe<CampaignBaseDataUploadCreativeTempCreativeExternal>;
  /** creativesExternal field returns all creatives uploaded - currently UI only supports 1 creative in creativeExternal field */
  creativesExternal?: Maybe<Array<Maybe<CampaignBaseDataUploadCreativeTempCreativeExternal>>>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CampaignBaseDataUploadCreativeTempCreativeExternal = {
  adHeight?: Maybe<Scalars['Float']['output']>;
  adSlot?: Maybe<Scalars['String']['output']>;
  adWidth?: Maybe<Scalars['Float']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignBranch = {
  active: Scalars['Boolean']['output'];
  /** Get assigned Address */
  address?: Maybe<Address>;
  /** Get assigned Campaign */
  campaign: Campaign;
  /** @deprecated no value */
  contacts?: Maybe<Array<Maybe<Contact>>>;
  /** Get deleted at */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  hasOpeningHours: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Get assigned image */
  image?: Maybe<Media>;
  imprintUrl?: Maybe<Scalars['String']['output']>;
  legalUrl?: Maybe<Scalars['String']['output']>;
  /** Get assigned logo */
  logo?: Maybe<Media>;
  mapMarker?: Maybe<Media>;
  meta?: Maybe<Scalars['Mixed']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  privacyUrl?: Maybe<Scalars['String']['output']>;
  /**
   * Get number of modified products
   * @deprecated Should be queried in connection
   */
  productCount?: Maybe<Scalars['Int']['output']>;
  reference: Scalars['String']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};

export type CampaignBranchEdges = {
  edges?: Maybe<Array<Maybe<CampaignBranchNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CampaignBranchInput = {
  active: Scalars['Boolean']['input'];
  address: AddressInput;
  campaign: Scalars['ID']['input'];
  contacts?: InputMaybe<Array<InputMaybe<ContactInput>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  hasOpeningHours: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  imprintUrl?: InputMaybe<Scalars['String']['input']>;
  legalUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['ID']['input']>;
  mapMarker?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['Mixed']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignBranchNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<CampaignBranch>;
};

export type CampaignCategory = {
  alias?: Maybe<Scalars['String']['output']>;
  /** @deprecated Is not needed anymore */
  campaign?: Maybe<Scalars['ID']['output']>;
  colorcode?: Maybe<Scalars['String']['output']>;
  display: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  products?: Maybe<Array<Maybe<CampaignProduct>>>;
  sorting?: Maybe<Scalars['Int']['output']>;
  stages?: Maybe<Array<Maybe<CampaignStage>>>;
};


export type CampaignCategoryStagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type CampaignCategoryInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  colorcode?: InputMaybe<Scalars['String']['input']>;
  display?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type CampaignComponent = {
  active?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Get assigned Campaign
   * @deprecated Use campaign-query instead.
   */
  campaign: Campaign;
  /** Get CampaignComponent children, default is empty Array */
  children?: Maybe<Array<Maybe<CampaignComponent>>>;
  /** Get assigned Component */
  component: Component;
  /** Get assigned Component-Set */
  componentSet?: Maybe<ComponentSet>;
  id: Scalars['ID']['output'];
  /** Get assigned Stages */
  stages?: Maybe<Array<Maybe<CampaignComponentInstance>>>;
};

export type CampaignComponentInstance = {
  /** Get assigned Campaign Component */
  campaignComponent: CampaignComponent;
  children?: Maybe<Array<Maybe<CampaignComponentInstance>>>;
  column: Scalars['Int']['output'];
  component?: Maybe<Component>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  meta?: Maybe<Scalars['Mixed']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parent?: Maybe<Scalars['ID']['output']>;
  /** Get assigned Product */
  product?: Maybe<CampaignProduct>;
  section?: Maybe<ComponentSectionType>;
  sorting: Scalars['Int']['output'];
  /** Get assigned Stage */
  stage?: Maybe<CampaignStage>;
  start?: Maybe<Scalars['Date']['output']>;
};


export type CampaignComponentInstanceMetaArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  def?: InputMaybe<Scalars['Boolean']['input']>;
  merge?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignComponentInstanceProductArgs = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignComponentInstanceStageArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignComponentInstanceInput = {
  campaignComponent: Scalars['ID']['input'];
  column: Scalars['Int']['input'];
  end?: InputMaybe<Scalars['Date']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['Mixed']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['ID']['input']>;
  product?: InputMaybe<CampaignProductInput>;
  section?: InputMaybe<ComponentSectionType>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<Scalars['ID']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
};

export type CampaignDeployment = {
  account?: Maybe<Scalars['String']['output']>;
  assetManifest?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** Get assigned Campaign */
  campaign: Campaign;
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  createdBy?: Maybe<User_V2>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  info?: Maybe<Scalars['SequelizeJSON']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['Int']['output']>;
  stage?: Maybe<CampaignDeploymentStage>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  state?: Maybe<CampaignDeploymentState>;
  updatedBy?: Maybe<User_V2>;
};

export type CampaignDeploymentInput = {
  assetManifest?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  campaign: Scalars['ID']['input'];
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  info?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<CampaignDeploymentStage>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<CampaignDeploymentState>;
};

export enum CampaignDeploymentStage {
  Preview = 'PREVIEW',
  Production = 'PRODUCTION'
}

export enum CampaignDeploymentState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type CampaignEdges = {
  edges?: Maybe<Array<Maybe<CampaignNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CampaignInput = {
  account?: InputMaybe<Scalars['ID']['input']>;
  adserverId?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  blacklist?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  budget?: InputMaybe<Scalars['Float']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['Int']['input']>;
  clientServiceContact?: InputMaybe<Scalars['ID']['input']>;
  clientServiceContactExternal?: InputMaybe<Scalars['ID']['input']>;
  conditionsUrl?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  cpe?: InputMaybe<Scalars['String']['input']>;
  creative?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  everyTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  f11Id?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  inShowroom?: InputMaybe<Scalars['Boolean']['input']>;
  linkOutDefault?: InputMaybe<Scalars['String']['input']>;
  linkoutTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  multi?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  pathKalkuTool?: InputMaybe<Scalars['String']['input']>;
  playoutRange?: InputMaybe<CampaignPlayoutRangeEnum>;
  playoutSchedule?: InputMaybe<CampaignPlayoutScheduleEnum>;
  productFamily?: InputMaybe<Scalars['ID']['input']>;
  productVariant?: InputMaybe<Scalars['ID']['input']>;
  searchNoResultsLink?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<CampaignStatus>;
  theme?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  themeJs?: InputMaybe<Scalars['String']['input']>;
  themeScss?: InputMaybe<Scalars['String']['input']>;
  uniqueTrackingPixel?: InputMaybe<Scalars['String']['input']>;
  watchlaterSubject?: InputMaybe<Scalars['String']['input']>;
  watchlaterTemplate?: InputMaybe<Scalars['String']['input']>;
  /** Only whitelist or blacklist allowed */
  whitelist?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Campaign>;
};

export enum CampaignPlayoutRangeEnum {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export enum CampaignPlayoutScheduleEnum {
  Consistent = 'CONSISTENT',
  Fastest = 'FASTEST',
  Optimized = 'OPTIMIZED'
}

export type CampaignPreview = {
  adPlacementTypes?: Maybe<Array<Maybe<CampaignPreviewAdPlacementType>>>;
  campaign?: Maybe<Campaign>;
  clientServiceContact?: Maybe<User>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  createdBy?: Maybe<User>;
  /** Get assigned deployment */
  deployment?: Maybe<CampaignDeployment>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  path?: Maybe<Scalars['String']['output']>;
  previewSites?: Maybe<Array<PreviewSite>>;
  theme?: Maybe<Scalars['CampaignPreviewTheme']['output']>;
};

export type CampaignPreviewAdPlacementType = {
  code?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetDevice?: Maybe<TargetDevice>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type CampaignProduct = {
  branch?: Maybe<Scalars['ID']['output']>;
  campaign?: Maybe<Scalars['ID']['output']>;
  /** Get assigned Category */
  category?: Maybe<CampaignCategory>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated Use used instead. */
  isUsed?: Maybe<MediaIsUsedEdges>;
  meta?: Maybe<Scalars['Mixed']['output']>;
  name: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  used?: Maybe<Scalars['Boolean']['output']>;
};


export type CampaignProductMetaArgs = {
  def?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignProductEdges = {
  edges?: Maybe<Array<Maybe<CampaignProductNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CampaignProductInput = {
  branch?: InputMaybe<Scalars['ID']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignProductNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<CampaignProduct>;
};

export enum CampaignReportState {
  Archive = 'ARCHIVE',
  Default = 'DEFAULT',
  Pending = 'PENDING'
}

export type CampaignReporting = {
  count?: Maybe<Scalars['Int']['output']>;
};

export type CampaignStage = {
  /** Get assigned Product Category */
  category?: Maybe<CampaignCategory>;
  /** Get assigned Campaign Component Instances */
  componentInstances?: Maybe<Array<Maybe<CampaignComponentInstance>>>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  end?: Maybe<Scalars['Date']['output']>;
  /** Get assigned Grid */
  grid: Grid;
  id: Scalars['ID']['output'];
  linkOutDefault?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Scalars['SequelizeJSON']['output']>;
  name: Scalars['String']['output'];
  payout?: Maybe<Scalars['Boolean']['output']>;
  /** Get assigned image */
  previewImage?: Maybe<Media>;
  sorting: Scalars['Int']['output'];
  start?: Maybe<Scalars['Date']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};


export type CampaignStageCategoryArgs = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CampaignStageComponentInstancesArgs = {
  flatChildren?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CampaignStageEdges = {
  edges?: Maybe<Array<Maybe<CampaignStageNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CampaignStageInput = {
  campaignComponentInstances?: InputMaybe<Array<InputMaybe<CampaignComponentInstanceInput>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  end?: InputMaybe<Scalars['Date']['input']>;
  grid?: InputMaybe<Scalars['ID']['input']>;
  linkOutDefault?: InputMaybe<Scalars['String']['input']>;
  meta?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  payout?: InputMaybe<Scalars['Boolean']['input']>;
  previewImage?: InputMaybe<Scalars['ID']['input']>;
  /** order of stages */
  sorting?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Date']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CampaignStageNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<CampaignStage>;
};

export enum CampaignStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT'
}

export type CampaignsBaseDataConnection = {
  edges?: Maybe<Array<Maybe<CampaignsBaseDataEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CampaignsBaseDataEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<CampaignBaseData>;
};

export type CampaignsBaseDataFilter = {
  isBookmarked?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Channel = {
  calculationByTargetDeviceGroup?: Maybe<ChannelCalculationByTargetDeviceGroup>;
  calculations?: Maybe<Array<Maybe<ChannelCalculation>>>;
  channelId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publisherWebsites?: Maybe<Array<Maybe<PublisherWebsite>>>;
};

export type ChannelCalculation = {
  calculation?: Maybe<Scalars['String']['output']>;
  channel?: Maybe<Scalars['ID']['output']>;
  targetDeviceGroup?: Maybe<TargetDeviceGroupCode>;
};

export type ChannelCalculationByTargetDeviceGroup = {
  DESKTOP?: Maybe<Scalars['String']['output']>;
  DOOH?: Maybe<Scalars['String']['output']>;
  MOBILE?: Maybe<Scalars['String']['output']>;
  MULTI?: Maybe<Scalars['String']['output']>;
};

export type ChannelCalculationInput = {
  calculation: Scalars['String']['input'];
  targetDeviceGroup: Scalars['String']['input'];
};

export type ChannelCalculationMutation = {
  setup: Array<ChannelCalculation>;
};


export type ChannelCalculationMutationSetupArgs = {
  data: Array<SetupChannelCalculationInput>;
};

export type ChannelConnection = {
  edges?: Maybe<Array<Maybe<ChannelEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ChannelEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Channel>;
};

export type ChannelFilter = {
  OR?: InputMaybe<Array<ChannelFilter>>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ChannelInput = {
  calculations?: InputMaybe<Array<ChannelCalculationInput>>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type ChannelMutation = {
  create: Channel;
  remove: Scalars['Boolean']['output'];
  update: Channel;
};


export type ChannelMutationCreateArgs = {
  data: CreateChannelInput;
};


export type ChannelMutationRemoveArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type ChannelMutationUpdateArgs = {
  data: UpdateChannelInput;
};

export type ChannelWebsite = {
  channel?: Maybe<Scalars['ID']['output']>;
  website?: Maybe<Scalars['ID']['output']>;
};

export type ChannelWebsiteInput = {
  channel: Scalars['ID']['input'];
  website: Scalars['ID']['input'];
};

export type ChannelWebsiteMutation = {
  add: Array<ChannelWebsite>;
  remove: Scalars['Boolean']['output'];
};


export type ChannelWebsiteMutationAddArgs = {
  data: Array<ChannelWebsiteInput>;
};


export type ChannelWebsiteMutationRemoveArgs = {
  data: Array<ChannelWebsiteInput>;
};

export type ChannelWithoutCalculation = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export enum CollisionHandlingUpload {
  Copy = 'COPY',
  None = 'NONE',
  Replace = 'REPLACE'
}

export type Component = {
  active: Scalars['Boolean']['output'];
  allowedGrids?: Maybe<Array<Maybe<Grid>>>;
  /** Get assigned Category */
  category?: Maybe<ComponentCategory>;
  /** Get Component Children, default is empty Array */
  children?: Maybe<Array<Maybe<Component>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get Fields of Component */
  fields?: Maybe<Array<Maybe<ComponentField>>>;
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  /** Get Component Parent, default is empty Array */
  parent?: Maybe<Array<Maybe<Component>>>;
  /** This is Alias Key in Reports */
  reportKey?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Array<Scalars['String']['output']>>;
  section: ComponentSectionType;
  sorting?: Maybe<Scalars['Int']['output']>;
  /** Get Component Tags from your query */
  tags?: Maybe<Array<Maybe<ComponentTag>>>;
  /** Get Component Tag relations */
  tagsAll?: Maybe<Array<Maybe<ComponentTag>>>;
};


export type ComponentFieldsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComponentBranchField = {
  code: Scalars['String']['output'];
  default?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  options?: Maybe<ComponentFieldOption>;
  required: Scalars['Boolean']['output'];
  sorting?: Maybe<Scalars['Int']['output']>;
  /** Get assigned Type */
  type?: Maybe<ComponentFieldType>;
};

export type ComponentCategory = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentField = {
  active: Scalars['Boolean']['output'];
  code: Scalars['String']['output'];
  default?: Maybe<Scalars['Mixed']['output']>;
  dependsOn?: Maybe<ComponentFieldDependsOn>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<ComponentFieldGroup>;
  id: Scalars['ID']['output'];
  options?: Maybe<ComponentFieldOption>;
  required: Scalars['Boolean']['output'];
  sorting?: Maybe<Scalars['Int']['output']>;
  /** Get assigned Type */
  type?: Maybe<ComponentFieldType>;
};

export type ComponentFieldDependsOn = {
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ComponentFieldGroup = {
  fieldSorting: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  sorting: Scalars['Int']['output'];
  width?: Maybe<Scalars['String']['output']>;
};

export type ComponentFieldOption = {
  max?: Maybe<Scalars['Mixed']['output']>;
  min?: Maybe<Scalars['Mixed']['output']>;
  step?: Maybe<Scalars['Mixed']['output']>;
  unitOfMeasure?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['Mixed']['output']>;
};

export type ComponentFieldType = {
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ComponentInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  /** This is Alias Key in Reports */
  reportKey?: InputMaybe<Scalars['String']['input']>;
  reportType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  section: ComponentSectionType;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export enum ComponentSectionType {
  Content = 'CONTENT',
  Footer = 'FOOTER',
  Header = 'HEADER',
  Social = 'SOCIAL'
}

export type ComponentSet = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
};

export type ComponentTag = {
  active: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: ComponentTagType;
  sorting: Scalars['Int']['output'];
};

export enum ComponentTagType {
  CompGroupGeneralI = 'COMP_GROUP_GENERAL_I',
  CompGroupGeneralIi = 'COMP_GROUP_GENERAL_II',
  CompGroupGeneralIii = 'COMP_GROUP_GENERAL_III',
  CompGroupGeneralIv = 'COMP_GROUP_GENERAL_IV',
  GeneralCampaignBuilder = 'GENERAL_CAMPAIGN_BUILDER',
  GeneralCampaignBuilderContainer = 'GENERAL_CAMPAIGN_BUILDER_CONTAINER',
  GeneralCampaignBuilderNoSub = 'GENERAL_CAMPAIGN_BUILDER_NO_SUB',
  GeneralCampaignBuilderSubOnly = 'GENERAL_CAMPAIGN_BUILDER_SUB_ONLY',
  GeneralCampaignInit = 'GENERAL_CAMPAIGN_INIT',
  GeneralConfigurable = 'GENERAL_CONFIGURABLE',
  GeneralImportBranch = 'GENERAL_IMPORT_BRANCH',
  GeneralImportProduct = 'GENERAL_IMPORT_PRODUCT',
  GeneralProduct = 'GENERAL_PRODUCT',
  ProductAa = 'PRODUCT_AA',
  ProductAa_2 = 'PRODUCT_AA_2',
  ProductAa_2Init = 'PRODUCT_AA_2_INIT',
  ProductAaInit = 'PRODUCT_AA_INIT',
  ProductBd = 'PRODUCT_BD',
  ProductBdInit = 'PRODUCT_BD_INIT',
  ProductBiva = 'PRODUCT_BIVA',
  ProductBivam = 'PRODUCT_BIVAM',
  ProductBivamInit = 'PRODUCT_BIVAM_INIT',
  ProductBivaInit = 'PRODUCT_BIVA_INIT',
  ProductBp = 'PRODUCT_BP',
  ProductBp_2 = 'PRODUCT_BP_2',
  ProductBp_2Init = 'PRODUCT_BP_2_INIT',
  ProductBpInit = 'PRODUCT_BP_INIT',
  ProductCea = 'PRODUCT_CEA',
  ProductCeax = 'PRODUCT_CEAX',
  ProductCeaxl = 'PRODUCT_CEAXL',
  ProductCeaxl_2 = 'PRODUCT_CEAXL_2',
  ProductCeaxl_2Init = 'PRODUCT_CEAXL_2_INIT',
  ProductCeaxlInit = 'PRODUCT_CEAXL_INIT',
  ProductCeaxInit = 'PRODUCT_CEAX_INIT',
  ProductCeaInit = 'PRODUCT_CEA_INIT',
  ProductDa_2 = 'PRODUCT_DA_2',
  ProductDa_2Init = 'PRODUCT_DA_2_INIT',
  ProductIma = 'PRODUCT_IMA',
  ProductImaInit = 'PRODUCT_IMA_INIT',
  ProductIp = 'PRODUCT_IP',
  ProductIpInit = 'PRODUCT_IP_INIT',
  ProductOv = 'PRODUCT_OV',
  ProductOvInit = 'PRODUCT_OV_INIT',
  ProductRa = 'PRODUCT_RA',
  ProductRaInit = 'PRODUCT_RA_INIT',
  ProductSa = 'PRODUCT_SA',
  ProductSa_2 = 'PRODUCT_SA_2',
  ProductSa_2Init = 'PRODUCT_SA_2_INIT',
  ProductSaInit = 'PRODUCT_SA_INIT',
  ProductSip = 'PRODUCT_SIP',
  ProductSipInit = 'PRODUCT_SIP_INIT',
  ProductSop = 'PRODUCT_SOP',
  ProductSopInit = 'PRODUCT_SOP_INIT',
  ProductSt = 'PRODUCT_ST',
  ProductStInit = 'PRODUCT_ST_INIT',
  ProductVa = 'PRODUCT_VA',
  ProductVaInit = 'PRODUCT_VA_INIT',
  ProductVideoIp = 'PRODUCT_VIDEO_IP',
  ProductVideoIpInit = 'PRODUCT_VIDEO_IP_INIT',
  ProductVideoOv = 'PRODUCT_VIDEO_OV',
  ProductVideoOvInit = 'PRODUCT_VIDEO_OV_INIT',
  ProductVv = 'PRODUCT_VV',
  ProductVvInit = 'PRODUCT_VV_INIT',
  ProductWbp = 'PRODUCT_WBP',
  ProductWbpInit = 'PRODUCT_WBP_INIT',
  SectionContent = 'SECTION_CONTENT',
  SectionFooter = 'SECTION_FOOTER',
  SectionHeader = 'SECTION_HEADER',
  SectionSocialMedia = 'SECTION_SOCIAL_MEDIA'
}

export type Contact = {
  accounts?: Maybe<AccountContactEdges>;
  active?: Maybe<Scalars['Boolean']['output']>;
  address?: Maybe<Address>;
  avatar?: Maybe<Media>;
  baseAccount?: Maybe<Account>;
  birthday?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<User_V2>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  /** @deprecated Use customer.avatar instead. */
  image?: Maybe<Image>;
  interests?: Maybe<Scalars['String']['output']>;
  intolerances?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInUrl?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  phoneHome?: Maybe<Scalars['String']['output']>;
  phoneMobile?: Maybe<Scalars['String']['output']>;
  phoneWork?: Maybe<Scalars['String']['output']>;
  shoeSize?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<User_V2>;
  user?: Maybe<User_V2>;
  xingUrl?: Maybe<Scalars['String']['output']>;
};


export type ContactAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type ContactAddressArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type ContactEdges = {
  edges?: Maybe<Array<Maybe<ContactNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type ContactInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['ID']['input']>;
  avatar?: InputMaybe<Scalars['ID']['input']>;
  baseAccount?: InputMaybe<Scalars['ID']['input']>;
  birthday?: InputMaybe<Scalars['String']['input']>;
  contactType?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender?: InputMaybe<Gender>;
  id?: InputMaybe<Scalars['ID']['input']>;
  interests?: InputMaybe<Scalars['String']['input']>;
  intolerances?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  linkedInUrl?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneHome?: InputMaybe<Scalars['String']['input']>;
  phoneMobile?: InputMaybe<Scalars['String']['input']>;
  phoneWork?: InputMaybe<Scalars['String']['input']>;
  shoeSize?: InputMaybe<Scalars['String']['input']>;
  upsertAddress?: InputMaybe<AddressInput>;
  user?: InputMaybe<Scalars['ID']['input']>;
  xingUrl?: InputMaybe<Scalars['String']['input']>;
};

export type ContactMutation = {
  remove?: Maybe<Contact>;
  upsert?: Maybe<UpsertContactPayload>;
};


export type ContactMutationUpsertArgs = {
  data: ContactInput;
};

export type ContactNode = {
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Contact>;
};

export type Coordinate = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CopyAccountPayload = MutationResponse & {
  account?: Maybe<Account>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CopyProductFamilyInput = {
  codes: Array<Scalars['ID']['input']>;
  targetReseller: Scalars['ID']['input'];
};

export type CopyProductInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['ID']['input']>;
  targetReseller: Scalars['ID']['input'];
};

export type CountriesGeoData = {
  centroid?: Maybe<Scalars['GeoJSON']['output']>;
  countryCode: Scalars['String']['output'];
  featureId?: Maybe<Scalars['BigInt']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  geometryBounds?: Maybe<Scalars['GeoJSON']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  property?: Maybe<Property>;
};

export type Country = {
  adserverUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  defaultTrackingPixel?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  optOutPixel?: Maybe<Scalars['String']['output']>;
  tax?: Maybe<Scalars['Float']['output']>;
};

export type CountryConnection = {
  edges?: Maybe<Array<Maybe<CountryEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type CountryEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Country>;
};

export type CountryFilter = {
  OR?: InputMaybe<Array<CountryFilter>>;
  adserverUrl?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type CreateChannelInput = {
  calculationByTargetDeviceGroup?: InputMaybe<CalculationByTargetDeviceGroupInput>;
  name: Scalars['String']['input'];
  websiteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type CreateCreativeFromHashInput = {
  adGapId?: InputMaybe<Scalars['String']['input']>;
  /** Also known as adslot */
  adPlacementCode: Scalars['String']['input'];
  brandSafetyTracking?: InputMaybe<Scalars['String']['input']>;
  /** This field is not supported in combination with redirectHtmlCode */
  clickTracking?: InputMaybe<Scalars['String']['input']>;
  hash: Scalars['String']['input'];
  name: Scalars['String']['input'];
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
  targetDeviceCode: Scalars['String']['input'];
  targeting?: InputMaybe<CreateWithOrderTargetingInput>;
  /** This field is not supported in combination with redirectHtmlCode */
  viewTracking?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateCreativeFromHashPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Creative>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCreativeFromRedirectCodeInput = {
  /** Also known as adslot */
  adPlacementCode: Scalars['String']['input'];
  brandSafetyTracking?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  redirectHtmlCode: Scalars['String']['input'];
  targetDeviceCode: Scalars['String']['input'];
};

export type CreateCreativeFromRedirectCodePayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Creative>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateCustomRoleInput = {
  name: Scalars['String']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type CreateFileTreeDirectoryInput = {
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type CreateFileTreeInput = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateFromHashDaypartsInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  weekday: Scalars['String']['input'];
};

export type CreateInvitationsInput = {
  customRoleIds: Array<Scalars['ID']['input']>;
  emails: Array<Scalars['String']['input']>;
};

export type CreateMediaFolderInput = {
  accountId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMediaUploadRequestInput = {
  folderId: Scalars['ID']['input'];
};

export type CreateOrderInput = {
  ais: Scalars['Long']['input'];
  allowlist?: InputMaybe<Scalars['String']['input']>;
  blocklist?: InputMaybe<Scalars['String']['input']>;
  budget: Scalars['Float']['input'];
  campaignId: Scalars['ID']['input'];
  end?: InputMaybe<Scalars['DateTime']['input']>;
  legalAgreements?: InputMaybe<LegalAgreementsInput>;
  playoutSchedule?: InputMaybe<CampaignPlayoutScheduleEnum>;
  productCode: Scalars['String']['input'];
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  zips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Sub-Type for storing details of the user legal agreement */
export type CreateOrderLegalAgreementInput = {
  dataPrivacy?: InputMaybe<AgreementDetailsInput>;
  termsOfService?: InputMaybe<AgreementDetailsInput>;
};

export type CreateOrderPayload = MutationResponse & {
  campaign?: Maybe<Campaign>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type CreateOrderSequenceInput = {
  options?: InputMaybe<OrderSequenceOptions>;
  productCode: Scalars['ID']['input'];
  resellerId?: InputMaybe<Scalars['ID']['input']>;
};

/** Sub-Type for storing details of the user who created an order of a client */
export type CreateOrderUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductDeliveryChannelInput = {
  code: Scalars['ID']['input'];
  minimumBookingVolume: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateProductFamilyInput = {
  code: Scalars['ID']['input'];
  color: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalCreatives?: InputMaybe<Scalars['Boolean']['input']>;
  icon: Scalars['String']['input'];
  name: Scalars['String']['input'];
  productVariants: Array<ProductVariantInput>;
  reseller?: InputMaybe<Scalars['ID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductFunnelInput = {
  billingType: Scalars['String']['input'];
  code: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateProductGeoTargetInput = {
  code: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateProductGuaranteeInput = {
  code: Scalars['ID']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  precision?: InputMaybe<Scalars['Int']['input']>;
  roundType?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductIdentificationInput = {
  code: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  precision: Scalars['Int']['input'];
  roundType: Scalars['String']['input'];
};

export type CreateProductInput = {
  bookable: Scalars['Boolean']['input'];
  budgetIdentification: Scalars['ID']['input'];
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  code: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['ID']['input'];
  ctr?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productBillingType?: InputMaybe<Scalars['ID']['input']>;
  productDeliveryChannel: Scalars['ID']['input'];
  productFamily?: InputMaybe<Scalars['ID']['input']>;
  /** TB change */
  productFamilyToReseller?: InputMaybe<Scalars['ID']['input']>;
  productFunnel: Scalars['ID']['input'];
  productGeoTarget: Scalars['ID']['input'];
  productGuarantees?: InputMaybe<Array<ProductGuaranteeInput>>;
  productIdentifications: Array<ProductIdentificationInput>;
  productTargetings?: InputMaybe<Array<ProductTargetingInput>>;
  productVisibilityMetrics?: InputMaybe<Array<ProductVisibilityMetricInput>>;
  publisherAdPlacementTypes?: InputMaybe<Array<ProductPublisherAdPlacementTypeInput>>;
  purchasePrice: Scalars['Float']['input'];
  reseller: Scalars['ID']['input'];
  salesPrice: Scalars['Float']['input'];
  settings?: InputMaybe<Scalars['JSON']['input']>;
  targetDeviceGroup: Scalars['ID']['input'];
};

export type CreateProductVisibilityMetricInput = {
  code: Scalars['String']['input'];
  defaultOption: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  selectedOption: Scalars['Boolean']['input'];
};

export type CreatePublisherAdPlacementInput = {
  cpm?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productFamily?: InputMaybe<ProductFamilyInput>;
  publisherAdPlacementTypeCode: Scalars['ID']['input'];
  publisherId: Scalars['ID']['input'];
  publisherWebsiteId: Scalars['ID']['input'];
  sorting?: InputMaybe<Scalars['Int']['input']>;
  targetDeviceCode: Scalars['ID']['input'];
  website_id?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePublisherAdPlacementTypeInput = {
  code: Scalars['ID']['input'];
  height: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  specification: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type CreatePublisherInput = {
  countryCode: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  publisherId: Scalars['ID']['input'];
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePublisherWebsiteInput = {
  alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain: Scalars['String']['input'];
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  productFamily?: InputMaybe<ProductFamilyInput>;
  publisherId?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  targetings?: InputMaybe<Array<PublisherWebsiteTargetingInput>>;
};

export type CreateRadiusZipsCatchmentAreaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  manualZips?: InputMaybe<Scalars['JSONB']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  storeId: Scalars['UUID']['input'];
};

export type CreateResellerCampaignSettingInput = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<ResellerCampaignBookingSettingInput>;
  brand?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customername?: InputMaybe<Scalars['String']['input']>;
  domainTargetingBlacklist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domainTargetingWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reseller: Scalars['ID']['input'];
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<ResellerCampaignTargetingInput>;
};

/** Payload data for creating a completely new reseller account. */
export type CreateResellerInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  customername?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  /**
   * Required username containing 3 to 20 characters where letter, number,
   * period ("."), underscore ("_") and or hyphen "-" are allowed.
   */
  orgId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  role?: InputMaybe<Scalars['String']['input']>;
  tenantGateway?: InputMaybe<Scalars['String']['input']>;
  tenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

export type CreateResellerNotificationSettingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  ccEmail?: InputMaybe<Scalars['JSON']['input']>;
  channel: Scalars['String']['input'];
  event: Scalars['String']['input'];
  reseller: Scalars['ID']['input'];
  toEmail: Scalars['JSON']['input'];
};

export type CreateStoreInput = {
  accountCanonicalId: Scalars['UUID']['input'];
  active?: InputMaybe<Scalars['Boolean']['input']>;
  additionalAddress?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  /**
   * Geocoded address (same required fields as UpsertGeocodedAddressInput without id).
   * A GeocodedAddress row is created first, then the store references it.
   */
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSONB']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  hasOpeningHours?: InputMaybe<Scalars['Boolean']['input']>;
  image?: InputMaybe<Scalars['UUID']['input']>;
  imprintUrl?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  legalUrl?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['UUID']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  mapmarker?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  privacyUrl?: InputMaybe<Scalars['String']['input']>;
  reference: Scalars['String']['input'];
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type CreateStoresGroupInput = {
  accountCanonicalId: Scalars['UUID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateTagInput = {
  accountCanonicalId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateUsersInput = {
  customRoleIds: Array<Scalars['ID']['input']>;
  emails: Array<Scalars['String']['input']>;
};

export type CreateWithOrderTargetingInput = {
  dayparts?: InputMaybe<Array<CreateFromHashDaypartsInput>>;
};

export type Creative = {
  adPlacementCode?: Maybe<Scalars['String']['output']>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  /** Get current creative revision by stage */
  currentRevision?: Maybe<CreativeRevision>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  revisions?: Maybe<Array<Maybe<CreativeRevision>>>;
  status?: Maybe<CreativeStatus>;
  targetDeviceCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};


export type CreativeCurrentRevisionArgs = {
  stage: CreativeRevisionStageEnum;
};

/**
 * State of a creative in adserver
 * READY = 0
 * ACTIVE = 1
 * DEACTIVATED = 2
 * READY_UNCHECKED = 3
 * ACTIVE_UNCHECKED = 4
 * DEACTIVATED_UNCHECKED = 5
 * DISCARDED = 6
 */
export enum CreativeAdserverStatusEnum {
  Active = 'ACTIVE',
  ActiveUnchecked = 'ACTIVE_UNCHECKED',
  Deactivated = 'DEACTIVATED',
  DeactivatedUnchecked = 'DEACTIVATED_UNCHECKED',
  Discarded = 'DISCARDED',
  Ready = 'READY',
  ReadyUnchecked = 'READY_UNCHECKED'
}

/** A connection to a list of items. */
export type CreativeConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreativeEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CreativeDeploymentInput = {
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  creative: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  error?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  progress?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<CampaignDeploymentStage>;
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  state?: InputMaybe<CampaignDeploymentState>;
};

/** An edge in a connection. */
export type CreativeEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<Creative>;
};

export enum CreativeExternalStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT'
}

export type CreativeInternalComponentCategory = {
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type CreativeInternalComponentComponent = {
  active: Scalars['Boolean']['output'];
  allowedGrids?: Maybe<Array<Maybe<Grid>>>;
  /** Get assigned Category */
  category?: Maybe<CreativeInternalComponentCategory>;
  /** Get Component Children, default is empty Array */
  children?: Maybe<Array<Maybe<CreativeInternalComponentComponent>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get Fields of Component */
  fields?: Maybe<Array<Maybe<ComponentField>>>;
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  /** Get Component Parent, default is empty Array */
  parent?: Maybe<Array<Maybe<Component>>>;
  /** This is Alias Key in Reports */
  reportKey?: Maybe<Scalars['String']['output']>;
  reportType?: Maybe<Array<Scalars['String']['output']>>;
  section: ComponentSectionType;
  sorting?: Maybe<Scalars['Int']['output']>;
  /** Get Component Tags from your query */
  tags?: Maybe<Array<Maybe<ComponentTag>>>;
  /** Get Component Tag relations */
  tagsAll?: Maybe<Array<Maybe<ComponentTag>>>;
};


export type CreativeInternalComponentComponentFieldsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum CreativeInternalDeploymentStage {
  Preview = 'PREVIEW',
  Production = 'PRODUCTION'
}

export enum CreativeInternalDeploymentState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type CreativeInternalEdges = {
  edges?: Maybe<Array<Maybe<CreativeInternalNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type CreativeInternalNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Campaign>;
};

export enum CreativeInternalPlayoutRangeEnum {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export enum CreativeInternalPlayoutScheduleEnum {
  Consistent = 'CONSISTENT',
  FastestPossible = 'FASTEST_POSSIBLE'
}

export type CreativeInternalPreviewAdPlacementType = {
  code?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetDevice?: Maybe<TargetDevice>;
  width?: Maybe<Scalars['Int']['output']>;
};

export enum CreativeInternalStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT'
}

export type CreativeMutation = {
  addRevisionFromHash?: Maybe<AddCreativeRevisionFromHashPayload>;
  createFromHash?: Maybe<CreateCreativeFromHashPayload>;
  /** @deprecated Please use createFromHash */
  createFromRedirectCode?: Maybe<CreateCreativeFromRedirectCodePayload>;
  remove?: Maybe<RemoveCreativePayload>;
  removeRevision?: Maybe<RemoveCreativeRevisionPayload>;
  update?: Maybe<UpdateCreativePayload>;
  /** @deprecated Use campaignBaseData -> creativeExternal instead */
  uploadTemp?: Maybe<UploadCreativeTempPayload>;
};


export type CreativeMutationAddRevisionFromHashArgs = {
  input: AddCreativeRevisionFromHashInput;
};


export type CreativeMutationCreateFromHashArgs = {
  input: CreateCreativeFromHashInput;
};


export type CreativeMutationCreateFromRedirectCodeArgs = {
  input: CreateCreativeFromRedirectCodeInput;
};


export type CreativeMutationRemoveArgs = {
  input: RemoveCreativeInput;
};


export type CreativeMutationRemoveRevisionArgs = {
  input: RemoveCreativeRevisionInput;
};


export type CreativeMutationUpdateArgs = {
  input: UpdateCreativeInput;
};


export type CreativeMutationUploadTempArgs = {
  adPlacementCode?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  redirectHtmlCode?: InputMaybe<Scalars['String']['input']>;
};

export enum CreativeOrderBy {
  Age = 'AGE',
  Name = 'NAME'
}

export type CreativeRevision = {
  adGapId?: Maybe<Scalars['String']['output']>;
  brandSafetyTracking?: Maybe<Scalars['String']['output']>;
  clickTracking?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  hash?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  redirectHtmlCode?: Maybe<Scalars['String']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  stage?: Maybe<CreativeRevisionStageEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  viewTracking?: Maybe<Scalars['String']['output']>;
};

export enum CreativeRevisionStageEnum {
  Preview = 'PREVIEW',
  Production = 'PRODUCTION'
}

export enum CreativeStatus {
  Active = 'ACTIVE',
  Archive = 'ARCHIVE',
  Draft = 'DRAFT'
}

export type CustomRole = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Permission_V2>;
  userCount: Scalars['Int']['output'];
};

export enum CustomRoleField {
  Id = 'id',
  Name = 'name'
}

export type CustomRoleOrderBy = {
  field: CustomRoleField;
  order?: InputMaybe<OrderByDirection>;
};

export type CustomRolesInput = {
  orderBy?: InputMaybe<Array<CustomRoleOrderBy>>;
  paginate?: InputMaybe<OffsetBasedPageInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CustomRolesPage = {
  items: Array<CustomRole>;
  pageInfo: OffsetBasedPageInfo;
};

export type DataPrivacyInput = {
  approvedAt: Scalars['DateTime']['input'];
  isApproved: Scalars['Boolean']['input'];
};

/** Filter that may be used to filer results by a column that contains date & time */
export type DateFilter = {
  equals?: InputMaybe<Scalars['String']['input']>;
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['String']['input']>;
  lowerThan?: InputMaybe<Scalars['String']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['String']['input']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThan?: InputMaybe<Scalars['DateTime']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
  lowerThan?: InputMaybe<Scalars['DateTime']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteAllFileTreeEntriesInput = {
  directoryPath?: InputMaybe<Scalars['String']['input']>;
  fileTreeId: Scalars['ID']['input'];
};

export type DeleteFileTreeEntryInput = {
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type DeleteMediaFolderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRadiusZipsCatchmentAreaInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteResellerCampaignSettingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteResellerNotificationSettingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteStoresGroupInput = {
  id: Scalars['UUID']['input'];
};

export type DeleteStoresGroupResult = {
  removed: Scalars['Boolean']['output'];
};

export enum DeviceCodeEnum {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Tablet = 'TABLET'
}

/** Represents the campaign booking settings for a targget device group DESKTOP, MOBILE, MULTI */
export type DeviceSetting = {
  id: Scalars['ID']['output'];
  targetDeviceGroupCode?: Maybe<Scalars['String']['output']>;
  /** list of website ids to book */
  websiteIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** list of website ids to exclude when booking */
  websiteIdsBlacklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DeviceSettingInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  targetDeviceGroupCode?: InputMaybe<Scalars['String']['input']>;
  websiteIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  websiteIdsBlacklist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type DoubleVerifyDailyBreakdown = {
  /** Date (DD.MM.YYYY) */
  day: Scalars['String']['output'];
  /** View time in seconds */
  viewTime: Scalars['Float']['output'];
  /** Viewability rate (0-1) */
  viewability: Scalars['Float']['output'];
};

export type ElasticsDayPerformanceBiva = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Completed video views (content-vastVideo_complete) */
  completed: Scalars['Int']['output'];
  /** Day */
  day: Scalars['String']['output'];
  /** A list of triggers and the count */
  events?: Maybe<Array<Maybe<ElasticsEventTriggerCount>>>;
  /** Video starts (content-vastVideo_start) */
  started: Scalars['Int']['output'];
  /** View Through Rate */
  viewThroughRate: Scalars['Float']['output'];
  /** Viewable Ad Impressions */
  viewableAdImpression?: Maybe<Scalars['Int']['output']>;
};

export type ElasticsDayPerformanceSa = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Completed Story View */
  completed: Scalars['Int']['output'];
  /** Day */
  day: Scalars['String']['output'];
  /** Total linkouts */
  linkouts: Scalars['Int']['output'];
  /**
   * Story starts (Ad Impressions)
   * @deprecated Use adImpression field instead
   */
  started: Scalars['Int']['output'];
  /** CTR (per day) */
  viewThroughRate: Scalars['Float']['output'];
  /** Viewable Ad Impressions */
  viewableAdImpression?: Maybe<Scalars['Int']['output']>;
};

export enum ElasticsEvent {
  All = 'ALL',
  Click = 'Click',
  Hover = 'Hover',
  Input = 'Input',
  Scroll = 'Scroll',
  SearchNoResult = 'SearchNoResult',
  Unlock = 'Unlock',
  VideoPlay100Percent = 'VideoPlay100Percent',
  VideoPlayStart = 'VideoPlayStart',
  View = 'View',
  Zoom = 'Zoom'
}

export type ElasticsEventCount = {
  /** Unique identifier for the branch associated with the event */
  branchId?: Maybe<Scalars['ID']['output']>;
  /** Represents the total number of occurrences of a specific event */
  count: Scalars['Int']['output'];
  /** The specific event for which the count is computed */
  event: ElasticsEvent;
};

export type ElasticsEventTriggerCount = {
  /** Count */
  count: Scalars['Int']['output'];
  /** Trigger name */
  event: Scalars['String']['output'];
};

export type ElasticsFlyoutMenu = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Menu Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Trigger */
  trigger: Scalars['String']['output'];
};

export type ElasticsKeywordCount = {
  /** Represents the total number of occurrences of a specified keyword in a given context */
  count: Scalars['Int']['output'];
  /** Specifies the particular keyword for which the count is computed */
  keyword: Scalars['String']['output'];
};

export type ElasticsProductCount = {
  /** Represents the total number of times a particular product has been searched and found in a campaign */
  count: Scalars['Int']['output'];
  /** Refers to the specific product involved in a campaign */
  product?: Maybe<CampaignProduct>;
};

export type ElasticsReportAdvertisingSpaceDayPerformance = {
  /** Daily values grouped by adSlot */
  adSlotDayList?: Maybe<Array<Maybe<AdslotDayList>>>;
  /** Daily values grouped by target device */
  targetDeviceDayList?: Maybe<Array<Maybe<TargetDeviceDayList>>>;
};

export type ElasticsReportAdvertisingSpacePerformance = {
  /** Ad Impressionen */
  adImpression: Scalars['Int']['output'];
  /** Ad placement type */
  adPlacementType?: Maybe<Scalars['String']['output']>;
  /** Advertising Space */
  advertisingSpace: Scalars['String']['output'];
  areaId: Scalars['Int']['output'];
  /** Unique billable interactions or Adserver clicks for external products */
  interaction: Scalars['Int']['output'];
  /** Product delivery channel */
  productDeliveryChannel?: Maybe<ProductDeliveryChannelEnum>;
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
  /** Target device code */
  targetDevice?: Maybe<DeviceCodeEnum>;
};

export type ElasticsReportDayBranchLinkouts = {
  /** Campaign Branch */
  branch: CampaignBranch;
  /** Total Linkouts */
  count: Scalars['Int']['output'];
  /** Day */
  day: Scalars['String']['output'];
};

export type ElasticsReportDayPerformance = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Ad Impressions daily contribuition */
  adImpressionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Day */
  day: Scalars['String']['output'];
  /** Unique billable interactions or Adserver clicks for external products */
  interaction: Scalars['Int']['output'];
  /** Interactions daily contribuition */
  interactionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Interactions per Ad Impression */
  interactionRate?: Maybe<Scalars['Float']['output']>;
  /** Linkouts per Ad Impression */
  linkoutRate?: Maybe<Scalars['Float']['output']>;
  /** Total Linkouts */
  linkouts: Scalars['Int']['output'];
  /** Linkouts daily contribuition */
  linkoutsPercentage?: Maybe<Scalars['Float']['output']>;
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
  /** Unique linkouts */
  uniqueLinkouts: Scalars['Int']['output'];
  /** Users (Unique) */
  uniqueUsers: Scalars['Int']['output'];
  /** Unique users daily contribuition */
  uniqueUsersPercentage?: Maybe<Scalars['Float']['output']>;
  /**
   * Users
   * @deprecated Value makes no sense at all
   */
  users: Scalars['Int']['output'];
  /** Viewable Ad Impressions */
  viewableAdImpression?: Maybe<Scalars['Int']['output']>;
};

export type ElasticsReportDoubleVerify = {
  /** Average view time across all days (seconds) */
  averageViewTime: Scalars['Float']['output'];
  /** Average viewability rate across all days (0-1) */
  averageViewability: Scalars['Float']['output'];
  /** Daily breakdown of viewability metrics */
  dailyBreakdown: Array<DoubleVerifyDailyBreakdown>;
};

export type ElasticsReportInteractionsPerTrigger = {
  /** Total click interactions */
  clickTotal?: Maybe<Scalars['Int']['output']>;
  /** Unique click interactions */
  clickUnique?: Maybe<Scalars['Int']['output']>;
  /** Total hover interactions */
  hoverTotal?: Maybe<Scalars['Int']['output']>;
  /** Unique hover interactions */
  hoverUnique?: Maybe<Scalars['Int']['output']>;
  /** Total linkouts */
  linkoutsTotal?: Maybe<Scalars['Int']['output']>;
  /** Unique linkouts */
  linkoutsUnique?: Maybe<Scalars['Int']['output']>;
  /** Total scroll interactions */
  scrollTotal?: Maybe<Scalars['Int']['output']>;
  /** Unique scroll interactions */
  scrollUnique?: Maybe<Scalars['Int']['output']>;
  /** Sum of all interaction types (total) */
  sumInteractionsTotal?: Maybe<Scalars['Int']['output']>;
  /** Sum of all interaction types (unique) */
  sumInteractionsUnique?: Maybe<Scalars['Int']['output']>;
  /** Trigger */
  trigger: Scalars['String']['output'];
};

export type ElasticsReportLinkoutsByBranch = {
  /** Campaign branch */
  branch: CampaignBranch;
  /** Total Linkouts */
  count: Scalars['Int']['output'];
  /** Unique linkouts */
  countUnique: Scalars['Int']['output'];
};

export type ElasticsReportMyBranch = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Trigger */
  trigger: Scalars['String']['output'];
};

export type ElasticsReportPublisherPerformance = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Ad Impressions percentage */
  adImpressionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Interactions (Unique) */
  interaction: Scalars['Int']['output'];
  /** Interaction percentage */
  interactionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Publisher */
  publisher: Scalars['String']['output'];
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
};

export type ElasticsReportTopBranch = {
  /** Ad Impression count from Adserver */
  adImpression: Scalars['Int']['output'];
  /** Campaign branch */
  branch: CampaignBranch;
  /** Branch goal */
  branchGoal?: Maybe<BranchGoal>;
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** All events except 'View' with payout true */
  interactions: Scalars['Int']['output'];
  /** Total linkouts */
  linkouts: Scalars['Int']['output'];
  /** Total payouts */
  payouts: Scalars['Int']['output'];
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
  /** All events except 'View' with payout true (Unique) */
  uniqueInteractions: Scalars['Int']['output'];
  /** Unique linkouts */
  uniqueLinkouts: Scalars['Int']['output'];
  /** Unique payouts */
  uniquePayouts: Scalars['Int']['output'];
  /** Unique users */
  uniqueUsers: Scalars['Int']['output'];
};

export type ElasticsReportTopBreadcrumb = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Trigger */
  trigger: Scalars['String']['output'];
};

export type ElasticsReportTopComponent = {
  branch?: Maybe<CampaignBranch>;
  component: CampaignComponentInstance;
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Total linkouts */
  linkouts?: Maybe<Scalars['Int']['output']>;
};

export type ElasticsReportTopHomepage = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Ad Impressions percetage */
  adImpressionPercentage?: Maybe<Scalars['Float']['output']>;
  /** Homepage */
  homepage: Scalars['String']['output'];
  /** Aerospike Engagements for internal or Adserver Clicks for external products */
  interaction: Scalars['Int']['output'];
  /** Interaction percentage */
  interactionPercentage?: Maybe<Scalars['Float']['output']>;
  /** BP Video triggers */
  triggers?: Maybe<Array<Maybe<BpTriggerCount>>>;
};

export type ElasticsReportTopMainMenu = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Label taken from meta.label */
  label: Scalars['String']['output'];
};

export type ElasticsReportTopProduct = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Campaign Product */
  product: CampaignProduct;
  /** Triggers */
  triggers?: Maybe<Array<Maybe<ElasticsEventTriggerCount>>>;
};

export type ElasticsReportTopSearch = {
  /** Top X Search Terms */
  keywords?: Maybe<Array<Maybe<ElasticsKeywordCount>>>;
  /** Top X Search Terms (Not Found) */
  notFound?: Maybe<Array<Maybe<ElasticsKeywordCount>>>;
  /** Top X Search Results for Products */
  products?: Maybe<Array<Maybe<ElasticsProductCount>>>;
};

export type ElasticsReportTopStage = {
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Campaign Stage */
  stage: CampaignStage;
};

export type ElasticsReportTopTrigger = {
  branchId?: Maybe<Scalars['ID']['output']>;
  /** Total events */
  count: Scalars['Int']['output'];
  /** Events and their counts (Aerospike only) */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Trigger */
  trigger: Scalars['String']['output'];
};

export type ElasticsReportTotalBiva = {
  /** Total values for all triggers */
  total?: Maybe<Array<Maybe<ElasticsEventTriggerCount>>>;
};

export type ElasticsReportTotalContent = {
  /** Gesamt */
  totalEvents?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Gesamt Unique User */
  uniqueEvents?: Maybe<Array<Maybe<ElasticsEventCount>>>;
};

export type ElasticsReportTotalEvents = {
  /** Completed article views (Product AA) */
  aaCompleted: Scalars['Int']['output'];
  /** Adserver clicks */
  adServerClicks: Scalars['Int']['output'];
  /** Ad Impressions */
  adServerViews: Scalars['Int']['output'];
  /** Completed stories (Product SA) */
  completedStories: Scalars['Int']['output'];
  engagementDetails: Array<Maybe<EngagementDetails>>;
  /** Events and their counts */
  events?: Maybe<Array<Maybe<ElasticsEventCount>>>;
  /** Unique free space clicks */
  freeSpaceClicks: Scalars['Int']['output'];
  /** Unique free space clicks for the product Branded Player */
  freeSpaceContentBrandedPlayerClicks: Scalars['Int']['output'];
  /** Unique free space clicks in the content area */
  freeSpaceContentClicks: Scalars['Int']['output'];
  /** Unique free space Clicks in the footer area */
  freeSpaceFooterClicks: Scalars['Int']['output'];
  /** Unique free space Clicks in the header area */
  freeSpaceHeaderClicks: Scalars['Int']['output'];
  /** Total clicks on 'Read more' */
  showMoreCount: Scalars['Int']['output'];
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
  /** All Interactions - Aerospike for internal creatives and Adserver for external creatives */
  totalEvents: Scalars['Int']['output'];
  /** Total linkouts */
  totalLinkouts: Scalars['Int']['output'];
  /** Unique completed article views */
  uniqueAaCompleted: Scalars['Int']['output'];
  /** Unique completed stories (Product SA) */
  uniqueCompletedStories: Scalars['Int']['output'];
  /** Unique linkouts */
  uniqueLinkouts: Scalars['Int']['output'];
  /** Unique payouts */
  uniquePayouts: Scalars['Int']['output'];
  /**
   * All Interactions (Unique per event)
   * @deprecated Value will be removed
   */
  uniqueSessionEvents: Scalars['Int']['output'];
  /** Unique billable interactions or Adserver clicks for external products */
  uniqueSessions: Scalars['Int']['output'];
  /** Viewable Ad Impressions */
  viewableAdImpression: Scalars['Int']['output'];
};

export type ElasticsReportTotalSocialIconsBar = {
  /** Social Type */
  trigger: Scalars['String']['output'];
  /** Unique Clicks Social Icons */
  uniqueEvents?: Maybe<Array<Maybe<ElasticsEventCount>>>;
};

export type ElasticsReportUserEvents = {
  /** Interactions per user (Wrong Type) */
  average: Scalars['Float']['output'];
  /** Interactions per user */
  interactionsPerUser: Scalars['Int']['output'];
  /** Total users that performed 1 action */
  one: Scalars['Int']['output'];
  /** Total users that performed more than 3 actions */
  rest: Scalars['Int']['output'];
  /** Total users that performed 3 actions */
  three: Scalars['Int']['output'];
  /** Time taken to process the request */
  took: Scalars['Int']['output'];
  /** Total number of unique users */
  total: Scalars['Int']['output'];
  /** Total users that performed 2 actions */
  two: Scalars['Int']['output'];
};

export type ElasticsReportUserScrolls = {
  /** Scrolls per user */
  average: Scalars['Float']['output'];
  /** Total users that scrolled 5 times */
  five: Scalars['Int']['output'];
  /** Total user that scrolled 4 times */
  four: Scalars['Int']['output'];
  /** Total user that scrolled 1 time */
  one: Scalars['Int']['output'];
  /** Total user that scrolled more than 6 times */
  rest: Scalars['Int']['output'];
  /** Total user that scrolled 6 times */
  six: Scalars['Int']['output'];
  /** Total user that scrolled 3 times */
  three: Scalars['Int']['output'];
  /**
   * Time taken to process the request
   * @deprecated Will be removed
   */
  took: Scalars['Int']['output'];
  /** Total number of unique users that scrolled */
  total: Scalars['Int']['output'];
  /** Total user that scrolled 2 times */
  two: Scalars['Int']['output'];
};

export type ElasticsReportVisitDuration = {
  /** Average visit duration (seconds) */
  durationAvg: Scalars['Int']['output'];
  /** Maximum visit duration (seconds) */
  durationMax: Scalars['Int']['output'];
  /** Minimum visit duration (seconds) */
  durationMin: Scalars['Int']['output'];
  /**
   * Time taken to process the request
   * @deprecated Will be removed
   */
  took: Scalars['Int']['output'];
};

export enum ElasticsSection {
  Content = 'content',
  Footer = 'footer',
  Header = 'header'
}

export type EngagementDetails = {
  count: Scalars['Int']['output'];
  /** Event */
  event: ElasticsEvent;
  triggers: Array<Maybe<Trigger>>;
};

export type File = {
  contentType: Scalars['String']['output'];
  etag: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filesize: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  uuid: Scalars['String']['output'];
};

export type FileTree = {
  entries: FileTreeEntryPage;
  id: Scalars['ID']['output'];
  isValid: Scalars['Boolean']['output'];
  previewUrl: Scalars['String']['output'];
  profile: FileTreeProfile;
  profileId: Scalars['ID']['output'];
};


export type FileTreeEntriesArgs = {
  input?: InputMaybe<FileTreeEntriesInput>;
};


export type FileTreePreviewUrlArgs = {
  filePath?: InputMaybe<Scalars['String']['input']>;
};

export type FileTreeDirectory = FileTreeEntry & {
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type FileTreeEntriesInput = {
  paginate?: InputMaybe<OffsetBasedPageInput>;
};

export type FileTreeEntry = {
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type FileTreeEntryPage = {
  items: Array<FileTreeEntry>;
  pageInfo: OffsetBasedPageInfo;
};

export type FileTreeFile = FileTreeEntry & {
  contentType: Scalars['String']['output'];
  etag: Scalars['String']['output'];
  fileSize: Scalars['Long']['output'];
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type FileTreeProfile = {
  contentTypesAllowed: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type FindOptionsInput = {
  returnDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lowerThan?: InputMaybe<Scalars['Float']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type ForwardInput = {
  addressLine?: InputMaybe<Scalars['String']['input']>;
  buildingNumber?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
};

export enum Gender {
  Divers = 'DIVERS',
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GeoFeatureIdMap = {
  countryCode: Scalars['String']['output'];
  entityCode: Scalars['String']['output'];
  id: Scalars['BigInt']['output'];
  tableName: Scalars['String']['output'];
};

export type GeocodeBoundingBox = {
  northEast?: Maybe<Coordinate>;
  southWest?: Maybe<Coordinate>;
};

export enum GeocodeFeatureType {
  Address = 'ADDRESS',
  Country = 'COUNTRY',
  Locality = 'LOCALITY',
  PointOfInterest = 'POINT_OF_INTEREST',
  PostalCode = 'POSTAL_CODE',
  Street = 'STREET',
  Sublocality = 'SUBLOCALITY'
}

export type GeocodeLocation = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeocodeOptions = {
  bounds?: InputMaybe<BoundingBoxInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  proximity?: InputMaybe<CoordinateInput>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export enum GeocodePrecision {
  Approximate = 'APPROXIMATE',
  Centerpoint = 'CENTERPOINT',
  RangeInterpolated = 'RANGE_INTERPOLATED',
  Rooftop = 'ROOFTOP',
  Route = 'ROUTE'
}

export type GeocodeProvider = {
  attribution?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  rawPlaceId?: Maybe<Scalars['String']['output']>;
};

export type GeocodeResult = {
  boundingBox?: Maybe<GeocodeBoundingBox>;
  components: AddressComponents;
  confidence?: Maybe<Scalars['Float']['output']>;
  formattedAddress: Scalars['String']['output'];
  location: GeocodeLocation;
  precision: GeocodePrecision;
  provider: GeocodeProvider;
  types?: Maybe<Array<GeocodeFeatureType>>;
};

export type GeocodedAddress = {
  additionalAddress?: Maybe<Scalars['String']['output']>;
  address: Scalars['String']['output'];
  city: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  orgId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  zip: Scalars['String']['output'];
};

export type Grid = {
  active?: Maybe<Scalars['Boolean']['output']>;
  allowedComponents?: Maybe<Array<Maybe<Component>>>;
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['Mixed']['output']>;
  /** Get assigned Products */
  settingsLarge?: Maybe<Scalars['Mixed']['output']>;
  settingsSmall?: Maybe<Scalars['Mixed']['output']>;
  sorting: Scalars['Int']['output'];
};

export type GroupedGeoZipInsights = {
  aggregates?: Maybe<ZipPropertyAggregates>;
  id: Scalars['String']['output'];
};

export type GroupedGeoZipInsightsFilter = {
  countryCode: Scalars['String']['input'];
  hasIpMapping?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['String']['input'];
  zipCodes: Array<Scalars['String']['input']>;
};

export type GroupedGeoZipInsightsQuery = {
  groups: Array<GroupedGeoZipInsightsFilter>;
};

export type GroupedRadiusFilter = {
  center: CoordinateInput;
  countryCode: Scalars['String']['input'];
  id: Scalars['String']['input'];
  radius: Scalars['Int']['input'];
};

export type GroupedRadiusQuery = {
  groups: Array<GroupedRadiusFilter>;
};

export type GuaranteeFulfillment = {
  code?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type Image = {
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  md5sum: Scalars['String']['output'];
  type: Scalars['String']['output'];
  uuid: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type Import = {
  campaign: Campaign;
  completedAt?: Maybe<Scalars['String']['output']>;
  /** Inhalt des Imports als Array [["row1_col1", "row1_colN"], [...]] */
  data?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  error?: Maybe<Scalars['SequelizeJSON']['output']>;
  file: File;
  id: Scalars['ID']['output'];
  mapping?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  notice?: Maybe<Scalars['SequelizeJSON']['output']>;
  progress?: Maybe<Scalars['Int']['output']>;
  startedAt?: Maybe<Scalars['String']['output']>;
  state?: Maybe<ImportState>;
  /**
   * Statistics about the import: total number of rows, number of successful rows,
   * number of rows with warnings, number of failed rows.
   * Depending on the progress of the import, not all fields might be available yet.
   */
  statistics: ImportStatistics;
  type: ImportType;
};

export type ImportBatchPayload = {
  code: Scalars['Int']['output'];
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Default encoding is utf8 */
export enum ImportLocationEncoding {
  Latin1 = 'LATIN1',
  Utf8 = 'UTF8'
}

export type ImportLocationsPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<Location>>>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ImportMapping = {
  import: Scalars['ID']['output'];
  /**
   * Contains mapping Array like ["price_batch_price", null, "..."]
   * Use null if import must ignore column. Array index is the Column index
   */
  mapping: Array<Maybe<Scalars['String']['output']>>;
  override: Scalars['Boolean']['output'];
  skipFirstLine: Scalars['Boolean']['output'];
};

export type ImportMappingInput = {
  /** Import ID */
  import: Scalars['ID']['input'];
  /**
   * Contains mapping Array like ["price_batch_price", null, "..."]
   *
   * Use null if import must ignore column. Array index is the Column index
   */
  mapping: Array<InputMaybe<Scalars['String']['input']>>;
  /** Override files with same filename */
  override?: InputMaybe<Scalars['Boolean']['input']>;
  skipFirstLine?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportMappingStore = {
  campaign: Scalars['ID']['output'];
  createdAt: Scalars['DateTime']['output'];
  createdBy: User_V2;
  id: Scalars['ID']['output'];
  /**
   * Contains mapping Array like ["price_batch_price", null, "..."]
   * Use null if import must ignore column. Array index is the Column index
   */
  mapping: Array<Maybe<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  override: Scalars['Boolean']['output'];
  skipFirstLine: Scalars['Boolean']['output'];
  type: ImportMappingStoreType;
  updatedAt: Scalars['DateTime']['output'];
};

export type ImportMappingStoreInput = {
  campaign: Scalars['ID']['input'];
  /**
   * Contains mapping Array like ["price_batch_price", null, "..."]
   *
   * Use null if import must ignore column. Array index is the Column index
   */
  mapping: Array<InputMaybe<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
  skipFirstLine?: InputMaybe<Scalars['Boolean']['input']>;
  type: ImportMappingStoreType;
};

export enum ImportMappingStoreType {
  Branch = 'BRANCH',
  Product = 'PRODUCT',
  Sku = 'SKU'
}

export type ImportOrderCampaignInput = {
  creatorEmail: Scalars['String']['input'];
  creatorFullname: Scalars['String']['input'];
  merchantToolListAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  merchantToolListLink?: InputMaybe<Scalars['String']['input']>;
  trackingsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingsLink?: InputMaybe<Scalars['String']['input']>;
};

/** Sub-Type for orders which can be used to store data of the client’s customer */
export type ImportOrderCustomerInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parentAccount?: InputMaybe<ImportOrderCustomerParentInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type ImportOrderCustomerParentInput = {
  id: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

/**
 * Payload data for importing order data which must belong to a specific client
 * without triggering any additional logic.
 */
export type ImportOrderInput = {
  adserverId?: InputMaybe<Scalars['String']['input']>;
  /** Number of Ad Impressions */
  ais?: InputMaybe<Scalars['Long']['input']>;
  /**
   * Positive budge value wihout thousand seperator or currency codes
   * automatically rounded to 2-digit precision.
   */
  budget: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  /** Number of clicks */
  clicks?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Optional id of an existing reseller/client account which should be the
   * owner of the order. If the id is not given the id of the requesting client
   * will be used.
   */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Optional [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code of the country where the order should be placed. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Cost-per-click, automatically rounded to 6-digit precision */
  cpc?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<ImportOrderCustomerInput>;
  end: Scalars['DateTime']['input'];
  f11Id?: InputMaybe<Scalars['String']['input']>;
  madtechCategory?: InputMaybe<Scalars['String']['input']>;
  manualHandling?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required id of this order which is defined by the client and must be unique
   * for the client.
   */
  orderId: Scalars['String']['input'];
  playoutScheduleType?: InputMaybe<OrderPlayoutScheduleType>;
  productSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  productkey?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['DateTime']['input'];
  status?: InputMaybe<OrderStatus>;
  targetingRange?: InputMaybe<OrderTargetingRange>;
  user?: InputMaybe<CreateOrderUserInput>;
  visibilityMetric?: InputMaybe<Scalars['String']['input']>;
};

export type ImportOrderOfferInput = {
  bookingNotes?: InputMaybe<Scalars['String']['input']>;
  creatorEmail: Scalars['String']['input'];
  creatorFullname: Scalars['String']['input'];
  offerLink: Scalars['String']['input'];
  offerNotes?: InputMaybe<Scalars['String']['input']>;
  reportFrequency?: InputMaybe<Array<InputMaybe<ReportFrequency>>>;
};

export enum ImportState {
  Completed = 'COMPLETED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Launched = 'LAUNCHED',
  Running = 'RUNNING'
}

export type ImportStatistics = {
  failure?: Maybe<Scalars['Int']['output']>;
  success?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  warning?: Maybe<Scalars['Int']['output']>;
};

export enum ImportType {
  Branch = 'BRANCH',
  Product = 'PRODUCT',
  Sku = 'SKU'
}

export type IndustrySectorType = {
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>;
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lowerThan?: InputMaybe<Scalars['Int']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type Invitation = {
  customRoles: Array<InvitationCustomRole>;
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  inviteeEmail: Scalars['String']['output'];
  senderFirstName: Scalars['String']['output'];
  senderLastName: Scalars['String']['output'];
  status?: Maybe<InvitationStatus>;
};

export type InvitationCustomRole = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type InvitationOrderBy = {
  field: InvitationOrderByField;
  order?: InputMaybe<OrderByDirection>;
};

export enum InvitationOrderByField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Pending = 'pending'
}

export enum InvitationStatus {
  Accepted = 'ACCEPTED',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Revoked = 'REVOKED'
}

export type InvitationsInput = {
  orderBy?: InputMaybe<Array<InvitationOrderBy>>;
  paginate?: InputMaybe<OffsetBasedPageInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type InvitationsPage = {
  items: Array<Invitation>;
  pageInfo: OffsetBasedPageInfo;
};

export enum KpiCode {
  AdImpressions = 'AD_IMPRESSIONS',
  Clicks = 'CLICKS'
}

export type LegalAgreementsInput = {
  dataPrivacy: DataPrivacyInput;
  termsOfService: TermsOfServiceInput;
};

export type Location = {
  active?: Maybe<Scalars['Boolean']['output']>;
  center?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  radius?: Maybe<Scalars['String']['output']>;
  selected?: Maybe<LocationSelected>;
  state?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type LocationInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  center?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
  selected?: InputMaybe<LocationSelectedInput>;
  state?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type LocationMutation = {
  importFile?: Maybe<ImportLocationsPayload>;
};


export type LocationMutationImportFileArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  encoding?: InputMaybe<ImportLocationEncoding>;
  file: Scalars['Upload']['input'];
  geocode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationSelected = {
  range?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  set?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LocationSelectedInput = {
  range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  set?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LocationTemplate = {
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locations?: Maybe<Array<Maybe<Location>>>;
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

/** A connection to a list of items. */
export type LocationTemplateConnection = {
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LocationTemplateEdge>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

/** An edge in a connection. */
export type LocationTemplateEdge = {
  /** A cursor for use in pagination */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge */
  node?: Maybe<LocationTemplate>;
};

export enum LocationTemplateOrderBy {
  Age = 'AGE',
  Name = 'NAME'
}

export enum MadTechCategoryEnum {
  Default = 'DEFAULT',
  Group = 'GROUP',
  Individual = 'INDIVIDUAL'
}

export type MapFilter = {
  advanced?: Maybe<AdvancedMapFilter>;
  basic?: Maybe<BasicMapFilter>;
};

export type MapFilterBase = {
  zips: Array<Scalars['String']['output']>;
};

export type MapFilterInput = {
  advanced?: InputMaybe<AdvancedMapFilterInput>;
  basic?: InputMaybe<BasicMapFilterInput>;
};

export type MapFilterNode = {
  mapGroupFilter?: Maybe<MapGroupFilter>;
  mapNumberFilter?: Maybe<MapNumberFilter>;
};

export type MapFilterNodeInput = {
  mapGroupFilter?: InputMaybe<MapGroupFilterInput>;
  mapNumberFilter?: InputMaybe<MapNumberFilterInput>;
};

export enum MapFilterType {
  Advanced = 'ADVANCED',
  Basic = 'BASIC'
}

export type MapGroupFilter = {
  filters: Array<MapFilterNode>;
  id: Scalars['String']['output'];
  operator: MapGroupFilterOperator;
};

export type MapGroupFilterInput = {
  filters: Array<MapFilterNodeInput>;
  id: Scalars['String']['input'];
  operator: MapGroupFilterOperator;
};

export enum MapGroupFilterOperator {
  And = 'AND',
  Or = 'OR'
}

export type MapNumberFilter = {
  id: Scalars['String']['output'];
  operator: MapNumberFilterOperator;
  property: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type MapNumberFilterInput = {
  id: Scalars['String']['input'];
  operator: MapNumberFilterOperator;
  property: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export enum MapNumberFilterOperator {
  Eq = 'EQ',
  Gt = 'GT',
  Gte = 'GTE',
  Lt = 'LT',
  Lte = 'LTE',
  Neq = 'NEQ'
}

export type MeMutation = {
  update?: Maybe<User>;
};


export type MeMutationUpdateArgs = {
  data: UserInput;
};

export type Media = {
  active?: Maybe<Scalars['Boolean']['output']>;
  canonicalId: Scalars['ID']['output'];
  category?: Maybe<MediaCategory>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  etag: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  filesize?: Maybe<Scalars['Int']['output']>;
  folderId?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use canonicalId instead. */
  id: Scalars['ID']['output'];
  /** @deprecated Use used instead. */
  isUsed?: Maybe<MediaIsUsedEdges>;
  updatedAt: Scalars['DateTime']['output'];
  used?: Maybe<Scalars['Boolean']['output']>;
  uuid: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type MediaCategory = {
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type MediaEdges = {
  categories?: Maybe<Array<Maybe<MediaCategory>>>;
  edges?: Maybe<Array<Maybe<MediaNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export type MediaFolder = {
  accountId: Scalars['Int']['output'];
  children: MediaFolderChildrenPage;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  media: MediaPage;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type MediaFolderChildrenArgs = {
  paginate?: InputMaybe<OffsetBasedPageInput>;
};


export type MediaFolderMediaArgs = {
  paginate?: InputMaybe<OffsetBasedPageInput>;
};

export type MediaFolderChildrenPage = {
  items: Array<MediaFolder>;
  pageInfo: OffsetBasedPageInfo;
};

export type MediaFoldersInput = {
  accountId: Scalars['Int']['input'];
  /** Return at most this folder if accessible. Mutually exclusive with parentId. */
  folderId?: InputMaybe<Scalars['ID']['input']>;
  /** Pagination for folder lists (root or under parentId). Ignored when folderId is set. */
  paginate?: InputMaybe<OffsetBasedPageInput>;
  /** List folders under this parent. Mutually exclusive with folderId. */
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MediaFoldersPage = {
  items: Array<MediaFolder>;
  pageInfo: OffsetBasedPageInfo;
};

export type MediaIsUsed = {
  ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  type: Scalars['String']['output'];
};

export type MediaIsUsedEdges = {
  edges?: Maybe<Array<Maybe<MediaIsUsed>>>;
  /** @deprecated Use edges instead */
  ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  /** @deprecated Use edges instead */
  type?: Maybe<Scalars['String']['output']>;
};

export type MediaMutation = {
  createFromUrl?: Maybe<Media>;
  remove?: Maybe<Array<Maybe<Media>>>;
  removeAll?: Maybe<Scalars['Boolean']['output']>;
  upload?: Maybe<Array<Maybe<Media>>>;
  uploadBulk?: Maybe<Array<Maybe<Media>>>;
};


export type MediaMutationCreateFromUrlArgs = {
  campaign: Scalars['ID']['input'];
  category?: Scalars['ID']['input'];
  override?: InputMaybe<Scalars['Boolean']['input']>;
  shrink?: InputMaybe<Scalars['Boolean']['input']>;
  url: Scalars['String']['input'];
};


export type MediaMutationRemoveArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MediaMutationRemoveAllArgs = {
  accountId?: InputMaybe<Scalars['Int']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  creativeInternalId?: InputMaybe<Scalars['Int']['input']>;
};


export type MediaMutationUploadArgs = {
  account?: InputMaybe<Scalars['ID']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  campaignBaseData?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  collisionHandling?: InputMaybe<CollisionHandlingUpload>;
  file: Scalars['Upload']['input'];
  folderId?: InputMaybe<Scalars['ID']['input']>;
  shrink?: InputMaybe<Scalars['Boolean']['input']>;
  uploadContext?: InputMaybe<UploadContextMediaType>;
  uuid?: InputMaybe<Scalars['String']['input']>;
};


export type MediaMutationUploadBulkArgs = {
  account?: InputMaybe<Scalars['ID']['input']>;
  campaign?: InputMaybe<Scalars['ID']['input']>;
  campaignBaseData?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  collisionHandling?: InputMaybe<CollisionHandlingUpload>;
  files: Array<Scalars['Upload']['input']>;
  folderId?: InputMaybe<Scalars['ID']['input']>;
  shrink?: InputMaybe<Scalars['Boolean']['input']>;
  uploadContext?: InputMaybe<UploadContextMediaType>;
};

export type MediaNode = {
  /** This is feature for future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<Media>;
};

export type MediaPage = {
  items: Array<Media>;
  pageInfo: OffsetBasedPageInfo;
};

export type MediaUploadRequest = {
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  sessionSizeLimit: Scalars['Int']['output'];
  uploadLinkToken: Scalars['String']['output'];
};

export type MoveFileTreeEntryInput = {
  fileTreeId: Scalars['ID']['input'];
  sourcePath: Scalars['String']['input'];
  targetPath: Scalars['String']['input'];
};

export type MoveMediaFolderInput = {
  id: Scalars['ID']['input'];
  parentId?: InputMaybe<Scalars['ID']['input']>;
};

export type MoveMediaInput = {
  canonicalId: Scalars['ID']['input'];
  targetFolderId: Scalars['ID']['input'];
};

export type Mutation = {
  account?: Maybe<AccountMutation>;
  addOrganizationOwners: Array<User_V2>;
  adtech?: Maybe<AdtechMutation>;
  attachStoreToStoresGroup: AttachStoreToStoresGroupResult;
  attachTagToStore: AttachTagToStoreResult;
  campaignBaseData?: Maybe<CampaignBaseDataMutation>;
  channel?: Maybe<ChannelMutation>;
  channelCalculation?: Maybe<ChannelCalculationMutation>;
  channelWebsite?: Maybe<ChannelWebsiteMutation>;
  contact?: Maybe<ContactMutation>;
  createCustomRole: CustomRole;
  createFileTree: FileTree;
  createFileTreeDirectory: FileTreeDirectory;
  createInvitations: Array<Invitation>;
  createMediaFolder: MediaFolder;
  createMediaUploadRequest: MediaUploadRequest;
  createOrder?: Maybe<CreateOrderPayload>;
  createRadiusZipsCatchmentArea: RadiusZipsCatchmentArea;
  createStore: Store;
  createStoresGroup: StoresGroup;
  createTag: Tag;
  createUsers: Array<User_V2>;
  creative?: Maybe<CreativeMutation>;
  deleteAllFileTreeEntries: Scalars['Int']['output'];
  deleteFileTree: Scalars['Int']['output'];
  deleteFileTreeEntry: Scalars['Boolean']['output'];
  deleteMediaFolder: Scalars['Boolean']['output'];
  deleteRadiusZipsCatchmentArea: RadiusZipsCatchmentArea;
  deleteStoresGroup: DeleteStoresGroupResult;
  importFile?: Maybe<Import>;
  importLaunch?: Maybe<Scalars['Boolean']['output']>;
  importMapping?: Maybe<ImportMapping>;
  location?: Maybe<LocationMutation>;
  locationTemplate?: Maybe<LocationMutation>;
  me?: Maybe<MeMutation>;
  media?: Maybe<MediaMutation>;
  moveFileTreeEntry: FileTreeEntry;
  moveMedia: Media;
  moveMediaFolder: MediaFolder;
  offer?: Maybe<OfferMutation>;
  order?: Maybe<OrderMutation>;
  orderSequence?: Maybe<OrderSequenceMutation>;
  product?: Maybe<ProductMutation>;
  productDeliveryChannel?: Maybe<ProductDeliveryChannelMutation>;
  productFamily?: Maybe<ProductFamilyMutation>;
  productFunnel?: Maybe<ProductFunnelMutation>;
  productGeoTarget?: Maybe<ProductGeoTargetMutation>;
  productGuarantee?: Maybe<ProductGuaranteeMutation>;
  productIdentification?: Maybe<ProductIdentificationMutation>;
  productVisibilityMetric?: Maybe<ProductVisibilityMetricMutation>;
  publisher?: Maybe<PublisherMutation>;
  publisherAdPlacement?: Maybe<PublisherAdPlacementMutation>;
  publisherAdPlacementType?: Maybe<PublisherAdPlacementTypeMutation>;
  publisherWebsite?: Maybe<PublisherWebsiteMutation>;
  removeAddress?: Maybe<Address>;
  removeComponent?: Maybe<Component>;
  removeCustomRole: CustomRole;
  removeImportMappingStore: Scalars['Boolean']['output'];
  removeInvitations: Array<Invitation>;
  removeOrganizationOwners: Array<User_V2>;
  removeStoreFromStoresGroup: RemoveStoreFromStoresGroupResult;
  removeTag: RemoveTagResult;
  removeUser: User_V2;
  renameMedia: Scalars['Boolean']['output'];
  reseller?: Maybe<ResellerMutations>;
  resellerCampaignSetting?: Maybe<ResellerCampaignSettingMutation>;
  resellerNotificationSetting?: Maybe<ResellerNotificationSettingMutation>;
  revokeInvitations: Array<Invitation>;
  /** Send a Campaign Report email with shareable link to external and internal members */
  sendSharedReportLinkEmail: SendSharedReportLinkEmailResponse;
  /** Share a campaign report by generating a unique shareable link. */
  shareCampaignReport: ShareCampaignReportResponse;
  /**
   * Unshare a campaign report.
   * Invalidates the link key and prevents further access to the shared report.
   */
  unshareCampaignReport: UnshareCampaignReportResponse;
  /** Update a campaign report share link. */
  updateCampaignReportShareLink: UpdateCampaignReportShareLinkResponse;
  updateCustomRole: CustomRole;
  updateMyProfile: User_V2;
  updateOrganizationBrandAppearance?: Maybe<OrganizationBrandAppearance>;
  updateRadiusZipsCatchmentArea: RadiusZipsCatchmentArea;
  updateUserCustomRoles: User_V2;
  uploadFileTreeArchive: FileTreeEntryPage;
  uploadFileTreeFile: FileTreeFile;
  upsertAddress?: Maybe<Address>;
  upsertBookingDefault?: Maybe<BookingDefault>;
  /** @deprecated Use campaignBaseData -> creativeInternal instead */
  upsertCampaign?: Maybe<Campaign>;
  /**
   * Upserts CampaignDeployment. State changes to COMPLETE when progress is at 100
   * @deprecated Use campaignBaseData -> creativeInternal instead
   */
  upsertCampaignDeployment?: Maybe<CampaignDeployment>;
  upsertCreativeDeployment?: Maybe<CampaignDeployment>;
  upsertGeocodedAddresses: UpsertGeocodedAddressesResult;
  upsertImportMappingStore?: Maybe<ImportMappingStore>;
  user?: Maybe<UserMutation>;
  userRole?: Maybe<UserRoleMutation>;
};


export type MutationAccountArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddOrganizationOwnersArgs = {
  input: OrganizationOwnersInput;
};


export type MutationAttachStoreToStoresGroupArgs = {
  input: AttachStoreToStoresGroupInput;
};


export type MutationAttachTagToStoreArgs = {
  input: AttachTagToStoreInput;
};


export type MutationCampaignBaseDataArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationContactArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateCustomRoleArgs = {
  input: CreateCustomRoleInput;
};


export type MutationCreateFileTreeArgs = {
  input: CreateFileTreeInput;
};


export type MutationCreateFileTreeDirectoryArgs = {
  input: CreateFileTreeDirectoryInput;
};


export type MutationCreateInvitationsArgs = {
  input: CreateInvitationsInput;
};


export type MutationCreateMediaFolderArgs = {
  input: CreateMediaFolderInput;
};


export type MutationCreateMediaUploadRequestArgs = {
  input: CreateMediaUploadRequestInput;
};


export type MutationCreateOrderArgs = {
  input: CreateOrderInput;
};


export type MutationCreateRadiusZipsCatchmentAreaArgs = {
  input: CreateRadiusZipsCatchmentAreaInput;
};


export type MutationCreateStoreArgs = {
  input: CreateStoreInput;
};


export type MutationCreateStoresGroupArgs = {
  input: CreateStoresGroupInput;
};


export type MutationCreateTagArgs = {
  input: CreateTagInput;
};


export type MutationCreateUsersArgs = {
  input: CreateUsersInput;
};


export type MutationDeleteAllFileTreeEntriesArgs = {
  input: DeleteAllFileTreeEntriesInput;
};


export type MutationDeleteFileTreeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileTreeEntryArgs = {
  input: DeleteFileTreeEntryInput;
};


export type MutationDeleteMediaFolderArgs = {
  input: DeleteMediaFolderInput;
};


export type MutationDeleteRadiusZipsCatchmentAreaArgs = {
  input: DeleteRadiusZipsCatchmentAreaInput;
};


export type MutationDeleteStoresGroupArgs = {
  input: DeleteStoresGroupInput;
};


export type MutationImportFileArgs = {
  campaign: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
  type: ImportType;
};


export type MutationImportLaunchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationImportMappingArgs = {
  data: ImportMappingInput;
};


export type MutationMoveFileTreeEntryArgs = {
  input: MoveFileTreeEntryInput;
};


export type MutationMoveMediaArgs = {
  input: MoveMediaInput;
};


export type MutationMoveMediaFolderArgs = {
  input: MoveMediaFolderInput;
};


export type MutationRemoveAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveComponentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveCustomRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveImportMappingStoreArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveInvitationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationRemoveOrganizationOwnersArgs = {
  input: OrganizationOwnersInput;
};


export type MutationRemoveStoreFromStoresGroupArgs = {
  input: RemoveStoreFromStoresGroupInput;
};


export type MutationRemoveTagArgs = {
  input: RemoveTagInput;
};


export type MutationRemoveUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRenameMediaArgs = {
  input: RenameMediaInput;
};


export type MutationRevokeInvitationsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationSendSharedReportLinkEmailArgs = {
  input: SendSharedReportLinkEmailInput;
};


export type MutationShareCampaignReportArgs = {
  input: ShareCampaignReportInput;
};


export type MutationUnshareCampaignReportArgs = {
  input: UnshareCampaignReportInput;
};


export type MutationUpdateCampaignReportShareLinkArgs = {
  input: UpdateCampaignReportShareLinkInput;
};


export type MutationUpdateCustomRoleArgs = {
  input: UpdateCustomRoleInput;
};


export type MutationUpdateMyProfileArgs = {
  input?: InputMaybe<UpdateMyProfileInput>;
};


export type MutationUpdateOrganizationBrandAppearanceArgs = {
  data: OrganizationBrandAppearanceInput;
};


export type MutationUpdateRadiusZipsCatchmentAreaArgs = {
  input: UpdateRadiusZipsCatchmentAreaInput;
};


export type MutationUpdateUserCustomRolesArgs = {
  input: UpdateUserCustomRolesInput;
};


export type MutationUploadFileTreeArchiveArgs = {
  input: UploadFileTreeArchiveInput;
};


export type MutationUploadFileTreeFileArgs = {
  input: UploadFileTreeFileInput;
};


export type MutationUpsertAddressArgs = {
  data: AddressInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertBookingDefaultArgs = {
  data: BookingDefaultInput;
};


export type MutationUpsertCampaignArgs = {
  data: CampaignInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertCampaignDeploymentArgs = {
  data: CampaignDeploymentInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertCreativeDeploymentArgs = {
  data: CreativeDeploymentInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationUpsertGeocodedAddressesArgs = {
  input: UpsertGeocodedAddressesInput;
};


export type MutationUpsertImportMappingStoreArgs = {
  data: ImportMappingStoreInput;
};

export type MutationResponse = {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type NumberFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>;
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  greaterThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  lowerThan?: InputMaybe<Scalars['Float']['input']>;
  lowerThanOrEqual?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type Offer = {
  /** offer customer */
  account?: Maybe<Account>;
  /** true if this is the latest selected revision of this offer */
  activeRevision?: Maybe<Scalars['Boolean']['output']>;
  /** selected device and ad placement combinations */
  adPlacement?: Maybe<Array<Maybe<OfferAdPlacement>>>;
  /** public author */
  author?: Maybe<User_V2>;
  /** line break seperated string of domains where the campaign must not be displayed */
  blacklist?: Maybe<Scalars['String']['output']>;
  /** options needed to restore the booking view */
  bookingOptions?: Maybe<OfferBookingOptions>;
  /** customer brand name */
  brand?: Maybe<Scalars['String']['output']>;
  /** base budget excluding offer discount */
  budget?: Maybe<Scalars['Float']['output']>;
  /** custom budget allocation for every campaign month */
  budgetAllocation?: Maybe<Array<Maybe<OfferBudgetAllocation>>>;
  /** budget type is either "AUTOMATIC" or "CUSTOM" when budget allocation is given */
  budgetType?: Maybe<Scalars['String']['output']>;
  /** linked campaign if applicable */
  campaign?: Maybe<Campaign>;
  /** linked campaignBaseData if applicable */
  campaignBaseData?: Maybe<CampaignBaseData>;
  /** name of campaign */
  campaignName?: Maybe<Scalars['String']['output']>;
  /** additional cash discount exclusive for this offer */
  cashDiscount?: Maybe<Scalars['Float']['output']>;
  /** run of channel configuration */
  channel?: Maybe<ProductChannel>;
  /** internal comment for this offer */
  comment?: Maybe<Scalars['String']['output']>;
  /** contact on customer side */
  contact?: Maybe<Contact>;
  /** host country */
  country?: Maybe<Country>;
  /** true if campaign creative is not supplied by customer */
  creativeCreation?: Maybe<Scalars['Boolean']['output']>;
  /** additional text displayed in offer document */
  description?: Maybe<Scalars['String']['output']>;
  /** end date of campaign */
  end?: Maybe<Scalars['DateTime']['output']>;
  /** total cost with applied date range filter and all propabilities */
  expectedBudget?: Maybe<Scalars['Float']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** flag indicating if this is a v2 offer */
  isV2?: Maybe<Scalars['Boolean']['output']>;
  madTechCategory?: Maybe<MadTechCategoryEnum>;
  /** list of motive with display settings */
  motive?: Maybe<Array<Maybe<OfferMotive>>>;
  /** additional natural discount exclusive for this offer */
  naturalDiscount?: Maybe<Scalars['Float']['output']>;
  offerLanguageCode?: Maybe<Scalars['String']['output']>;
  /** internal offer number */
  offerNumber?: Maybe<Scalars['Int']['output']>;
  /** external offer number */
  offerNumberExternal?: Maybe<Scalars['String']['output']>;
  offerStateCode?: Maybe<OfferStateCodeEnum>;
  /** total cost with applied date range filter */
  partialBudget?: Maybe<Scalars['Float']['output']>;
  /** total cost with applied date range filter and budget propability */
  partialProbabilityBudget?: Maybe<Scalars['Float']['output']>;
  /** media reference to main offer document */
  pdf?: Maybe<Media>;
  /** playout schedule can be either "CONSISTENT" or "FASTEST" or "OPTIMIZED" */
  playoutScheduleType?: Maybe<CampaignPlayoutScheduleEnum>;
  /** probaility of offer commission and expected budget */
  probability?: Maybe<OfferProbability>;
  product?: Maybe<Product>;
  productCode?: Maybe<Scalars['String']['output']>;
  /** geo targeting type extracted from zipGroup */
  productGeoTarget?: Maybe<CampaignPlayoutRangeEnum>;
  /** selected visibility metric for the campaign */
  productVisibilityMetric?: Maybe<ProductVisibilityMetric>;
  /** list of allowed publishers for the campaign */
  publisher?: Maybe<Array<Maybe<Publisher>>>;
  /** list of report frequencies */
  reportFrequency?: Maybe<Array<Maybe<ReportFrequency>>>;
  revision?: Maybe<Scalars['Int']['output']>;
  /** media reference to list of domains the campaign will be displayed on */
  siteList?: Maybe<Media>;
  /** snapshot of of calculation, product, potential and discount data on last update */
  snapshot?: Maybe<OfferSnapshot>;
  source?: Maybe<OfferSourceEnum>;
  /** media reference to spec requirments for the selected product */
  specs?: Maybe<Media>;
  /** start date of campaign */
  start?: Maybe<Scalars['DateTime']['output']>;
  surcharge?: Maybe<OfferSurcharge>;
  /** list of special targetings to use for the campaign */
  targetGroup?: Maybe<Array<Maybe<ProductTargeting>>>;
  /** setting for custom campaign time targetings */
  targeting?: Maybe<OfferTargeting>;
  /** target cost after all discounts and calculations */
  totalCost?: Maybe<Scalars['Float']['output']>;
  /** type of offer can be either "DEFAULT" or "INVENTORY" */
  type?: Maybe<OfferTypeEnum>;
  /** version lock */
  version?: Maybe<Scalars['Int']['output']>;
  /** line break seperated string of domains where the campaign may only be displayed */
  whitelist?: Maybe<Scalars['String']['output']>;
  /** mark campaign as "WKZ(Werbekostenzuschuss)-Kampagne" */
  wkz?: Maybe<Scalars['Boolean']['output']>;
  /** list of zip groups and region codes selected for the campaign */
  zipGroup?: Maybe<OfferZipGroup>;
};

export type OfferAccountFilter = {
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type OfferAdPlacement = {
  adPlacement?: Maybe<PublisherAdPlacementType>;
  targetDevice?: Maybe<TargetDevice>;
};

export type OfferAuthorFilter = {
  email?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringFilter>;
};

export type OfferBookingOptions = {
  /** @deprecated Use themeColors instead */
  accentColor?: Maybe<Scalars['String']['output']>;
  budgetFactor: Scalars['Float']['output'];
  globalFilter?: Maybe<MapFilter>;
  layer?: Maybe<Scalars['String']['output']>;
  layerFilters?: Maybe<MapFilter>;
  locations?: Maybe<Array<OfferBookingOptionsLocations>>;
  /** @deprecated Use basic/advanced map filter manualZips instead */
  manualZips?: Maybe<Array<Scalars['String']['output']>>;
  regions?: Maybe<Array<OfferBookingOptionsRegions>>;
  showPins?: Maybe<Scalars['Boolean']['output']>;
  showSelectedCountryOnly?: Maybe<Scalars['Boolean']['output']>;
  showTargetArea?: Maybe<Scalars['Boolean']['output']>;
  showUnselected?: Maybe<Scalars['Boolean']['output']>;
  themeColors?: Maybe<Scalars['SequelizeJSON']['output']>;
};

export type OfferBookingOptionsLocations = {
  active?: Maybe<Scalars['Boolean']['output']>;
  center?: Maybe<Array<Scalars['Float']['output']>>;
  city?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<MapFilter>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  radius?: Maybe<Scalars['Int']['output']>;
  selected?: Maybe<OfferBookingOptionsLocationsSelected>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unfiltered?: Maybe<OfferBookingOptionsLocationsSelected>;
  zip: Scalars['String']['output'];
};

export type OfferBookingOptionsLocationsSelected = {
  range?: Maybe<Array<Scalars['String']['output']>>;
  set?: Maybe<Array<Scalars['String']['output']>>;
};

export type OfferBookingOptionsRegions = {
  code: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type OfferBudget = {
  /** expected budget for selected filter criteria */
  budget?: Maybe<Scalars['Float']['output']>;
  /** expected budget for selected filter criteria with budget propability applied */
  expectedBudget?: Maybe<Scalars['Float']['output']>;
};

export type OfferBudgetAllocation = {
  budget?: Maybe<Scalars['Float']['output']>;
  month?: Maybe<Scalars['Int']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type OfferCampaignFilter = {
  OR?: InputMaybe<Array<OfferCampaignFilter>>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type OfferChangeBookingInput = {
  /** base budget excluding offer discount */
  budget: Scalars['Float']['input'];
  /** custom budget allocation for every campaign month */
  budgetAllocation?: InputMaybe<Array<OfferUpsertBudgetAllocationInput>>;
  budgetFactor?: InputMaybe<Scalars['Float']['input']>;
  /** end date of campaign */
  end: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  /** start date of campaign */
  start: Scalars['String']['input'];
  /** target budget after all discounts and calculations */
  totalCost: Scalars['Float']['input'];
  /** version lock */
  version: Scalars['Int']['input'];
};

export type OfferChangeStateInput = {
  id: Scalars['ID']['input'];
  targetState: OfferStateCodeEnum;
  trigger?: InputMaybe<Array<OfferChangeStateTriggerInput>>;
  version: Scalars['Int']['input'];
};

export type OfferChangeStateTriggerInput = {
  code: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type OfferConnection = {
  edges?: Maybe<Array<Maybe<OfferEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type OfferCopyInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferCountryFilter = {
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type OfferCreatePreviewInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferDateRange = {
  /** end date of campaign */
  end: Scalars['String']['input'];
  /** start date of campaign */
  start: Scalars['String']['input'];
};

export type OfferDeleteInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Offer>;
};

export type OfferFilter = {
  OR?: InputMaybe<Array<OfferFilter>>;
  account?: InputMaybe<OfferAccountFilter>;
  activeRevision?: InputMaybe<Scalars['Boolean']['input']>;
  author?: InputMaybe<OfferAuthorFilter>;
  campaign?: InputMaybe<OfferCampaignFilter>;
  campaignName?: InputMaybe<StringFilter>;
  country?: InputMaybe<OfferCountryFilter>;
  end?: InputMaybe<DateFilter>;
  id?: InputMaybe<NumberFilter>;
  offerLanguageCode?: InputMaybe<StringFilter>;
  offerNumber?: InputMaybe<NumberFilter>;
  offerNumberExternal?: InputMaybe<StringFilter>;
  offerStateCode?: InputMaybe<StringFilter>;
  product?: InputMaybe<OfferProductFilter>;
  revision?: InputMaybe<NumberFilter>;
  start?: InputMaybe<DateFilter>;
};

export type OfferGenerateSitelistInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferLanguage = {
  code?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OfferLinkCampaignInput = {
  id: Scalars['ID']['input'];
  payload: OfferLinkCampaignPayload;
  version: Scalars['Int']['input'];
};

export type OfferLinkCampaignPayload = {
  createCampaign?: InputMaybe<OfferLinkCampaignPayloadCreateCampaignInput>;
  linkCampaign?: InputMaybe<OfferLinkCampaignPayloadLinkCampaignInput>;
};

export type OfferLinkCampaignPayloadCreateCampaignInput = {
  productVariantCode: Scalars['String']['input'];
};

export type OfferLinkCampaignPayloadLinkCampaignInput = {
  campaignBaseDataId?: InputMaybe<Scalars['Int']['input']>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferMailTemplate = {
  content: Scalars['String']['output'];
  footerTemplate?: Maybe<Scalars['String']['output']>;
  headerTemplate?: Maybe<Scalars['String']['output']>;
};

export type OfferMailTemplateInput = {
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferMotive = {
  name?: Maybe<Scalars['String']['output']>;
  targeting?: Maybe<OfferMotiveTargeting>;
  weighting?: Maybe<Scalars['Float']['output']>;
};

export type OfferMotiveTargeting = {
  dayparts?: Maybe<Array<Maybe<OfferTargetingDaypart>>>;
};

export type OfferMutation = {
  changeBooking?: Maybe<Offer>;
  changeState?: Maybe<Offer>;
  copy?: Maybe<Offer>;
  createMailTemplate?: Maybe<OfferMailTemplate>;
  createPreview?: Maybe<Offer>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  generateSitelist?: Maybe<Offer>;
  linkCampaign?: Maybe<Offer>;
  probability?: Maybe<Offer>;
  removeText?: Maybe<OfferText>;
  upsert?: Maybe<Offer>;
  upsertText?: Maybe<Array<Maybe<OfferText>>>;
};


export type OfferMutationChangeBookingArgs = {
  input: OfferChangeBookingInput;
};


export type OfferMutationChangeStateArgs = {
  input: OfferChangeStateInput;
};


export type OfferMutationCopyArgs = {
  input: OfferCopyInput;
};


export type OfferMutationCreateMailTemplateArgs = {
  input: OfferMailTemplateInput;
};


export type OfferMutationCreatePreviewArgs = {
  input: OfferCreatePreviewInput;
};


export type OfferMutationDeleteArgs = {
  input: OfferDeleteInput;
};


export type OfferMutationGenerateSitelistArgs = {
  input: OfferGenerateSitelistInput;
};


export type OfferMutationLinkCampaignArgs = {
  input: OfferLinkCampaignInput;
};


export type OfferMutationProbabilityArgs = {
  input: OfferProbabilityInput;
};


export type OfferMutationRemoveTextArgs = {
  input: OfferTextRemoveInput;
};


export type OfferMutationUpsertArgs = {
  input: OfferUpsertInput;
};


export type OfferMutationUpsertTextArgs = {
  input: Array<OfferTextInput>;
  update?: InputMaybe<Scalars['Boolean']['input']>;
};

export type OfferProbability = {
  /** percentage of budget which will likely be ordered on offer commission */
  budget?: Maybe<Scalars['Int']['output']>;
  /** likelyhood of offer commission in % */
  commission?: Maybe<Scalars['Int']['output']>;
};

export type OfferProbabilityInput = {
  budget: Scalars['Int']['input'];
  commission: Scalars['Int']['input'];
  id: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};

export type OfferProductFamilyFilter = {
  code?: InputMaybe<StringFilter>;
};

export type OfferProductFilter = {
  code?: InputMaybe<StringFilter>;
  productFamily?: InputMaybe<OfferProductFamilyFilter>;
  productGeoTarget?: InputMaybe<StringFilter>;
};

export type OfferSnapshot = {
  /** snapshot of calculation result */
  calculation?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** snapshot of discount data from selected account */
  discount?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** snapshot of potential api response */
  potential?: Maybe<Scalars['SequelizeJSON']['output']>;
  /** snapshot of product data */
  product?: Maybe<Scalars['SequelizeJSON']['output']>;
};

export enum OfferSourceEnum {
  ApiCreation = 'API_CREATION',
  AutoAdCreation = 'AUTO_AD_CREATION',
  /** @deprecated Use BOOKING_FLOW instead. */
  Booking = 'BOOKING',
  BookingFlow = 'BOOKING_FLOW',
  /** @deprecated Use MEDIA_PLANNING or another supported source. */
  Forecast = 'FORECAST',
  MediaPlanning = 'MEDIA_PLANNING',
  OfferCreation = 'OFFER_CREATION'
}

export type OfferState = {
  action: Array<OfferStateAction>;
  code: Scalars['ID']['output'];
  createRevision: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  possibleState: Array<OfferStatePossibleState>;
  sorting: Scalars['Int']['output'];
};

export type OfferStateAction = {
  code: Scalars['ID']['output'];
  disabled?: Maybe<Scalars['Boolean']['output']>;
};

export enum OfferStateCodeEnum {
  Booked = 'BOOKED',
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  InMediaPlan = 'IN_MEDIA_PLAN',
  OfferRefused = 'OFFER_REFUSED',
  OfferSent = 'OFFER_SENT',
  RemovedFromMediaPlan = 'REMOVED_FROM_MEDIA_PLAN',
  Requested = 'REQUESTED',
  Saved = 'SAVED'
}

export type OfferStatePossibleState = {
  code: Scalars['ID']['output'];
  trigger: Array<OfferStatePossibleStateTrigger>;
};

export type OfferStatePossibleStateTrigger = {
  code: Scalars['ID']['output'];
};

export type OfferSurcharge = {
  description?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export type OfferTargeting = {
  dayparts?: Maybe<Array<Maybe<OfferTargetingDaypart>>>;
};

export type OfferTargetingDaypart = {
  endTime?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  weekday?: Maybe<Scalars['String']['output']>;
};

export type OfferText = {
  code: Scalars['ID']['output'];
  language: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type OfferTextConnection = {
  edges?: Maybe<Array<Maybe<OfferTextEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type OfferTextEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<OfferText>;
};

export type OfferTextFilter = {
  code?: InputMaybe<StringFilter>;
  language?: InputMaybe<StringFilter>;
};

export type OfferTextInput = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
};

export type OfferTextRemoveInput = {
  code: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export enum OfferTypeEnum {
  Default = 'DEFAULT',
  Inventory = 'INVENTORY'
}

export type OfferUpsertAdPlacementInput = {
  adPlacementCode: Scalars['String']['input'];
  targetDeviceCode: Scalars['String']['input'];
};

export type OfferUpsertBookingOptionsInput = {
  budgetFactor: Scalars['Float']['input'];
  globalFilter?: InputMaybe<MapFilterInput>;
  layer?: InputMaybe<Scalars['String']['input']>;
  layerFilters?: InputMaybe<MapFilterInput>;
  locations?: InputMaybe<Array<OfferUpsertBookingOptionsLocationsInput>>;
  regions?: InputMaybe<Array<OfferUpsertBookingOptionsRegionsInput>>;
  showPins?: InputMaybe<Scalars['Boolean']['input']>;
  showSelectedCountryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showTargetArea?: InputMaybe<Scalars['Boolean']['input']>;
  showUnselected?: InputMaybe<Scalars['Boolean']['input']>;
  themeColors?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type OfferUpsertBookingOptionsLocationsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  center?: InputMaybe<Array<Scalars['Float']['input']>>;
  city: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MapFilterInput>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  radius?: InputMaybe<Scalars['Int']['input']>;
  selected?: InputMaybe<OfferUpsertBookingOptionsLocationsSelectedInput>;
  street: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unfiltered?: InputMaybe<OfferUpsertBookingOptionsLocationsSelectedInput>;
  zip: Scalars['String']['input'];
};

export type OfferUpsertBookingOptionsLocationsSelectedInput = {
  range?: InputMaybe<Array<Scalars['String']['input']>>;
  set?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OfferUpsertBookingOptionsRegionsInput = {
  code: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type OfferUpsertBudgetAllocationInput = {
  budget: Scalars['Float']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

export type OfferUpsertDaypartInput = {
  endTime: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  weekday: Scalars['String']['input'];
};

export type OfferUpsertInput = {
  /** offer customer */
  accountId?: InputMaybe<Scalars['Int']['input']>;
  /** selected device and ad placement combinations */
  adPlacement: Array<OfferUpsertAdPlacementInput>;
  /** public author */
  authorId?: InputMaybe<Scalars['ID']['input']>;
  /** line break seperated string of domains where the campaign must not be displayed */
  blacklist?: InputMaybe<Scalars['String']['input']>;
  /** options needed to restore the booking view */
  bookingOptions?: InputMaybe<OfferUpsertBookingOptionsInput>;
  /** customer brand name */
  brand?: InputMaybe<Scalars['String']['input']>;
  /** base budget excluding offer discount */
  budget: Scalars['Float']['input'];
  /** custom budget allocation for every campaign month */
  budgetAllocation?: InputMaybe<Array<OfferUpsertBudgetAllocationInput>>;
  /** budget type is either "AUTOMATIC" or "CUSTOM" when budget allocation is given */
  budgetType: Scalars['String']['input'];
  /** name of campaign */
  campaignName?: InputMaybe<Scalars['String']['input']>;
  /** additional cash discount exclusive for this offer */
  cashDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** run of channel configuration */
  channel?: InputMaybe<ChannelInput>;
  /** internal comment for this offer */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** contact on customer side */
  contactId?: InputMaybe<Scalars['Int']['input']>;
  /** host country */
  countryCode: Scalars['String']['input'];
  /** true if campaign creative is not supplied by customer */
  creativeCreation: Scalars['Boolean']['input'];
  /** additional text displayed in offer document */
  description?: InputMaybe<Scalars['String']['input']>;
  /** end date of campaign */
  end: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  /** flag indicating if this is a v2 offer */
  isV2?: InputMaybe<Scalars['Boolean']['input']>;
  madTechCategory: MadTechCategoryEnum;
  /** list of motive with display settings */
  motive?: InputMaybe<Array<OfferUpsertMotiveInput>>;
  /** additional natural discount exclusive for this offer */
  naturalDiscount?: InputMaybe<Scalars['Float']['input']>;
  /** language for offer documents */
  offerLanguageCode?: InputMaybe<Scalars['String']['input']>;
  /** state code of the offer */
  offerStateCode?: InputMaybe<OfferStateCodeEnum>;
  /** Organization Id */
  orgId?: InputMaybe<Scalars['String']['input']>;
  /** playout schedule can be either "CONSISTENT" or "FASTEST" or "OPTIMIZED" */
  playoutScheduleType: CampaignPlayoutScheduleEnum;
  productCode: Scalars['String']['input'];
  /** selected visibility metric for the campaign */
  productVisibilityMetricCode?: InputMaybe<Scalars['String']['input']>;
  /** list of allowed publishers for the campaign */
  publisher?: InputMaybe<Array<OfferUpsertPublisherInput>>;
  /** list of report frequencies */
  reportFrequency?: InputMaybe<Array<ReportFrequency>>;
  source?: InputMaybe<OfferSourceEnum>;
  /** start date of campaign */
  start: Scalars['String']['input'];
  surcharge?: InputMaybe<OfferUpsertSurcharge>;
  /** list of special targetings to use for the campaign */
  targetGroup?: InputMaybe<Array<OfferUpsertTargetGroupInput>>;
  /** setting for custom campaign time targetings */
  targeting?: InputMaybe<OfferUpsertTargetingInput>;
  /** target budget after all discounts and calculations */
  totalCost: Scalars['Float']['input'];
  /** type of offer can be either "DEFAULT" or "INVENTORY" */
  type: OfferTypeEnum;
  /** version lock */
  version?: InputMaybe<Scalars['Int']['input']>;
  /** line break seperated string of domains where the campaign may only be displayed */
  whitelist?: InputMaybe<Scalars['String']['input']>;
  /** mark campaign as "WKZ(Werbekostenzuschuss)-Kampagne" */
  wkz: Scalars['Boolean']['input'];
  /** list of zip groups selected for the campaign */
  zipGroup: OfferUpsertZipGroupInput;
};

export type OfferUpsertMotiveInput = {
  name: Scalars['String']['input'];
  targeting?: InputMaybe<OfferUpsertTargetingInput>;
  weighting?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferUpsertPublisherInput = {
  id: Scalars['Int']['input'];
};

export type OfferUpsertSurcharge = {
  description?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

export type OfferUpsertTargetGroupInput = {
  code: Scalars['String']['input'];
};

export type OfferUpsertTargetingInput = {
  dayparts: Array<OfferUpsertDaypartInput>;
};

export type OfferUpsertZipGroupFieldInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  zips: Array<Scalars['String']['input']>;
};

export type OfferUpsertZipGroupInput = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groups?: InputMaybe<Array<InputMaybe<OfferUpsertZipGroupFieldInput>>>;
  type?: InputMaybe<CampaignPlayoutRangeEnum>;
};

export type OfferZipGroup = {
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<ZipGroup>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type OffsetBasedPageInfo = {
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type OffsetBasedPageInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

/** A model which stores the incoming ordered data */
export type Order = {
  accountManagerId?: Maybe<Scalars['String']['output']>;
  adserverId?: Maybe<Scalars['String']['output']>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  ais?: Maybe<Scalars['Long']['output']>;
  bannerfile?: Maybe<Scalars['String']['output']>;
  blacklist?: Maybe<Scalars['String']['output']>;
  bookingNotes?: Maybe<Scalars['String']['output']>;
  bookingPriority?: Maybe<Scalars['Int']['output']>;
  budget?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['Int']['output']>;
  channel?: Maybe<Scalars['ID']['output']>;
  channelIds?: Maybe<Scalars['JSON']['output']>;
  clicks?: Maybe<Scalars['Int']['output']>;
  client?: Maybe<Reseller>;
  country?: Maybe<Country>;
  /** Optional [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code of the country where the order should be placed. */
  countryCode?: Maybe<Scalars['String']['output']>;
  cpc?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Represents a filterable list of creatives assigned to this order */
  creatives?: Maybe<Array<Maybe<OrderCreative>>>;
  customer?: Maybe<OrderCustomer>;
  end?: Maybe<Scalars['DateTime']['output']>;
  f11Id?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  legalAgreement?: Maybe<Scalars['JSON']['output']>;
  madtechCategory?: Maybe<Scalars['String']['output']>;
  manualHandling?: Maybe<Scalars['Boolean']['output']>;
  merchantToolListAvailable?: Maybe<Scalars['Boolean']['output']>;
  merchantToolListLink?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  offerNotes?: Maybe<Scalars['String']['output']>;
  orderId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated Use `productCode`. */
  playoutScheduleType?: Maybe<OrderPlayoutScheduleType>;
  productCode?: Maybe<Scalars['String']['output']>;
  productSnapshot?: Maybe<Scalars['JSON']['output']>;
  productkey?: Maybe<Scalars['String']['output']>;
  publisher?: Maybe<Scalars['JSON']['output']>;
  reportFrequency?: Maybe<Array<Maybe<ReportFrequency>>>;
  salesManagerId?: Maybe<Scalars['String']['output']>;
  siteList?: Maybe<Scalars['JSON']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of this order */
  status?: Maybe<OrderStatus>;
  /** a list of status entries with additional information */
  statusLog?: Maybe<Array<Maybe<OrderStatusLogItem>>>;
  /** @deprecated 1641549622 use targeturl instead */
  targetUrl?: Maybe<Scalars['String']['output']>;
  targeting?: Maybe<Array<Maybe<OrderTargeting>>>;
  targetingRange?: Maybe<OrderTargetingRange>;
  targeturl?: Maybe<Scalars['String']['output']>;
  /** @deprecated 2021-03-08 use status instead */
  testorder?: Maybe<Scalars['Boolean']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  trackingsAvailable?: Maybe<Scalars['Boolean']['output']>;
  trackingsLink?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<OrderUser>;
  visibilityMetric?: Maybe<Scalars['String']['output']>;
  websiteIds?: Maybe<Scalars['JSON']['output']>;
  websiteIdsBlacklist?: Maybe<Scalars['JSON']['output']>;
  whitelist?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['JSON']['output']>;
};


/** A model which stores the incoming ordered data */
export type OrderCreativesArgs = {
  filter?: InputMaybe<OrderCreativeFilter>;
};


/** A model which stores the incoming ordered data */
export type OrderStatusLogArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};

export type OrderBy = {
  field: Scalars['String']['input'];
  order?: InputMaybe<OrderDirection>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderConnection = {
  edges?: Maybe<Array<Maybe<OrderEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo: PageInfo;
};

/** Payload data for creating an order */
export type OrderCreateOrderInput = {
  /** Number of ordered ad impressions. */
  ais?: InputMaybe<Scalars['Long']['input']>;
  /** A multi-line string of one domain per line that should be allowed */
  allowlist?: InputMaybe<Scalars['String']['input']>;
  /** Multi-line string with one domain per line which should be blocked. */
  blocklist?: InputMaybe<Scalars['String']['input']>;
  /**
   * Positive budge value wihout thousand seperator or currency codes
   * automatically rounded to 2-digit precision.
   */
  budget: Scalars['String']['input'];
  /** Calculation result for order */
  calculation?: InputMaybe<Scalars['JSON']['input']>;
  /** Information about the campaign creator */
  campaign?: InputMaybe<ImportOrderCampaignInput>;
  /** Optional channel ID for ROC (Run Of Channel) products. When specified, filters the product snapshot to include only this channel's data. */
  channel?: InputMaybe<Scalars['ID']['input']>;
  /** Optional [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code of the country where the order should be placed. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Additional array of (max 30) objects containing properties for creatives that should get created. */
  creatives?: InputMaybe<Array<InputMaybe<OrderCreativeInput>>>;
  /** information about the customer */
  customer?: InputMaybe<ImportOrderCustomerInput>;
  /** Date and time when the campaign should end. Must be after start. The string lacks time zone information and uses the transmitted timezone or, if not available, the requesting client’s time zone setting. */
  end: Scalars['DateTime']['input'];
  /**
   * The unique identifier of the order that should get updated.
   * Must specify either id or f11Id to update.
   */
  f11Id?: InputMaybe<Scalars['String']['input']>;
  /** details of the user legal agreement */
  legalAgreement?: InputMaybe<CreateOrderLegalAgreementInput>;
  madtechCategory?: InputMaybe<Scalars['String']['input']>;
  /** Arbitrary name for this order */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Information about the offer creator and link to the offer */
  offer?: InputMaybe<ImportOrderOfferInput>;
  /**
   * Required id of this order which is defined by the client and must be unique
   * for the client.
   */
  orderId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The playout schedule profile
   * CONSISTENT: Distributes clicks on whole campaign time span
   * FASTEST: Consumes all clicks as fast as possible
   * OPTIMIZED: Not used tbd
   */
  playoutScheduleType?: InputMaybe<OrderPlayoutScheduleType>;
  /** Code of a bookable product assigned to the requesting client. Usually product codes are all uppercase ASCII-Strings with hyphens like "CEDN-N-RON". */
  productCode: Scalars['String']['input'];
  productSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  /** An array of one or more region codes where the campaign should be displayed. The region codes are from the type ISO-3166-2-Codes */
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Date and time when the campaign should start. Must be before end. The string is lacking time zone information and uses the transmitted timezone or, if not available, the requesting client’s time zone setting. */
  start: Scalars['DateTime']['input'];
  /**
   * Initial status of the order which can have only one of the following values:
   * DRAFT: Stores the order as a draft version, no additional processing or publication will be triggered. DRAFT status can also be used to mark an order as a test order.
   * NEW: order is ready for further processing
   */
  status?: InputMaybe<OrderStatus>;
  /** Optional original targeting range value which was set when the order was created */
  targetingRange?: InputMaybe<OrderTargetingRange>;
  /** time zone name (for Central European Time (CET) e.g. 'Europe/Berlin') which `start` and `end` use. If not given the requesting client’s time zone setting is used. */
  timezone?: InputMaybe<Scalars['String']['input']>;
  /** details of the user who created the order (and essentially booked the campaign) */
  user?: InputMaybe<CreateOrderUserInput>;
  /** Optional string describing the visibility metric ID */
  visibilityMetric?: InputMaybe<Scalars['String']['input']>;
  /** An array of one or more zip codes where the campaign should be displayed */
  zip?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Model describing all required data for a creative which either points
 * to a soruceUrl or contains HTML sourcecode.
 */
export type OrderCreative = {
  adGapId?: Maybe<Scalars['String']['output']>;
  adserverId?: Maybe<Scalars['String']['output']>;
  /**
   * Set the status in the adserver.
   * Valid status are:  READY, ACTIVE, DEACTIVATED, READY_UNCHECKED, ACTIVE_UNCHECKED, DEACTIVATED_UNCHECKED, DISCARDED
   */
  adserverStatus?: Maybe<CreativeAdserverStatusEnum>;
  adslot?: Maybe<Scalars['String']['output']>;
  /** End date of the creative */
  end?: Maybe<Scalars['DateTime']['output']>;
  footerHtml?: Maybe<Scalars['String']['output']>;
  headerHtml?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  sourceUrl?: Maybe<Scalars['String']['output']>;
  /** Start date of the creative */
  start?: Maybe<Scalars['DateTime']['output']>;
  targetUrl?: Maybe<Scalars['String']['output']>;
  viewPixel?: Maybe<Scalars['String']['output']>;
  /** @deprecated 2021-03-05 use viewPixel instead */
  viewPixelUrl?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

/** Represents differnt combinable filter settings for creatives */
export type OrderCreativeFilter = {
  OR?: InputMaybe<Array<OrderCreativeFilter>>;
  adserverId?: InputMaybe<StringFilter>;
  adslot?: InputMaybe<StringFilter>;
  height?: InputMaybe<NumberFilter>;
  sourceUrl?: InputMaybe<StringFilter>;
  targetUrl?: InputMaybe<StringFilter>;
  viewPixel?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
};

/** Payload data for creating creatives */
export type OrderCreativeInput = {
  /** Optional adGapId for the creative */
  adGapId?: InputMaybe<Scalars['String']['input']>;
  /** The adserverStatus of the creative. Default is ACTIVE */
  adserverStatus?: InputMaybe<CreativeAdserverStatusEnum>;
  /**
   * Allowed values: Dynamic Sitebar - ds (300x601), Desktop Halfpage Ad - dhpa (300x600),
   * Billboard - bb (800x250), Mobile Halfpage Ad - mhpa (300x600), Tablet Halfpage Ad - thpa (300x600),
   * Medium Rectangle - mmr (300x250), 4to1 (320x75), Halfpage Ad - hpa (300x600),
   * Halfpage - hp (300x600), Sitebar - sb (300x601)
   */
  adslot: Scalars['String']['input'];
  /** Optional html source code that should get appended to the creative’s HTML */
  footerHtml?: InputMaybe<Scalars['String']['input']>;
  /** Optional html source code that should get prepended to the creative’s HTML */
  headerHtml?: InputMaybe<Scalars['String']['input']>;
  /** When "adslot" is not defined this is the required height of the creative in pixel. */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** Optional html source of the banner. Optional when sourceUrl is used instead. */
  html?: InputMaybe<Scalars['String']['input']>;
  /** Optional name for the creative */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Only used and required when html is not given. Fully qualified public url to the creatives source file. Either a html file or image file. */
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
  /** Fully qualified url which should be the link target of the creative */
  targetUrl?: InputMaybe<Scalars['String']['input']>;
  /** Optional targeting informations for the created creative */
  targeting?: InputMaybe<OrderTargetingInput>;
  /** Optional html source of the view tracking pixel that should be inserted into the creative’s sourcecode. */
  viewPixel?: InputMaybe<Scalars['String']['input']>;
  /**
   * `[0...100]` (Default `0`)
   * Weight of the creative in relation to other creatives in the campaign. When all creatives have the same weight they are equally distributed.
   */
  weight?: InputMaybe<Scalars['Int']['input']>;
  zipUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Type for defining all "customer*" attributes of an order */
export type OrderCustomer = {
  brand?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /**
   * optional arbitary identifier string for the customer an order belongs to,
   * usually this is the id of the customer of the reseller in a CRM system.
   */
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type OrderCustomerFilter = {
  brand?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  phone?: InputMaybe<StringFilter>;
  street?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type OrderEdge = {
  cursor: Scalars['String']['output'];
  node: Order;
};

/** Optional filtering parameters when querying for orders */
export type OrderFilter = {
  OR?: InputMaybe<Array<OrderFilter>>;
  adserverId?: InputMaybe<StringFilter>;
  ais?: InputMaybe<NumberFilter>;
  budget?: InputMaybe<NumberFilter>;
  clicks?: InputMaybe<NumberFilter>;
  client?: InputMaybe<ResellerFilter>;
  /** code of a country ("ISO 3166-1 alpha-2" - https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) */
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  customer?: InputMaybe<OrderCustomerFilter>;
  end?: InputMaybe<DateFilter>;
  f11Id?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  madtechCategory?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  orderId?: InputMaybe<StringFilter>;
  playoutScheduleType?: InputMaybe<StringFilter>;
  product?: InputMaybe<OrderProductFilter>;
  start?: InputMaybe<DateFilter>;
  status?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  user?: InputMaybe<OrderUserFilter>;
  visibilityMetric?: InputMaybe<StringFilter>;
};

export type OrderMutation = {
  addCreatives: Order;
  create: Order;
  import: Order;
  update: Order;
  updateCreative: Array<Maybe<OrderCreative>>;
};


export type OrderMutationAddCreativesArgs = {
  activate?: InputMaybe<Scalars['Boolean']['input']>;
  creatives?: InputMaybe<Array<OrderCreativeInput>>;
  orderId: Scalars['ID']['input'];
};


export type OrderMutationCreateArgs = {
  input: OrderCreateOrderInput;
};


export type OrderMutationImportArgs = {
  input: ImportOrderInput;
};


export type OrderMutationUpdateArgs = {
  input: UpdateOrderInput;
};


export type OrderMutationUpdateCreativeArgs = {
  input: OrderUpdateCreativeInput;
};

export enum OrderPlayoutScheduleType {
  Consistent = 'CONSISTENT',
  Fastest = 'FASTEST',
  Optimized = 'OPTIMIZED'
}

export type OrderProductFilter = {
  code?: InputMaybe<StringFilter>;
};

export type OrderReport = {
  overall?: Maybe<OrderReportOverall>;
};

export type OrderReportOverall = {
  aiConversion?: Maybe<Scalars['String']['output']>;
  clicksConversion?: Maybe<Scalars['String']['output']>;
  publishers?: Maybe<Array<Maybe<OrderReportOverallPublishers>>>;
};

export type OrderReportOverallPublishers = {
  adimpressions?: Maybe<Scalars['String']['output']>;
  conversions?: Maybe<Scalars['String']['output']>;
  displayname?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
};

export type OrderSequence = {
  productCode: Scalars['ID']['output'];
  resellerId: Scalars['ID']['output'];
  sequence: Scalars['String']['output'];
};

export type OrderSequenceMutation = {
  create: OrderSequence;
};


export type OrderSequenceMutationCreateArgs = {
  data: CreateOrderSequenceInput;
};

export type OrderSequenceOptions = {
  type: Scalars['String']['input'];
};

/** A list of status values that can be assigned to an Order.status */
export enum OrderStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Draft = 'DRAFT',
  Failed = 'FAILED',
  New = 'NEW',
  Processing = 'PROCESSING',
  Updated = 'UPDATED'
}

export type OrderStatusLogItem = {
  createdAt?: Maybe<Scalars['JSON']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<OrderStatus>;
  text?: Maybe<Scalars['String']['output']>;
};

export type OrderTargeting = {
  params: Scalars['JSON']['output'];
  type: Scalars['String']['output'];
};

export type OrderTargetingDaypartsInput = {
  endTime: Scalars['DateTime']['input'];
  startTime: Scalars['DateTime']['input'];
  /** Name of the weekday the item should be applied on */
  weekday: OrderTargetingDaypartsWeekday;
};

export enum OrderTargetingDaypartsWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

/** Payload data for creating creatives */
export type OrderTargetingInput = {
  /** Collection of daypart items which define when the campaign should be visible. */
  dayparts?: InputMaybe<Array<InputMaybe<OrderTargetingDaypartsInput>>>;
};

export enum OrderTargetingRange {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export type OrderUpdateCreativeInput = {
  /**
   * Set the status in the adserver.
   * Valid status are:  READY, ACTIVE, DEACTIVATED, READY_UNCHECKED, ACTIVE_UNCHECKED, DEACTIVATED_UNCHECKED, DISCARDED
   */
  adserverStatus: CreativeAdserverStatusEnum;
  /** to update the createive, the adserverId is needed */
  creativeAdserverId?: InputMaybe<Scalars['ID']['input']>;
  /** the previewHash corresponding to the s3 folder name and used in the CC sourceUrl */
  creativePreviewHash: Scalars['String']['input'];
  /** End date of the creative */
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /** the primary key of the order table */
  orderId: Scalars['ID']['input'];
  /** Start date of the creative */
  start?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Type for defining all "user*"-attributes of an order */
export type OrderUser = {
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type OrderUserFilter = {
  email?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type OrganizationBrandAppearance = {
  landscapeLogo?: Maybe<Media>;
  squareLogo?: Maybe<Media>;
};

export type OrganizationBrandAppearanceInput = {
  landscapeLogo?: InputMaybe<Scalars['ID']['input']>;
  squareLogo?: InputMaybe<Scalars['ID']['input']>;
};

export type OrganizationOwnersInput = {
  userIds: Array<Scalars['ID']['input']>;
};

export type PageInfo = {
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']['output']>;
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Permission = {
  action?: Maybe<Scalars['String']['output']>;
  /** Get Permission Dependencies */
  dependencies?: Maybe<Array<Maybe<Permission>>>;
  description?: Maybe<Scalars['String']['output']>;
  /** Get Permission Grops to create View Tree */
  groups?: Maybe<Array<Maybe<Permission>>>;
  hidden: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use `action` instead. */
  permission?: Maybe<Scalars['String']['output']>;
  resource?: Maybe<Scalars['String']['output']>;
  sorting: Scalars['Int']['output'];
};

export type Permission_V2 = {
  action: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  resource: Scalars['String']['output'];
};

export type PingInput = {
  name: Scalars['String']['input'];
};

export type PingResult = {
  reply: Scalars['String']['output'];
};

export type Potential = {
  ai?: Maybe<Scalars['Long']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type PotentialByCode = {
  ai?: Maybe<Scalars['Long']['output']>;
  code?: Maybe<Scalars['String']['output']>;
};

export type PotentialByCodes = {
  ai?: Maybe<Scalars['Long']['output']>;
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PotentialCountryInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type PotentialCountryResponse = {
  total?: Maybe<PotentialByCodes>;
  type?: Maybe<PotentialType>;
};

export type PotentialFilter = {
  end?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['String']['input']>;
};

export type PotentialGroup = {
  name?: Maybe<Scalars['String']['output']>;
  potentials?: Maybe<Array<Maybe<Potential>>>;
  total?: Maybe<PotentialTotal>;
};

export type PotentialGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  zips: Array<Scalars['String']['input']>;
};

export type PotentialGroups = {
  groups?: Maybe<Array<Maybe<PotentialGroup>>>;
  potentials?: Maybe<Array<Maybe<Potential>>>;
  total?: Maybe<PotentialTotal>;
};

export type PotentialRegions = {
  potentials?: Maybe<Array<Maybe<PotentialByCode>>>;
  total?: Maybe<PotentialByCodes>;
};

export type PotentialRegionsAndGroupsResponse = {
  regions?: Maybe<PotentialRegions>;
  total?: Maybe<PotentialTotalRegional>;
  type?: Maybe<PotentialType>;
  zipGroups?: Maybe<PotentialGroups>;
};

export type PotentialResponse = {
  groups?: Maybe<Array<Maybe<PotentialGroup>>>;
  potentials?: Maybe<Array<Maybe<Potential>>>;
  total?: Maybe<PotentialTotal>;
  type?: Maybe<PotentialType>;
  zipGroups?: Maybe<PotentialGroups>;
};

export type PotentialTotal = {
  ai?: Maybe<Scalars['Long']['output']>;
  ais?: Maybe<Scalars['Long']['output']>;
  uniqueZips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type PotentialTotalRegional = {
  ai?: Maybe<Scalars['Long']['output']>;
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  uniqueZips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum PotentialType {
  Local = 'LOCAL',
  National = 'NATIONAL',
  Regional = 'REGIONAL'
}

export type Preview = {
  sites?: Maybe<Array<PreviewSite>>;
  themes?: Maybe<Array<Maybe<PreviewTheme>>>;
};


export type PreviewSitesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type PreviewThemesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};

export type PreviewSite = {
  active: Scalars['Boolean']['output'];
  country: Country;
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  /** Get assigned Image */
  image?: Maybe<Media>;
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type PreviewTheme = {
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Product = {
  ProductFamilyToReseller?: Maybe<Scalars['ID']['output']>;
  bookable?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Use budgetIdentification.calculation instead! */
  budgetCalculation?: Maybe<Scalars['String']['output']>;
  budgetIdentification?: Maybe<ProductIdentification>;
  channels?: Maybe<Array<Maybe<ProductChannel>>>;
  code?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  /** @deprecated will be removed */
  ctr?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Query on ProductVariant instead! */
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productBillingType?: Maybe<ProductBillingType>;
  productDeliveryChannel?: Maybe<ProductDeliveryChannel>;
  /** Change to type of ProductFamilyToReseller - TrafficBooster (ForeignKey to ProductFamily removed) */
  productFamily?: Maybe<ProductFamilyToReseller>;
  productFunnel?: Maybe<ProductFunnel>;
  productGeoTarget?: Maybe<ProductGeoTarget>;
  productGuarantees?: Maybe<Array<Maybe<ProductGuarantee>>>;
  productIdentifications?: Maybe<Array<Maybe<ProductIdentification>>>;
  productTargetings?: Maybe<Array<Maybe<ProductTargeting>>>;
  productVisibilityMetrics?: Maybe<Array<Maybe<ProductVisibilityMetric>>>;
  publisherAdPlacementTypes?: Maybe<Array<Maybe<ProductPublisherAdPlacementType>>>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  reseller?: Maybe<Reseller>;
  salesPrice?: Maybe<Scalars['Float']['output']>;
  settings?: Maybe<Scalars['JSON']['output']>;
  targetDeviceGroup?: Maybe<TargetDeviceGroup>;
};

export enum ProductAdSlotType {
  Hpa = 'HPA',
  Mobile = 'MOBILE',
  Sitebar = 'SITEBAR'
}

export type ProductBillingType = {
  code?: Maybe<Scalars['ID']['output']>;
  factor?: Maybe<Scalars['Float']['output']>;
  frequencyCappingType?: Maybe<Scalars['String']['output']>;
  fulfillmentType?: Maybe<Scalars['String']['output']>;
};

export type ProductBillingTypeConnection = {
  edges?: Maybe<Array<Maybe<ProductBillingTypeEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductBillingTypeEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductBillingType>;
};

export type ProductBillingTypeFilter = {
  OR?: InputMaybe<Array<ProductBillingTypeFilter>>;
  code?: InputMaybe<StringFilter>;
  factor?: InputMaybe<NumberFilter>;
  frequencyCappingType?: InputMaybe<StringFilter>;
  fulfillmentType?: InputMaybe<StringFilter>;
};

export type ProductChannel = {
  calculations?: Maybe<Array<Maybe<ProductChannelCalculation>>>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductChannelCalculation = {
  calculation?: Maybe<Scalars['String']['output']>;
  targetDeviceGroup?: Maybe<Scalars['String']['output']>;
};

export type ProductChannelChannelFilter = {
  equals?: InputMaybe<Scalars['ID']['input']>;
};

export type ProductChannelConnection = {
  edges?: Maybe<Array<Maybe<ProductChannelEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductChannelEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductChannel>;
};

export type ProductChannelFilter = {
  /** Filter by channel ID (only equals is supported) */
  channel?: InputMaybe<ProductChannelChannelFilter>;
};

export type ProductConnection = {
  edges?: Maybe<Array<Maybe<ProductEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductDeliveryChannel = {
  code?: Maybe<Scalars['ID']['output']>;
  minimumBookingVolume?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductDeliveryChannelByFilteredProductsConnection = {
  edges?: Maybe<Array<Maybe<ProductDeliveryChannelEdge>>>;
};

export type ProductDeliveryChannelConnection = {
  edges?: Maybe<Array<Maybe<ProductDeliveryChannelEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export enum ProductDeliveryChannelEnum {
  Rb = 'RB',
  Roc = 'ROC',
  Ron = 'RON'
}

export type ProductDeliveryChannelEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductDeliveryChannel>;
};

export type ProductDeliveryChannelFilter = {
  OR?: InputMaybe<Array<ProductDeliveryChannelFilter>>;
  code?: InputMaybe<StringFilter>;
  minimumBookingVolume?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductDeliveryChannelFilterByFilteredProducts = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  productFamily: ProductFamilyByFilteredProductsFilter;
  productFunnelCode: Scalars['String']['input'];
  targetDeviceGroupCode: Scalars['String']['input'];
};

export type ProductDeliveryChannelMutation = {
  create: ProductDeliveryChannel;
  update: ProductDeliveryChannel;
};


export type ProductDeliveryChannelMutationCreateArgs = {
  data: CreateProductDeliveryChannelInput;
};


export type ProductDeliveryChannelMutationUpdateArgs = {
  data: UpdateProductDeliveryChannelInput;
};

export type ProductEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Product>;
};

export type ProductFamiliesToResellerFilterByFilteredProducts = {
  allowDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
};

export type ProductFamily = {
  code?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalCreatives?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  /** customer specified short name to be displayed instead of code */
  shortName?: Maybe<Scalars['String']['output']>;
};


export type ProductFamilyProductVariantsArgs = {
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};

export type ProductFamilyByFilteredProductsFilter = {
  allowDeprecated?: InputMaybe<Scalars['Boolean']['input']>;
  code: Scalars['String']['input'];
};

export type ProductFamilyConnection = {
  edges?: Maybe<Array<Maybe<ProductFamilyEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductFamilyEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductFamily>;
};

export type ProductFamilyFilter = {
  OR?: InputMaybe<Array<ProductFamilyFilter>>;
  code?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<StringFilter>;
  externalCreatives?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  reseller?: InputMaybe<ResellerFilter>;
};

export type ProductFamilyInput = {
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSelectAll?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductFamilyMutation = {
  copy: Scalars['Boolean']['output'];
  create: ProductFamily;
  delete: Scalars['Boolean']['output'];
  update: ProductFamily;
};


export type ProductFamilyMutationCopyArgs = {
  data: CopyProductFamilyInput;
};


export type ProductFamilyMutationCreateArgs = {
  data: CreateProductFamilyInput;
};


export type ProductFamilyMutationDeleteArgs = {
  code: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  reseller?: InputMaybe<Scalars['ID']['input']>;
};


export type ProductFamilyMutationUpdateArgs = {
  data: UpdateProductFamilyInput;
};

export type ProductFamilyToReseller = {
  ProductFamilyCode?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  externalCreatives?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  /** customer specified short name to be displayed instead of code */
  shortName?: Maybe<Scalars['String']['output']>;
};

export type ProductFamilyToResellerByFilteredProductsConnection = {
  edges?: Maybe<Array<Maybe<ProductFamilyToResellerEdge>>>;
};

export type ProductFamilyToResellerConnection = {
  edges?: Maybe<Array<Maybe<ProductFamilyToResellerEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductFamilyToResellerEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductFamilyToReseller>;
};

export type ProductFamilyType = {
  codes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isSelectAll?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductFilter = {
  OR?: InputMaybe<Array<ProductFilter>>;
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  budgetIdentification?: InputMaybe<ProductIdentificationFilter>;
  channels?: InputMaybe<ProductChannelFilter>;
  code?: InputMaybe<StringFilter>;
  country?: InputMaybe<CountryFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  productBillingType?: InputMaybe<ProductBillingTypeFilter>;
  productDeliveryChannel?: InputMaybe<ProductDeliveryChannelFilter>;
  productFamily?: InputMaybe<ProductFamilyFilter>;
  productFunnel?: InputMaybe<ProductFunnelFilter>;
  productGeoTarget?: InputMaybe<ProductGeoTargetFilter>;
  purchasePrice?: InputMaybe<NumberFilter>;
  reseller?: InputMaybe<ResellerFilter>;
  salesPrice?: InputMaybe<NumberFilter>;
  targetDeviceGroup?: InputMaybe<TargetDeviceGroupFilter>;
};

export type ProductFunnel = {
  billingType?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['ID']['output']>;
  factor?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type ProductFunnelByFilteredProductsConnection = {
  edges?: Maybe<Array<Maybe<ProductFunnelEdge>>>;
};

export type ProductFunnelConnection = {
  edges?: Maybe<Array<Maybe<ProductFunnelEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductFunnelEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductFunnel>;
};

export type ProductFunnelFilter = {
  OR?: InputMaybe<Array<ProductFunnelFilter>>;
  billingType?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductFunnelMutation = {
  create: ProductFunnel;
  update: ProductFunnel;
};


export type ProductFunnelMutationCreateArgs = {
  data: CreateProductFunnelInput;
};


export type ProductFunnelMutationUpdateArgs = {
  data: UpdateProductFunnelInput;
};

export type ProductFunnelsByFilteredProductsFilter = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  productFamily: ProductFamilyByFilteredProductsFilter;
};

export type ProductGeoTarget = {
  code?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  product?: Maybe<Product>;
};

export type ProductGeoTargetByFilteredProductsConnection = {
  edges?: Maybe<Array<Maybe<ProductGeoTargetEdge>>>;
};

export type ProductGeoTargetConnection = {
  edges?: Maybe<Array<Maybe<ProductGeoTargetEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductGeoTargetEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductGeoTarget>;
};

export type ProductGeoTargetFilter = {
  OR?: InputMaybe<Array<ProductGeoTargetFilter>>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductGeoTargetMutation = {
  create: ProductGeoTarget;
  update: ProductGeoTarget;
};


export type ProductGeoTargetMutationCreateArgs = {
  data: CreateProductGeoTargetInput;
};


export type ProductGeoTargetMutationUpdateArgs = {
  data: UpdateProductGeoTargetInput;
};

export type ProductGeoTargetsFilterByFilteredProducts = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  productDeliveryChannelCode: Scalars['String']['input'];
  productFamily: ProductFamilyByFilteredProductsFilter;
  productFunnelCode: Scalars['String']['input'];
  targetDeviceGroupCode: Scalars['String']['input'];
};

export type ProductGuarantee = {
  code?: Maybe<Scalars['ID']['output']>;
  discountable?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  precision?: Maybe<Scalars['Int']['output']>;
  roundType?: Maybe<Scalars['String']['output']>;
  unit?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ProductGuaranteeConnection = {
  edges?: Maybe<Array<Maybe<ProductGuaranteeEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductGuaranteeEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductGuarantee>;
};

export type ProductGuaranteeFilter = {
  OR?: InputMaybe<Array<ProductGuaranteeFilter>>;
  code?: InputMaybe<StringFilter>;
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<StringFilter>;
};

export type ProductGuaranteeInput = {
  code: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export type ProductGuaranteeMutation = {
  create: ProductGuarantee;
  delete: Scalars['Boolean']['output'];
  update: ProductGuarantee;
};


export type ProductGuaranteeMutationCreateArgs = {
  data: CreateProductGuaranteeInput;
};


export type ProductGuaranteeMutationDeleteArgs = {
  code: Scalars['ID']['input'];
};


export type ProductGuaranteeMutationUpdateArgs = {
  data: UpdateProductGuaranteeInput;
};

export type ProductIdentification = {
  calculation?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  precision?: Maybe<Scalars['Int']['output']>;
  roundType?: Maybe<Scalars['String']['output']>;
};

export type ProductIdentificationConnection = {
  edges?: Maybe<Array<Maybe<ProductIdentificationEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductIdentificationEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductIdentification>;
};

export type ProductIdentificationFilter = {
  OR?: InputMaybe<Array<ProductIdentificationFilter>>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductIdentificationInput = {
  calculation: Scalars['String']['input'];
  code: Scalars['ID']['input'];
};

export type ProductIdentificationMutation = {
  create: ProductIdentification;
  update: ProductIdentification;
};


export type ProductIdentificationMutationCreateArgs = {
  data: CreateProductIdentificationInput;
};


export type ProductIdentificationMutationUpdateArgs = {
  data: UpdateProductIdentificationInput;
};

export type ProductMutation = {
  copy: Scalars['Boolean']['output'];
  create: Product;
  delete: Scalars['Boolean']['output'];
  update: Product;
};


export type ProductMutationCopyArgs = {
  data: CopyProductInput;
};


export type ProductMutationCreateArgs = {
  data: CreateProductInput;
};


export type ProductMutationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type ProductMutationUpdateArgs = {
  data: UpdateProductInput;
};

export type ProductPublisherAdPlacementType = {
  code?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<Scalars['String']['output']>;
  targetDevice?: Maybe<TargetDevice>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProductPublisherAdPlacementTypeInput = {
  code: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  targetDevice: Scalars['ID']['input'];
};

export enum ProductTargetDeviceType {
  Desktop = 'DESKTOP',
  Mobile = 'MOBILE',
  Multi = 'MULTI',
  Tablet = 'TABLET'
}

export type ProductTargeting = {
  code?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
  purchasePrice?: Maybe<Scalars['Float']['output']>;
  salesPrice?: Maybe<Scalars['Float']['output']>;
};

export type ProductTargetingConnection = {
  edges?: Maybe<Array<Maybe<ProductTargetingEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductTargetingEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductTargeting>;
};

export type ProductTargetingFilter = {
  OR?: InputMaybe<Array<ProductTargetingFilter>>;
  code?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  priority?: InputMaybe<NumberFilter>;
};

export type ProductTargetingInput = {
  code: Scalars['ID']['input'];
  purchasePrice: Scalars['Float']['input'];
  salesPrice: Scalars['Float']['input'];
};

export type ProductVariant = {
  code?: Maybe<Scalars['ID']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  deprecated?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  grids?: Maybe<Array<Maybe<Grid>>>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publisherAdPlacementTypes?: Maybe<Array<Maybe<ProductVariantPublisherAdPlacementType>>>;
  /** @deprecated Use code instead! */
  shortname?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantConnection = {
  edges?: Maybe<Array<Maybe<ProductVariantEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductVariantEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductVariant>;
};

export type ProductVariantFilter = {
  OR?: InputMaybe<Array<ProductVariantFilter>>;
  code?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  reseller?: InputMaybe<ResellerFilter>;
};

export type ProductVariantInput = {
  code: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Required if creating default product variants */
  publisherAdPlacementTypes?: InputMaybe<Array<ProductVariantPublisherAdPlacementTypeInput>>;
};

export type ProductVariantPublisherAdPlacementType = {
  code?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetDevice?: Maybe<TargetDevice>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type ProductVariantPublisherAdPlacementTypeInput = {
  code: Scalars['ID']['input'];
  icon?: InputMaybe<Scalars['String']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewHeight: Scalars['Int']['input'];
  previewWidth: Scalars['Int']['input'];
  targetDevice: Scalars['ID']['input'];
};

export type ProductVisibilityMetric = {
  code?: Maybe<Scalars['ID']['output']>;
  defaultOption?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  selectedOption?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductVisibilityMetricConnection = {
  edges?: Maybe<Array<Maybe<ProductVisibilityMetricEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type ProductVisibilityMetricEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<ProductVisibilityMetric>;
};

export type ProductVisibilityMetricFilter = {
  OR?: InputMaybe<Array<ProductVisibilityMetricFilter>>;
  code?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
};

export type ProductVisibilityMetricInput = {
  id: Scalars['ID']['input'];
  selectedOption: Scalars['Boolean']['input'];
};

export type ProductVisibilityMetricMutation = {
  create: ProductVisibilityMetric;
  delete: Scalars['Boolean']['output'];
  update: ProductVisibilityMetric;
};


export type ProductVisibilityMetricMutationCreateArgs = {
  data: CreateProductVisibilityMetricInput;
};


export type ProductVisibilityMetricMutationDeleteArgs = {
  id: Scalars['ID']['input'];
};


export type ProductVisibilityMetricMutationUpdateArgs = {
  data: UpdateProductVisibilityMetricInput;
};

export type PropertiesFilter = {
  age0To19?: InputMaybe<BigIntFilter>;
  age0To19SharePct?: InputMaybe<IntFilter>;
  age20To34?: InputMaybe<BigIntFilter>;
  age20To34SharePct?: InputMaybe<IntFilter>;
  age35To44?: InputMaybe<BigIntFilter>;
  age35To44SharePct?: InputMaybe<IntFilter>;
  age45To59?: InputMaybe<BigIntFilter>;
  age45To59SharePct?: InputMaybe<IntFilter>;
  age60Plus?: InputMaybe<BigIntFilter>;
  age60PlusSharePct?: InputMaybe<IntFilter>;
  ageAvg?: InputMaybe<IntFilter>;
  aiPotential?: InputMaybe<BigIntFilter>;
  and?: InputMaybe<Array<PropertiesFilter>>;
  areaKm2?: InputMaybe<FloatFilter>;
  digitalSharePct?: InputMaybe<IntFilter>;
  household1?: InputMaybe<IntFilter>;
  household1SharePct?: InputMaybe<IntFilter>;
  household2?: InputMaybe<IntFilter>;
  household2SharePct?: InputMaybe<IntFilter>;
  household3?: InputMaybe<IntFilter>;
  household3SharePct?: InputMaybe<IntFilter>;
  household4?: InputMaybe<IntFilter>;
  household4SharePct?: InputMaybe<IntFilter>;
  household5Plus?: InputMaybe<IntFilter>;
  household5PlusSharePct?: InputMaybe<IntFilter>;
  households?: InputMaybe<IntFilter>;
  householdsCountryRatio?: InputMaybe<IntFilter>;
  householdsWeightedAvg?: InputMaybe<IntFilter>;
  householdsWithKids?: InputMaybe<IntFilter>;
  householdsWithKidsSharePct?: InputMaybe<IntFilter>;
  householdsWithoutKids?: InputMaybe<IntFilter>;
  householdsWithoutKidsSharePct?: InputMaybe<IntFilter>;
  houses?: InputMaybe<IntFilter>;
  housesWith1or2FamiliesAndGarden?: InputMaybe<IntFilter>;
  housesWith1or2FamiliesAndGardenSharePct?: InputMaybe<IntFilter>;
  newBorn?: InputMaybe<IntFilter>;
  not?: InputMaybe<PropertiesFilter>;
  or?: InputMaybe<Array<PropertiesFilter>>;
  population?: InputMaybe<BigIntFilter>;
  populationDensity?: InputMaybe<FloatFilter>;
  printSharePct?: InputMaybe<IntFilter>;
  purchasePower15kTo25k?: InputMaybe<IntFilter>;
  purchasePower15kTo25kSharePct?: InputMaybe<IntFilter>;
  purchasePower25kTo40k?: InputMaybe<IntFilter>;
  purchasePower25kTo40kSharePct?: InputMaybe<IntFilter>;
  purchasePower40kTo60k?: InputMaybe<IntFilter>;
  purchasePower40kTo60kSharePct?: InputMaybe<IntFilter>;
  purchasePowerAbove60k?: InputMaybe<IntFilter>;
  purchasePowerAbove60kSharePct?: InputMaybe<IntFilter>;
  purchasePowerBelow15k?: InputMaybe<IntFilter>;
  purchasePowerBelow15kSharePct?: InputMaybe<IntFilter>;
  purchasePowerCountryRatio?: InputMaybe<IntFilter>;
  purchasePowerWeightedAvg?: InputMaybe<IntFilter>;
};

export type Property = {
  age0To19?: Maybe<Scalars['Int']['output']>;
  age0To19SharePct?: Maybe<Scalars['Int']['output']>;
  age20To34?: Maybe<Scalars['Int']['output']>;
  age20To34SharePct?: Maybe<Scalars['Int']['output']>;
  age35To44?: Maybe<Scalars['Int']['output']>;
  age35To44SharePct?: Maybe<Scalars['Int']['output']>;
  age45To59?: Maybe<Scalars['Int']['output']>;
  age45To59SharePct?: Maybe<Scalars['Int']['output']>;
  age60Plus?: Maybe<Scalars['Int']['output']>;
  age60PlusSharePct?: Maybe<Scalars['Int']['output']>;
  ageAvg?: Maybe<Scalars['Int']['output']>;
  aiPotential?: Maybe<Scalars['BigInt']['output']>;
  areaKm2?: Maybe<Scalars['Float']['output']>;
  countryCode: Scalars['String']['output'];
  digitalSharePct?: Maybe<Scalars['Int']['output']>;
  household1?: Maybe<Scalars['Int']['output']>;
  household1SharePct?: Maybe<Scalars['Int']['output']>;
  household2?: Maybe<Scalars['Int']['output']>;
  household2SharePct?: Maybe<Scalars['Int']['output']>;
  household3?: Maybe<Scalars['Int']['output']>;
  household3SharePct?: Maybe<Scalars['Int']['output']>;
  household4?: Maybe<Scalars['Int']['output']>;
  household4SharePct?: Maybe<Scalars['Int']['output']>;
  household5Plus?: Maybe<Scalars['Int']['output']>;
  household5PlusSharePct?: Maybe<Scalars['Int']['output']>;
  households?: Maybe<Scalars['Int']['output']>;
  householdsCountryRatio?: Maybe<Scalars['Int']['output']>;
  householdsWeightedAvg?: Maybe<Scalars['Int']['output']>;
  householdsWithKids?: Maybe<Scalars['Int']['output']>;
  householdsWithKidsSharePct?: Maybe<Scalars['Int']['output']>;
  householdsWithoutKids?: Maybe<Scalars['Int']['output']>;
  householdsWithoutKidsSharePct?: Maybe<Scalars['Int']['output']>;
  houses?: Maybe<Scalars['Int']['output']>;
  housesWith1or2FamiliesAndGarden?: Maybe<Scalars['Int']['output']>;
  housesWith1or2FamiliesAndGardenSharePct?: Maybe<Scalars['Int']['output']>;
  id: Scalars['UUID']['output'];
  newBorn?: Maybe<Scalars['Int']['output']>;
  population?: Maybe<Scalars['BigInt']['output']>;
  populationDensity?: Maybe<Scalars['Float']['output']>;
  printSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePower15kTo25k?: Maybe<Scalars['Int']['output']>;
  purchasePower15kTo25kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePower25kTo40k?: Maybe<Scalars['Int']['output']>;
  purchasePower25kTo40kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePower40kTo60k?: Maybe<Scalars['Int']['output']>;
  purchasePower40kTo60kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePowerAbove60k?: Maybe<Scalars['Int']['output']>;
  purchasePowerAbove60kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePowerBelow15k?: Maybe<Scalars['Int']['output']>;
  purchasePowerBelow15kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePowerCountryRatio?: Maybe<Scalars['Int']['output']>;
  purchasePowerWeightedAvg?: Maybe<Scalars['Int']['output']>;
};

export type Publisher = {
  country?: Maybe<Country>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  publisherAdPlacements?: Maybe<Array<Maybe<PublisherAdPlacement>>>;
  publisherId?: Maybe<Scalars['ID']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
};

export type PublisherAdPlacement = {
  cpm?: Maybe<Scalars['Float']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  productFamily?: Maybe<ProductFamilyType>;
  publisher?: Maybe<Publisher>;
  publisherAdPlacementType?: Maybe<PublisherAdPlacementType>;
  publisherWebsite?: Maybe<PublisherWebsite>;
  sorting?: Maybe<Scalars['Int']['output']>;
  targetDevice?: Maybe<TargetDevice>;
  website_id?: Maybe<Scalars['Int']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type PublisherAdPlacementConnection = {
  edges?: Maybe<Array<Maybe<PublisherAdPlacementEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PublisherAdPlacementEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PublisherAdPlacement>;
};

export type PublisherAdPlacementFilter = {
  OR?: InputMaybe<Array<PublisherAdPlacementFilter>>;
  cpm?: InputMaybe<NumberFilter>;
  deletedAt?: InputMaybe<DateFilter>;
  height?: InputMaybe<NumberFilter>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  publisher?: InputMaybe<PublisherFilter>;
  publisherAdPlacementType?: InputMaybe<StringFilter>;
  publisherWebsite?: InputMaybe<PublisherWebsiteFilter>;
  specification?: InputMaybe<StringFilter>;
  targetDevice?: InputMaybe<StringFilter>;
  website_id?: InputMaybe<NumberFilter>;
  width?: InputMaybe<NumberFilter>;
};

export type PublisherAdPlacementMutation = {
  create: PublisherAdPlacement;
  delete: Scalars['Boolean']['output'];
  update: PublisherAdPlacement;
};


export type PublisherAdPlacementMutationCreateArgs = {
  data: CreatePublisherAdPlacementInput;
};


export type PublisherAdPlacementMutationDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PublisherAdPlacementMutationUpdateArgs = {
  data: UpdatePublisherAdPlacementInput;
};

export type PublisherAdPlacementType = {
  code?: Maybe<Scalars['ID']['output']>;
  height?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['Int']['output']>;
};

export type PublisherAdPlacementTypeConnection = {
  edges?: Maybe<Array<Maybe<PublisherAdPlacementTypeEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PublisherAdPlacementTypeEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PublisherAdPlacementType>;
};

export type PublisherAdPlacementTypeFilter = {
  OR?: InputMaybe<Array<PublisherAdPlacementTypeFilter>>;
  code?: InputMaybe<StringFilter>;
  height?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  specification?: InputMaybe<StringFilter>;
  width?: InputMaybe<NumberFilter>;
};

export type PublisherAdPlacementTypeMutation = {
  create: PublisherAdPlacementType;
  update: PublisherAdPlacementType;
};


export type PublisherAdPlacementTypeMutationCreateArgs = {
  data: CreatePublisherAdPlacementTypeInput;
};


export type PublisherAdPlacementTypeMutationUpdateArgs = {
  data: UpdatePublisherAdPlacementTypeInput;
};

export type PublisherConnection = {
  edges?: Maybe<Array<Maybe<PublisherEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PublisherEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Publisher>;
};

export type PublisherFilter = {
  OR?: InputMaybe<Array<PublisherFilter>>;
  country?: InputMaybe<NumberFilter>;
  countryCode?: InputMaybe<StringFilter>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<NumberFilter>;
  name?: InputMaybe<StringFilter>;
  publisherId?: InputMaybe<NumberFilter>;
};

export type PublisherMutation = {
  create: Publisher;
  delete: Scalars['Boolean']['output'];
  update: Publisher;
};


export type PublisherMutationCreateArgs = {
  data: CreatePublisherInput;
};


export type PublisherMutationDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type PublisherMutationUpdateArgs = {
  data: UpdatePublisherInput;
};

export type PublisherSiteList = {
  countryCode?: Maybe<Scalars['String']['output']>;
  domains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  publisherId?: Maybe<Scalars['Int']['output']>;
  publisherName?: Maybe<Scalars['String']['output']>;
};

export type PublisherSiteListAdPlacementFilter = {
  publisherAdPlacementTypeCode: Scalars['String']['input'];
  targetDeviceCode: Scalars['String']['input'];
};

export type PublisherSiteListFilter = {
  blacklist?: InputMaybe<Array<Scalars['String']['input']>>;
  channel?: InputMaybe<Scalars['ID']['input']>;
  countryCode?: InputMaybe<StringFilter>;
  productFamilyCode?: InputMaybe<Scalars['String']['input']>;
  publisherAdPlacements?: InputMaybe<Array<PublisherSiteListAdPlacementFilter>>;
  publisherId: NumberFilter;
  whitelist?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type PublisherWebsite = {
  alias?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  channels?: Maybe<Array<Maybe<ChannelWithoutCalculation>>>;
  domain?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  productFamily?: Maybe<ProductFamilyType>;
  publisherId?: Maybe<Scalars['Int']['output']>;
  sorting?: Maybe<Scalars['Int']['output']>;
  targetings?: Maybe<Array<Maybe<PublisherWebsiteTargeting>>>;
};

export type PublisherWebsiteConnection = {
  edges?: Maybe<Array<Maybe<PublisherWebsiteEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type PublisherWebsiteEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<PublisherWebsite>;
};

export type PublisherWebsiteFilter = {
  OR?: InputMaybe<Array<PublisherWebsiteFilter>>;
  channels?: InputMaybe<NumberFilter>;
  domain?: InputMaybe<StringFilter>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<NumberFilter>;
};

export type PublisherWebsiteMutation = {
  create: PublisherWebsite;
  update: PublisherWebsite;
};


export type PublisherWebsiteMutationCreateArgs = {
  data: CreatePublisherWebsiteInput;
};


export type PublisherWebsiteMutationUpdateArgs = {
  data: UpdatePublisherWebsiteInput;
};

export type PublisherWebsiteTargeting = {
  code?: Maybe<Scalars['ID']['output']>;
  focus?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

export type PublisherWebsiteTargetingInput = {
  code: Scalars['ID']['input'];
  focus?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  account?: Maybe<Account>;
  accountObjects?: Maybe<Array<Maybe<AccountObject>>>;
  accounts?: Maybe<AccountEdges>;
  acl?: Maybe<AclQuery>;
  address?: Maybe<AddressQuery>;
  bookingDefault?: Maybe<BookingDefault>;
  campaign?: Maybe<Campaign>;
  campaignBaseData?: Maybe<CampaignBaseData>;
  campaignBaseDataExternalPreview?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternalPreview>>>;
  /** @deprecated Use campaign.deployments instead. */
  campaignDeployment?: Maybe<CampaignDeployment>;
  campaigns?: Maybe<Array<Maybe<Campaign>>>;
  campaignsBaseData?: Maybe<CampaignsBaseDataConnection>;
  channels?: Maybe<ChannelConnection>;
  components?: Maybe<Array<Maybe<Component>>>;
  contact?: Maybe<Contact>;
  contacts?: Maybe<ContactEdges>;
  countries?: Maybe<CountryConnection>;
  creative?: Maybe<Creative>;
  creativeInternal?: Maybe<CampaignBaseDataCreativeInternal>;
  creatives?: Maybe<CreativeConnection>;
  creativesInternal?: Maybe<Array<Maybe<CampaignBaseDataCreativeInternal>>>;
  customRoles: CustomRolesPage;
  /** Returns the total values grouped by advertising space */
  elasticsAdvertisingSpaceDayPerformance?: Maybe<ElasticsReportAdvertisingSpaceDayPerformance>;
  /** Retrieves the daily values grouped by ad slot or target device */
  elasticsAdvertisingSpacePerformance?: Maybe<Array<Maybe<ElasticsReportAdvertisingSpacePerformance>>>;
  /**
   * Returns the Ad Impressions and total number of linkouts per branch
   * @deprecated Use Top Branch instead
   */
  elasticsDayBranchLinkouts?: Maybe<Array<Maybe<ElasticsReportDayBranchLinkouts>>>;
  /** Returns the daily values */
  elasticsDayPerformance?: Maybe<Array<Maybe<ElasticsReportDayPerformance>>>;
  /**
   * Returns the daily values for video products like Biva.
   * Note: The data is based on triggers; however, the result shows them as events
   */
  elasticsDayPerformanceBiva?: Maybe<Array<Maybe<ElasticsDayPerformanceBiva>>>;
  /** Returns the daily values for the product SA. */
  elasticsDayPerformanceSa?: Maybe<Array<Maybe<ElasticsDayPerformanceSa>>>;
  /** This query returns DoubleVerify viewability metrics */
  elasticsDoubleVerify?: Maybe<ElasticsReportDoubleVerify>;
  /** Returns interaction statistics per trigger including scroll, hover, click and linkout counts */
  elasticsInteractionsPerTrigger: Array<ElasticsReportInteractionsPerTrigger>;
  /**
   * Similar to topBranch but only for total Linkouts and unique Linkouts
   * @deprecated Use elasticsTopBranch
   */
  elasticsLinkoutsByBranch?: Maybe<Array<Maybe<ElasticsReportLinkoutsByBranch>>>;
  /** Returns a list of the branch events grouped by trigger */
  elasticsMyBranch?: Maybe<Array<Maybe<ElasticsReportMyBranch>>>;
  /** Shows a list of publishers and how the billable interactions split on them */
  elasticsPublisherPerformance?: Maybe<Array<Maybe<ElasticsReportPublisherPerformance>>>;
  /** Returns the total values for all branches */
  elasticsTopBranch?: Maybe<Array<Maybe<ElasticsReportTopBranch>>>;
  /** Returns all events for triggers which start with `header-breadcrumb_` */
  elasticsTopBreadcrumb?: Maybe<Array<Maybe<ElasticsReportTopBreadcrumb>>>;
  /** Returns a list of components with the recorded events and linkouts */
  elasticsTopComponent?: Maybe<Array<Maybe<ElasticsReportTopComponent>>>;
  /** Returns all interactions which have the trigger `app-flyoutMenu` or `app-flyoutMenu_link` and meta.label must be set */
  elasticsTopFlyoutMenu?: Maybe<Array<Maybe<ElasticsFlyoutMenu>>>;
  /** Lists Ad Impressions and Cicks per website (Adserver only) */
  elasticsTopHomepage?: Maybe<Array<Maybe<ElasticsReportTopHomepage>>>;
  /** Lists all events which start with trigger `header-mainMenu` */
  elasticsTopMainMenu?: Maybe<Array<Maybe<ElasticsReportTopMainMenu>>>;
  /** Lists all campaign products and their events */
  elasticsTopProduct?: Maybe<Array<Maybe<ElasticsReportTopProduct>>>;
  /** Lists the search terms and if they were found or not */
  elasticsTopSearch?: Maybe<ElasticsReportTopSearch>;
  /** Lists the events per stage. Views are only with empty trigger and payout = 0. Click and Hover need to have payout = 1 */
  elasticsTopStage?: Maybe<Array<Maybe<ElasticsReportTopStage>>>;
  /**
   * Returns a list of components and their triggers. Condition is that the trigger starts with the given section and includes `-` after the section.
   * Used to get total values for header and footer components
   */
  elasticsTopTrigger?: Maybe<Array<Maybe<ElasticsReportTopTrigger>>>;
  /** Returns the total values for all triggers starting with `content-vastVideo_` */
  elasticsTotalBiva?: Maybe<ElasticsReportTotalBiva>;
  /** This query returns the total values for all components that have triggers starting with `content-` */
  elasticsTotalContent?: Maybe<ElasticsReportTotalContent>;
  /** This query returns the total values for certain events */
  elasticsTotalEvent?: Maybe<ElasticsReportTotalEvents>;
  /** @deprecated implementation already removed */
  elasticsTotalSocialIconsBar?: Maybe<Array<Maybe<ElasticsReportTotalSocialIconsBar>>>;
  /** This query returns the number of average user interactions */
  elasticsUserEvent?: Maybe<ElasticsReportUserEvents>;
  /**
   * This query returns the number of average user scrolls
   * @deprecated No longer supported
   */
  elasticsUserScroll?: Maybe<ElasticsReportUserScrolls>;
  /** This query returns the average duration of a users visit */
  elasticsVisitDuration?: Maybe<ElasticsReportVisitDuration>;
  fileTree?: Maybe<FileTree>;
  geoArea?: Maybe<AreasGeoData>;
  geoAreaById?: Maybe<AreasGeoData>;
  geoAreas: Array<Maybe<AreasGeoData>>;
  geoBoundingBoxByZips?: Maybe<BoundingBox>;
  geoCountry?: Maybe<CountriesGeoData>;
  geoGroupCenterByZips?: Maybe<Coordinate>;
  geoRegion?: Maybe<RegionsGeoData>;
  geoRegionById?: Maybe<RegionsGeoData>;
  geoRegions: Array<Maybe<RegionsGeoData>>;
  geoZip?: Maybe<ZipsGeoData>;
  geoZipById?: Maybe<ZipsGeoData>;
  geoZipInsightsByGroups: Array<GroupedGeoZipInsights>;
  geoZipPropertyAggregates?: Maybe<ZipPropertyAggregates>;
  geoZips: Array<Maybe<ZipsGeoData>>;
  geoZipsByBoundingBox: Array<Maybe<ZipsGeoData>>;
  geoZipsByCountry: Array<Maybe<ZipsGeoData>>;
  geoZipsByGroupedRadius: Array<ZipsGroupedByRadius>;
  geoZipsByProperties: Array<Maybe<ZipsGeoData>>;
  geoZipsByRange: Array<Maybe<ZipsGeoData>>;
  geoZipsPropertyMetricMap: Scalars['JSON']['output'];
  geocodeForward: Array<GeocodeResult>;
  geocodeReverse: Array<GeocodeResult>;
  /** Return CampaignDeployment and set state to RUNNING */
  getNextCampaignDeployment?: Maybe<CampaignDeployment>;
  getOrderReport?: Maybe<Array<Maybe<OrderReport>>>;
  import?: Maybe<Import>;
  importMappingStore?: Maybe<Array<Maybe<ImportMappingStore>>>;
  industrySectors?: Maybe<Array<Maybe<IndustrySectorType>>>;
  invitations: InvitationsPage;
  locationTemplates?: Maybe<LocationTemplateConnection>;
  /** Return self user data */
  me?: Maybe<User>;
  me_v2: User_V2;
  media?: Maybe<MediaEdges>;
  mediaFolders: MediaFoldersPage;
  mediumById?: Maybe<Media>;
  mediumByUuid?: Maybe<Media>;
  offerBudget: OfferBudget;
  offerLanguages: Array<OfferLanguage>;
  offerStates: Array<OfferState>;
  offerText?: Maybe<OfferTextConnection>;
  offers?: Maybe<OfferConnection>;
  order?: Maybe<Order>;
  /**
   * Paginatable list of orders supporting relay/edge cursored and
   * first/offset-pagination
   */
  orders?: Maybe<OrderConnection>;
  organizationBrandAppearance?: Maybe<OrganizationBrandAppearance>;
  permissions: Array<Permission_V2>;
  ping: PingResult;
  potential?: Maybe<PotentialResponse>;
  potentialCountry?: Maybe<PotentialCountryResponse>;
  potentialRegions?: Maybe<PotentialRegionsAndGroupsResponse>;
  preview?: Maybe<Preview>;
  productBillingTypes?: Maybe<ProductBillingTypeConnection>;
  productDeliveryChannels?: Maybe<ProductDeliveryChannelConnection>;
  productDeliveryChannelsByFilteredProducts?: Maybe<ProductDeliveryChannelByFilteredProductsConnection>;
  productFamilies?: Maybe<ProductFamilyConnection>;
  productFamiliesToReseller?: Maybe<ProductFamilyToResellerConnection>;
  productFamiliesToResellerByFilteredProducts?: Maybe<ProductFamilyToResellerByFilteredProductsConnection>;
  productFunnels?: Maybe<ProductFunnelConnection>;
  productFunnelsByFilteredProducts?: Maybe<ProductFunnelByFilteredProductsConnection>;
  productGeoTargets?: Maybe<ProductGeoTargetConnection>;
  productGeoTargetsByFilteredProducts?: Maybe<ProductGeoTargetByFilteredProductsConnection>;
  productGuarantees?: Maybe<ProductGuaranteeConnection>;
  productIdentifications?: Maybe<ProductIdentificationConnection>;
  productVariants?: Maybe<ProductVariantConnection>;
  productVisibilityMetrics?: Maybe<ProductVisibilityMetricConnection>;
  products?: Maybe<ProductConnection>;
  publisherAdPlacementTypes?: Maybe<PublisherAdPlacementTypeConnection>;
  publisherAdPlacements?: Maybe<PublisherAdPlacementConnection>;
  publisherSiteList?: Maybe<Array<PublisherSiteList>>;
  publisherWebsites?: Maybe<PublisherWebsiteConnection>;
  publishers?: Maybe<PublisherConnection>;
  radiusZipsCatchmentAreaById?: Maybe<RadiusZipsCatchmentArea>;
  /** Get a single report share link by its unique link key. */
  reportShareLinkByLinkKey?: Maybe<ReportShareLink>;
  /** List report share links matching the filter. */
  reportShareLinks: ReportShareLinkConnection;
  /** Get a single reseller/client account by its ID */
  reseller?: Maybe<Reseller>;
  /**
   * Paginatable list of orders supporting relay/edge cursored and
   * first/offset-pagination
   */
  resellers?: Maybe<ResellerConnection>;
  revenueTypes?: Maybe<Array<Maybe<AccountRevenueType>>>;
  storeById?: Maybe<Store>;
  stores: StoresPage;
  storesGroupById?: Maybe<StoresGroup>;
  storesGroups: StoresGroupsPage;
  tagById?: Maybe<Tag>;
  targetDeviceGroups?: Maybe<TargetDeviceGroupConnection>;
  targetDeviceGroupsByFilteredProducts?: Maybe<TargetDeviceGroupByFilteredProductsConnection>;
  targetDevices?: Maybe<TargetDeviceConnection>;
  user?: Maybe<User>;
  userRoles?: Maybe<Array<Maybe<UserRole>>>;
  user_v2?: Maybe<User_V2>;
  users?: Maybe<UserEdges>;
  users_v2: UsersPage;
};


export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAccountObjectsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryAccountsArgs = {
  contact?: InputMaybe<Scalars['SequelizeJSON']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryCampaignArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryCampaignBaseDataArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignBaseDataExternalPreviewArgs = {
  bundleHash: Scalars['String']['input'];
};


export type QueryCampaignDeploymentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCampaignsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryCampaignsBaseDataArgs = {
  filter?: InputMaybe<CampaignsBaseDataFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryChannelsArgs = {
  filter?: InputMaybe<ChannelFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryComponentsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<ComponentSectionType>;
  tags?: InputMaybe<Array<InputMaybe<ComponentTagType>>>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactsArgs = {
  account?: InputMaybe<Scalars['ID']['input']>;
  allContactsByAccount?: InputMaybe<Scalars['Boolean']['input']>;
  contactType?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  orderByBirthday?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryCountriesArgs = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  filter?: InputMaybe<CountryFilter>;
  hasBookableProducts?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryCreativeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreativeInternalArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCreativesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<CreativeOrderBy>>>;
};


export type QueryCreativesInternalArgs = {
  campaignId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Array<InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>>>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCustomRolesArgs = {
  input?: InputMaybe<CustomRolesInput>;
};


export type QueryElasticsAdvertisingSpaceDayPerformanceArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryElasticsAdvertisingSpacePerformanceArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsDayBranchLinkoutsArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryElasticsDayPerformanceArgs = {
  calculatePercentages?: InputMaybe<Scalars['Boolean']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsDayPerformanceBivaArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryElasticsDayPerformanceSaArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryElasticsDoubleVerifyArgs = {
  campaignBaseDataId: Scalars['ID']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryElasticsInteractionsPerTriggerArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
};


export type QueryElasticsLinkoutsByBranchArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsMyBranchArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsPublisherPerformanceArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopBranchArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopBreadcrumbArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopComponentArgs = {
  byBranch?: InputMaybe<Scalars['Boolean']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopFlyoutMenuArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryElasticsTopHomepageArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrderBy>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopMainMenuArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopProductArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopSearchArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopStageArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTopTriggerArgs = {
  byBranch?: InputMaybe<Scalars['Boolean']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
  section: ElasticsSection;
};


export type QueryElasticsTotalBivaArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTotalContentArgs = {
  byBranch?: InputMaybe<Scalars['Boolean']['input']>;
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTotalEventArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsTotalSocialIconsBarArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Array<InputMaybe<ElasticsEvent>>>;
  payout?: InputMaybe<Scalars['Int']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsUserEventArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsUserScrollArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  creativeId?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryElasticsVisitDurationArgs = {
  campaignBaseDataId?: InputMaybe<Scalars['ID']['input']>;
  campaignId: Scalars['ID']['input'];
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  reportingEngine?: InputMaybe<ReportingEngineEnum>;
};


export type QueryFileTreeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGeoAreaArgs = {
  areaCode: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
};


export type QueryGeoAreaByIdArgs = {
  id: Scalars['String']['input'];
};


export type QueryGeoAreasArgs = {
  countryCode: Scalars['String']['input'];
  filter: AreasFilter;
  orderBy?: InputMaybe<Array<AreasOrderByField>>;
};


export type QueryGeoBoundingBoxByZipsArgs = {
  countryCode: Scalars['String']['input'];
  zipCodes: Array<Scalars['String']['input']>;
};


export type QueryGeoCountryArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryGeoGroupCenterByZipsArgs = {
  countryCode: Scalars['String']['input'];
  zipCodes: Array<Scalars['String']['input']>;
};


export type QueryGeoRegionArgs = {
  countryCode: Scalars['String']['input'];
  regionCode: Scalars['String']['input'];
};


export type QueryGeoRegionByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGeoRegionsArgs = {
  countryCode: Scalars['String']['input'];
  filter: RegionsFilter;
};


export type QueryGeoZipArgs = {
  countryCode: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryGeoZipByIdArgs = {
  id: Scalars['UUID']['input'];
};


export type QueryGeoZipInsightsByGroupsArgs = {
  query: GroupedGeoZipInsightsQuery;
};


export type QueryGeoZipPropertyAggregatesArgs = {
  countryCode: Scalars['String']['input'];
  hasIpMapping?: InputMaybe<Scalars['Boolean']['input']>;
  zipCodes: Array<Scalars['String']['input']>;
};


export type QueryGeoZipsArgs = {
  countryCode: Scalars['String']['input'];
  filter: ZipsFilter;
  orderBy?: InputMaybe<Array<ZipsOrderByField>>;
};


export type QueryGeoZipsByBoundingBoxArgs = {
  boundingBox: BoundingBoxInput;
  countryCode: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<ZipsOrderByField>>;
};


export type QueryGeoZipsByCountryArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryGeoZipsByGroupedRadiusArgs = {
  query: GroupedRadiusQuery;
};


export type QueryGeoZipsByPropertiesArgs = {
  countryCode: Scalars['String']['input'];
  filter: ZipsByPropertiesFilter;
};


export type QueryGeoZipsByRangeArgs = {
  query: ZipsRangeFilter;
};


export type QueryGeoZipsPropertyMetricMapArgs = {
  countryCode: Scalars['String']['input'];
  filter: ZipsByPropertiesFilter;
  metric: Scalars['PropertyMetricKey']['input'];
};


export type QueryGeocodeForwardArgs = {
  forward: ForwardInput;
  options?: InputMaybe<GeocodeOptions>;
};


export type QueryGeocodeReverseArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  options?: InputMaybe<GeocodeOptions>;
};


export type QueryGetOrderReportArgs = {
  end: Scalars['String']['input'];
  groupBy?: InputMaybe<Scalars['String']['input']>;
  orderId: Scalars['String']['input'];
  start: Scalars['String']['input'];
};


export type QueryImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryImportMappingStoreArgs = {
  campaign?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<ImportMappingStoreType>;
};


export type QueryInvitationsArgs = {
  input?: InputMaybe<InvitationsInput>;
};


export type QueryLocationTemplatesArgs = {
  account?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<LocationTemplateOrderBy>>>;
};


export type QueryMediaArgs = {
  accountFromCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
};


export type QueryMediaFoldersArgs = {
  input: MediaFoldersInput;
};


export type QueryMediumByIdArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryMediumByUuidArgs = {
  uuid?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOfferBudgetArgs = {
  dateRange?: InputMaybe<OfferDateRange>;
  filter?: InputMaybe<OfferFilter>;
};


export type QueryOfferTextArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OfferTextFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryOffersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateRange?: InputMaybe<OfferDateRange>;
  filter?: InputMaybe<OfferFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OrderFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryPingArgs = {
  input: PingInput;
};


export type QueryPotentialArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PotentialFilter>;
  groups?: InputMaybe<Array<PotentialGroupInput>>;
};


export type QueryPotentialCountryArgs = {
  countryCode: Scalars['String']['input'];
  filter?: InputMaybe<PotentialFilter>;
};


export type QueryPotentialRegionsArgs = {
  countryCode: Scalars['String']['input'];
  filter?: InputMaybe<PotentialFilter>;
  groups?: InputMaybe<Array<InputMaybe<PotentialGroupInput>>>;
  regionCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductBillingTypesArgs = {
  filter?: InputMaybe<ProductBillingTypeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductDeliveryChannelsArgs = {
  filter?: InputMaybe<ProductDeliveryChannelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductDeliveryChannelsByFilteredProductsArgs = {
  filter?: InputMaybe<ProductDeliveryChannelFilterByFilteredProducts>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductFamiliesArgs = {
  filter?: InputMaybe<ProductFamilyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductFamiliesToResellerArgs = {
  filter?: InputMaybe<ProductFamilyFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductFamiliesToResellerByFilteredProductsArgs = {
  filter: ProductFamiliesToResellerFilterByFilteredProducts;
};


export type QueryProductFunnelsArgs = {
  filter?: InputMaybe<ProductFunnelFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductFunnelsByFilteredProductsArgs = {
  filter: ProductFunnelsByFilteredProductsFilter;
};


export type QueryProductGeoTargetsArgs = {
  filter?: InputMaybe<ProductGeoTargetFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductGeoTargetsByFilteredProductsArgs = {
  filter: ProductGeoTargetsFilterByFilteredProducts;
};


export type QueryProductGuaranteesArgs = {
  filter?: InputMaybe<ProductGuaranteeFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductIdentificationsArgs = {
  filter?: InputMaybe<ProductIdentificationFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductVariantsArgs = {
  filter?: InputMaybe<ProductVariantFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductVisibilityMetricsArgs = {
  filter?: InputMaybe<ProductVisibilityMetricFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryPublisherAdPlacementTypesArgs = {
  filter?: InputMaybe<PublisherAdPlacementTypeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryPublisherAdPlacementsArgs = {
  filter?: InputMaybe<PublisherAdPlacementFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryPublisherSiteListArgs = {
  filter: PublisherSiteListFilter;
};


export type QueryPublisherWebsitesArgs = {
  filter?: InputMaybe<PublisherWebsiteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryPublishersArgs = {
  filter?: InputMaybe<PublisherFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryRadiusZipsCatchmentAreaByIdArgs = {
  id: Scalars['UUID']['input'];
  options?: InputMaybe<FindOptionsInput>;
};


export type QueryReportShareLinkByLinkKeyArgs = {
  linkKey: Scalars['String']['input'];
};


export type QueryReportShareLinksArgs = {
  filter: ReportShareLinkFilter;
};


export type QueryResellerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryResellersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ResellerFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryStoreByIdArgs = {
  id: Scalars['UUID']['input'];
  options?: InputMaybe<FindOptionsInput>;
};


export type QueryStoresArgs = {
  input?: InputMaybe<StoresInput>;
};


export type QueryStoresGroupByIdArgs = {
  id: Scalars['UUID']['input'];
  options?: InputMaybe<FindOptionsInput>;
};


export type QueryStoresGroupsArgs = {
  input?: InputMaybe<StoresGroupsInput>;
};


export type QueryTagByIdArgs = {
  id: Scalars['UUID']['input'];
  options?: InputMaybe<FindOptionsInput>;
};


export type QueryTargetDeviceGroupsArgs = {
  filter?: InputMaybe<TargetDeviceGroupFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryTargetDeviceGroupsByFilteredProductsArgs = {
  filter: TargetDeviceGroupsFilterByFilteredProducts;
};


export type QueryTargetDevicesArgs = {
  filter?: InputMaybe<TargetDeviceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<InputMaybe<OrderBy>>>;
};


export type QueryUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUser_V2Args = {
  id: Scalars['ID']['input'];
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsers_V2Args = {
  input?: InputMaybe<UsersInput>;
};

export type RadiusZipsCatchmentArea = {
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  manualZips?: Maybe<Scalars['JSONB']['output']>;
  orgId: Scalars['UUID']['output'];
  radius?: Maybe<Scalars['String']['output']>;
  radiusZips?: Maybe<Scalars['JSONB']['output']>;
  storeId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionsFilter = {
  and?: InputMaybe<Array<RegionsFilter>>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<RegionsFilter>;
  or?: InputMaybe<Array<RegionsFilter>>;
  regionCode?: InputMaybe<StringFilter>;
};

export type RegionsGeoData = {
  centroid?: Maybe<Scalars['GeoJSON']['output']>;
  countryCode: Scalars['String']['output'];
  featureId?: Maybe<Scalars['BigInt']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  onSurfaceCentroid?: Maybe<Scalars['GeoJSON']['output']>;
  property?: Maybe<Property>;
  regionCode: Scalars['String']['output'];
};

export type RemoveAccountContactPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveAccountListPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveAccountPayload = MutationResponse & {
  account?: Maybe<Account>;
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveCreativeInput = {
  id: Scalars['ID']['input'];
};

export type RemoveCreativePayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveCreativeRevisionInput = {
  id: Scalars['ID']['input'];
};

export type RemoveCreativeRevisionPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creatives?: Maybe<Array<Maybe<Creative>>>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type RemoveStoreFromStoresGroupInput = {
  storeId: Scalars['UUID']['input'];
  storesGroupId: Scalars['UUID']['input'];
};

export type RemoveStoreFromStoresGroupResult = {
  removed: Scalars['Boolean']['output'];
};

export type RemoveTagInput = {
  id: Scalars['UUID']['input'];
};

export type RemoveTagResult = {
  removed: Scalars['Boolean']['output'];
};

export type RenameMediaInput = {
  canonicalId: Scalars['ID']['input'];
  filename: Scalars['String']['input'];
};

export enum ReportFrequency {
  FinalReport = 'FINAL_REPORT',
  Monthly = 'MONTHLY',
  Weekly = 'WEEKLY'
}

/** A shareable report link. */
export type ReportShareLink = {
  /** Campaign ID. */
  campaignId: Scalars['ID']['output'];
  /** Contact ID. */
  contactId: Scalars['ID']['output'];
  /** Full share link URL. */
  link: Scalars['String']['output'];
  /** Unique link key. */
  linkKey: Scalars['String']['output'];
  /** Theme name. */
  theme: Scalars['String']['output'];
};

/** Connection for paginated report share links. */
export type ReportShareLinkConnection = {
  /** List of edges. */
  edges: Array<ReportShareLinkEdge>;
  /** Total number of matching links. */
  totalCount: Scalars['Int']['output'];
};

/** Edge for ReportShareLink in a connection. */
export type ReportShareLinkEdge = {
  /** The report share link node. */
  node: ReportShareLink;
};

/** Filter for report share links. */
export type ReportShareLinkFilter = {
  /** Campaign ID to filter by. */
  campaignId?: InputMaybe<NumberFilter>;
  /** Contact ID to filter by. */
  contactId?: InputMaybe<StringFilter>;
};

export enum ReportingEngineEnum {
  Aerospike = 'AEROSPIKE',
  Elastic = 'ELASTIC'
}

/** A reseller is a user account which has access to the api. */
export type Reseller = {
  blocked?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  customername?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastFaultyLogin?: Maybe<Scalars['DateTime']['output']>;
  lastValidLogin?: Maybe<Scalars['DateTime']['output']>;
  lockUntil?: Maybe<Scalars['Int']['output']>;
  loginFailures?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  settings?: Maybe<ResellerSettings>;
  tenantGateway?: Maybe<Scalars['String']['output']>;
  tenantUrl?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

/** Represents campaign booking settings */
export type ResellerCampaignBookingSetting = {
  /** list of channel ids to book */
  channelIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** settings for the different targetDeviceGroups DESKTOP, MOBILE and MULTI */
  deviceSettings?: Maybe<Array<Maybe<DeviceSetting>>>;
  /** Priority value to use when booking inclusion or exlusion is done */
  priority?: Maybe<Scalars['Int']['output']>;
};

export type ResellerCampaignBookingSettingInput = {
  channelIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  deviceSettings?: InputMaybe<Array<InputMaybe<DeviceSettingInput>>>;
  priority?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Sub-Type for gdpr settings of ResellerCampaignSetting which follows
 * the international standard: https://iabeurope.eu/vendor-list-tcf-v2-0/
 */
export type ResellerCampaignGdprSetting = {
  /** defines the gdpr targeting target value, 1, 2, 4 */
  allowed?: Maybe<Scalars['Int']['output']>;
  /** Switch for turning GDPR targeting on and off again */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * bitmask value which combines different purpose values
   * SEE https://vendorlist.consensu.org/v2/purposes-de.json
   */
  purposes?: Maybe<Scalars['Int']['output']>;
  /** List of vendor ids */
  vendors?: Maybe<Scalars['JSON']['output']>;
};

export type ResellerCampaignGdprSettingInput = {
  allowed?: InputMaybe<Scalars['Int']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  purposes?: InputMaybe<Scalars['Int']['input']>;
  vendors?: InputMaybe<Scalars['JSON']['input']>;
};

/**
 * Reseller & reseller client’s brand- and customer-specific settings to be used when a campaign is
 * created and/or updated from an order
 */
export type ResellerCampaignSetting = {
  accountManagerId?: Maybe<Scalars['String']['output']>;
  advertiserId?: Maybe<Scalars['String']['output']>;
  booking?: Maybe<ResellerCampaignBookingSetting>;
  /**
   * optional name of the order’s "brand" which must exact match for this settings
   * to get applied. When there’s no name specified the settings get
   * applied to all campaigns created/updated from this order.
   */
  brand?: Maybe<Scalars['String']['output']>;
  /** code of a country ("ISO 3166-1 alpha-2" - https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) */
  countryCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional name of reseller’s customer which must match for setting getting
   * applied to campaign
   */
  customername?: Maybe<Scalars['String']['output']>;
  /** Array of domain names that should be blacklisted */
  domainTargetingBlacklist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Array of domain names that should be whitelisted */
  domainTargetingWhitelist?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  reseller?: Maybe<Reseller>;
  salesManagerId?: Maybe<Scalars['String']['output']>;
  /** More detailed settings for targeting of the campaign */
  targeting?: Maybe<ResellerCampaignTargeting>;
};

export type ResellerCampaignSettingMutation = {
  create?: Maybe<ResellerCampaignSetting>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<ResellerCampaignSetting>;
};


export type ResellerCampaignSettingMutationCreateArgs = {
  input: CreateResellerCampaignSettingInput;
};


export type ResellerCampaignSettingMutationDeleteArgs = {
  input: DeleteResellerCampaignSettingInput;
};


export type ResellerCampaignSettingMutationUpdateArgs = {
  input: UpdateResellerCampaignSettingInput;
};

export type ResellerCampaignTargeting = {
  gdpr?: Maybe<ResellerCampaignGdprSetting>;
};

export type ResellerCampaignTargetingInput = {
  gdpr?: InputMaybe<ResellerCampaignGdprSettingInput>;
};

export type ResellerConnection = {
  edges?: Maybe<Array<Maybe<ResellerEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo: PageInfo;
};

export type ResellerEdge = {
  cursor: Scalars['String']['output'];
  node: Reseller;
};

/** Input type for resellers query which supports different searchable attributes */
export type ResellerFilter = {
  OR?: InputMaybe<Array<ResellerFilter>>;
  blocked?: InputMaybe<NumberFilter>;
  createdAt?: InputMaybe<DateFilter>;
  customername?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringFilter>;
  id?: InputMaybe<NumberFilter>;
  lastFaultyLogin?: InputMaybe<DateFilter>;
  lastValidLogin?: InputMaybe<DateFilter>;
  lockUntil?: InputMaybe<NumberFilter>;
  loginFailures?: InputMaybe<NumberFilter>;
  orgId?: InputMaybe<StringFilter>;
  role?: InputMaybe<StringFilter>;
  timezone?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  username?: InputMaybe<StringFilter>;
};

export type ResellerMutations = {
  create: Reseller;
  update: Reseller;
};


export type ResellerMutationsCreateArgs = {
  input: CreateResellerInput;
};


export type ResellerMutationsUpdateArgs = {
  input: UpdateResellerInput;
};

/**
 * Reseller & reseller brand’s specific settings for notficiations send on specific
 * events (like incoming orders) on different channels.
 */
export type ResellerNotificationSetting = {
  /**
   * Optional name of the reseller’s order’s brand attribute which must exactly
   * match for settings getting applied.
   */
  brand?: Maybe<Scalars['String']['output']>;
  ccEmail?: Maybe<Scalars['JSON']['output']>;
  /**
   * required name of a channel on which a notification should get send, possible
   * values are: "email"
   */
  channel: Scalars['String']['output'];
  /**
   * optional name of the triggered event which must exact match, possible values
   * are: "orderCreateSuccess"
   */
  event: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** References the reseller this setting belongs to. */
  reseller?: Maybe<Reseller>;
  /**
   * object containing channel and event specific configuration options
   * tbd: define format and purpose
   */
  toEmail?: Maybe<Scalars['JSON']['output']>;
};

export type ResellerNotificationSettingMutation = {
  create?: Maybe<ResellerNotificationSetting>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  update?: Maybe<ResellerNotificationSetting>;
};


export type ResellerNotificationSettingMutationCreateArgs = {
  input: CreateResellerNotificationSettingInput;
};


export type ResellerNotificationSettingMutationDeleteArgs = {
  input: DeleteResellerNotificationSettingInput;
};


export type ResellerNotificationSettingMutationUpdateArgs = {
  input: UpdateResellerNotificationSettingInput;
};

/** Represents diffenrt types of lists conainting settings specific for a reseller */
export type ResellerSettings = {
  _?: Maybe<Scalars['Boolean']['output']>;
  campaign?: Maybe<Array<Maybe<ResellerCampaignSetting>>>;
  notification?: Maybe<Array<Maybe<ResellerNotificationSetting>>>;
};


/** Represents diffenrt types of lists conainting settings specific for a reseller */
export type ResellerSettingsCampaignArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  customername?: InputMaybe<Scalars['String']['input']>;
};


/** Represents diffenrt types of lists conainting settings specific for a reseller */
export type ResellerSettingsNotificationArgs = {
  brand?: InputMaybe<Scalars['String']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  even?: InputMaybe<Scalars['String']['input']>;
};

/** Input with the necessary data to send a campaign report email */
export type SendSharedReportLinkEmailInput = {
  additionalText?: InputMaybe<Scalars['String']['input']>;
  /** External Recipients are members of the Account associated with the Campaign */
  externalRecipients: Array<Scalars['ID']['input']>;
  /** Internal Recipients are F11 employees, primarily from the Customer Success team */
  internalRecipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  reportKeyLink: Scalars['String']['input'];
};

/** Response */
export type SendSharedReportLinkEmailResponse = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type SetupChannelCalculationInput = {
  calculation?: InputMaybe<Scalars['String']['input']>;
  channel: Scalars['ID']['input'];
  targetDeviceGroup: TargetDeviceGroupCode;
};

/** Input with the necessary data to generate a shareable link for a campaign report. */
export type ShareCampaignReportInput = {
  campaignId: Scalars['ID']['input'];
  contactId: Scalars['ID']['input'];
  theme: Scalars['String']['input'];
};

/** Response from sharing a campaign report. */
export type ShareCampaignReportResponse = MutationResponse & {
  campaignId?: Maybe<Scalars['ID']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['ID']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkKey?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  theme?: Maybe<Scalars['String']['output']>;
};

export type Store = {
  account?: Maybe<Account>;
  active: Scalars['Boolean']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSONB']['output']>;
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  geocodedAddress?: Maybe<GeocodedAddress>;
  hasOpeningHours: Scalars['Boolean']['output'];
  id: Scalars['UUID']['output'];
  image?: Maybe<Media>;
  imprintUrl?: Maybe<Scalars['String']['output']>;
  legalUrl?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Media>;
  mapmarker?: Maybe<Media>;
  name: Scalars['String']['output'];
  orgId: Scalars['UUID']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  privacyUrl?: Maybe<Scalars['String']['output']>;
  radiusZipsCatchmentAreas: Array<RadiusZipsCatchmentArea>;
  reference: Scalars['String']['output'];
  storesGroups: Array<StoresGroup>;
  updatedAt: Scalars['DateTime']['output'];
  websiteUrl?: Maybe<Scalars['String']['output']>;
};


export type StoreRadiusZipsCatchmentAreasArgs = {
  options?: InputMaybe<FindOptionsInput>;
};

export type StoresFieldsFilter = {
  accountCanonicalId?: InputMaybe<StringFilter>;
  active?: InputMaybe<BooleanFilter>;
  additionalAddress?: InputMaybe<StringFilter>;
  address?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<StoresFieldsFilter>>;
  city?: InputMaybe<StringFilter>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  email?: InputMaybe<StringFilter>;
  fax?: InputMaybe<StringFilter>;
  hasOpeningHours?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<StoresFieldsFilter>;
  or?: InputMaybe<Array<StoresFieldsFilter>>;
  phone?: InputMaybe<StringFilter>;
  reference?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type StoresFilter = {
  storesFieldsFilter?: InputMaybe<StoresFieldsFilter>;
  storesGroups?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type StoresGroup = {
  account?: Maybe<Account>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type StoresGroupsFieldsFilter = {
  accountCanonicalId?: InputMaybe<StringFilter>;
  and?: InputMaybe<Array<StoresGroupsFieldsFilter>>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  not?: InputMaybe<StoresGroupsFieldsFilter>;
  or?: InputMaybe<Array<StoresGroupsFieldsFilter>>;
  updatedAt?: InputMaybe<DateFilter>;
};

export type StoresGroupsFilter = {
  storesGroupsFieldsFilter?: InputMaybe<StoresGroupsFieldsFilter>;
};

export type StoresGroupsInput = {
  filter?: InputMaybe<StoresGroupsFilter>;
  orderBy?: InputMaybe<Array<StoresGroupsOrderBy>>;
  paginate?: InputMaybe<OffsetBasedPageInput>;
};

export type StoresGroupsOrderBy = {
  direction: OrderByDirection;
  field: StoresGroupsOrderableFields;
};

export enum StoresGroupsOrderableFields {
  Accountcanonicalid = 'ACCOUNTCANONICALID',
  Color = 'COLOR',
  Createdat = 'CREATEDAT',
  Id = 'ID',
  Name = 'NAME',
  Updatedat = 'UPDATEDAT'
}

export type StoresGroupsPage = {
  items: Array<StoresGroup>;
  pageInfo: OffsetBasedPageInfo;
};

export type StoresInput = {
  filter?: InputMaybe<StoresFilter>;
  orderBy?: InputMaybe<Array<StoresOrderBy>>;
  paginate?: InputMaybe<OffsetBasedPageInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type StoresOrderBy = {
  direction: OrderByDirection;
  field: StoresOrderableFields;
};

export enum StoresOrderableFields {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  City = 'CITY',
  Countrycode = 'COUNTRYCODE',
  Createdat = 'CREATEDAT',
  Id = 'ID',
  Name = 'NAME',
  Reference = 'REFERENCE',
  Updatedat = 'UPDATEDAT',
  Zip = 'ZIP'
}

export type StoresPage = {
  items: Array<Store>;
  pageInfo: OffsetBasedPageInfo;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  equals?: InputMaybe<Scalars['String']['input']>;
  iContains?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  not?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type Tag = {
  account?: Maybe<Account>;
  createdAt: Scalars['DateTime']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  orgId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TargetDevice = {
  code?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restrictedAdPlacementTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type TargetDeviceConnection = {
  edges?: Maybe<Array<Maybe<TargetDeviceEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type TargetDeviceDayList = {
  /** Ad Impressions */
  adImpression: Scalars['Int']['output'];
  /** Day */
  day: Scalars['String']['output'];
  /** Unique billable interactions or Adserver clicks for external products */
  interaction: Scalars['Int']['output'];
  /** Interaction Rate */
  interactionRate?: Maybe<Scalars['Float']['output']>;
  /** Social interactions */
  socialInteractions?: Maybe<Scalars['Int']['output']>;
  /** Target device */
  targetDevice: DeviceCodeEnum;
};

export type TargetDeviceEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TargetDevice>;
};

export type TargetDeviceFilter = {
  OR?: InputMaybe<Array<TargetDeviceFilter>>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TargetDeviceGroup = {
  code?: Maybe<Scalars['ID']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  targetDevices?: Maybe<Array<Maybe<TargetDevice>>>;
};

export type TargetDeviceGroupByFilteredProductsConnection = {
  edges?: Maybe<Array<Maybe<TargetDeviceGroupEdge>>>;
};

export enum TargetDeviceGroupCode {
  Desktop = 'DESKTOP',
  Dooh = 'DOOH',
  Mobile = 'MOBILE',
  Multi = 'MULTI'
}

export type TargetDeviceGroupConnection = {
  edges?: Maybe<Array<Maybe<TargetDeviceGroupEdge>>>;
  fullCount?: Maybe<Scalars['Int']['output']>;
  pageInfo?: Maybe<PageInfo>;
};

export type TargetDeviceGroupEdge = {
  cursor?: Maybe<Scalars['String']['output']>;
  node?: Maybe<TargetDeviceGroup>;
};

export type TargetDeviceGroupFilter = {
  OR?: InputMaybe<Array<TargetDeviceGroupFilter>>;
  code?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
};

export type TargetDeviceGroupsFilterByFilteredProducts = {
  clientId?: InputMaybe<Scalars['ID']['input']>;
  countryId: Scalars['ID']['input'];
  productFamily: ProductFamilyByFilteredProductsFilter;
  productFunnelCode: Scalars['String']['input'];
};

export type TermsOfServiceInput = {
  approvedAt: Scalars['DateTime']['input'];
  isApproved: Scalars['Boolean']['input'];
};

export type Trigger = {
  count: Scalars['Int']['output'];
  trigger?: Maybe<Scalars['String']['output']>;
};

export type UuidFilter = {
  equals?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  not?: InputMaybe<Scalars['UUID']['input']>;
  notIn?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** Input for unsharing a campaign report. */
export type UnshareCampaignReportInput = {
  linkKey: Scalars['String']['input'];
};

/** Response from unsharing a campaign report. */
export type UnshareCampaignReportResponse = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

/** Input to update a campaign report share link. */
export type UpdateCampaignReportShareLinkInput = {
  expiresAt: Scalars['Date']['input'];
  linkKey: Scalars['String']['input'];
};

/** Response from updating a campaign report share link. */
export type UpdateCampaignReportShareLinkResponse = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateChannelInput = {
  calculationByTargetDeviceGroup?: InputMaybe<CalculationByTargetDeviceGroupInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  websiteIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UpdateCreativeInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type UpdateCreativePayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  creative?: Maybe<Creative>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCustomRoleInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  permissionIds: Array<Scalars['ID']['input']>;
};

export type UpdateMyProfileInput = {
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  profilePicture?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateOrderCampaignInput = {
  creatorEmail?: InputMaybe<Scalars['String']['input']>;
  creatorFullname?: InputMaybe<Scalars['String']['input']>;
  merchantToolListAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  merchantToolListLink?: InputMaybe<Scalars['String']['input']>;
  trackingsAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  trackingsLink?: InputMaybe<Scalars['String']['input']>;
};

/** Payload data for updating an order */
export type UpdateOrderInput = {
  adserverId?: InputMaybe<Scalars['String']['input']>;
  /** Number of Ad Impressions */
  ais?: InputMaybe<Scalars['Long']['input']>;
  /**
   * Positive budge value wihout thousand seperator or currency codes
   * automatically rounded to 2-digit precision.
   */
  budget?: InputMaybe<Scalars['String']['input']>;
  /** Calculation result for order */
  calculation?: InputMaybe<Scalars['JSON']['input']>;
  /** Information about the campaign creator */
  campaign?: InputMaybe<UpdateOrderCampaignInput>;
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  /** Number of clicks */
  clicks?: InputMaybe<Scalars['Int']['input']>;
  /** New client id to move order into a new client */
  clientId?: InputMaybe<Scalars['Int']['input']>;
  /** Optional [ISO 3166-1 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) code of the country where the order should be placed. */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Cost-per-click, automatically rounded to 6-digit precision */
  cpc?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  customer?: InputMaybe<ImportOrderCustomerInput>;
  end?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * The unique identifier of the order that should get updated.
   * Must specify either id or f11Id to update.
   */
  f11Id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The unique identifier of the order that should get updated.
   * Must specify either id or f11Id to update.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  madtechCategory?: InputMaybe<Scalars['String']['input']>;
  manualHandling?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Required id of this order which is defined by the client and must be unique
   * for the client.
   */
  orderId?: InputMaybe<Scalars['String']['input']>;
  playoutScheduleType?: InputMaybe<OrderPlayoutScheduleType>;
  productSnapshot?: InputMaybe<Scalars['JSON']['input']>;
  productkey?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<OrderStatus>;
  targetingRange?: InputMaybe<OrderTargetingRange>;
  user?: InputMaybe<CreateOrderUserInput>;
  visibilityMetric?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductDeliveryChannelInput = {
  code: Scalars['ID']['input'];
  minimumBookingVolume?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductFamilyInput = {
  code: Scalars['ID']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalCreatives?: InputMaybe<Scalars['Boolean']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  productVariants?: InputMaybe<Array<ProductVariantInput>>;
  reseller?: InputMaybe<Scalars['ID']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductFunnelInput = {
  billingType?: InputMaybe<Scalars['String']['input']>;
  code: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductGeoTargetInput = {
  code: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductGuaranteeInput = {
  code: Scalars['ID']['input'];
  discountable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  roundType?: InputMaybe<Scalars['String']['input']>;
  unit?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductIdentificationInput = {
  code: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  precision?: InputMaybe<Scalars['Int']['input']>;
  roundType?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  bookable?: InputMaybe<Scalars['Boolean']['input']>;
  budgetIdentification?: InputMaybe<Scalars['ID']['input']>;
  channels?: InputMaybe<Array<Scalars['ID']['input']>>;
  code?: InputMaybe<Scalars['ID']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['ID']['input']>;
  ctr?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productBillingType?: InputMaybe<Scalars['ID']['input']>;
  productDeliveryChannel?: InputMaybe<Scalars['ID']['input']>;
  productFamily?: InputMaybe<Scalars['ID']['input']>;
  /** TB change */
  productFamilyToReseller?: InputMaybe<Scalars['ID']['input']>;
  productFunnel?: InputMaybe<Scalars['ID']['input']>;
  productGeoTarget?: InputMaybe<Scalars['ID']['input']>;
  productGuarantees?: InputMaybe<Array<ProductGuaranteeInput>>;
  productIdentifications?: InputMaybe<Array<ProductIdentificationInput>>;
  productTargetings?: InputMaybe<Array<ProductTargetingInput>>;
  productVisibilityMetrics?: InputMaybe<Array<ProductVisibilityMetricInput>>;
  publisherAdPlacementTypes?: InputMaybe<Array<ProductPublisherAdPlacementTypeInput>>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
  reseller?: InputMaybe<Scalars['ID']['input']>;
  salesPrice?: InputMaybe<Scalars['Float']['input']>;
  settings?: InputMaybe<Scalars['JSON']['input']>;
  targetDeviceGroup?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProductVisibilityMetricInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  defaultOption?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  selectedOption?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePublisherAdPlacementInput = {
  cpm?: InputMaybe<Scalars['Float']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  productFamily?: InputMaybe<ProductFamilyInput>;
  publisherAdPlacementTypeCode?: InputMaybe<Scalars['ID']['input']>;
  publisherId?: InputMaybe<Scalars['ID']['input']>;
  publisherWebsiteId?: InputMaybe<Scalars['ID']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  targetDeviceCode?: InputMaybe<Scalars['ID']['input']>;
  website_id?: InputMaybe<Scalars['Int']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePublisherAdPlacementTypeInput = {
  code: Scalars['ID']['input'];
  height?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  specification?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePublisherInput = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['ID']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePublisherWebsiteInput = {
  alias?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domain?: InputMaybe<Scalars['String']['input']>;
  hidden?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  productFamily?: InputMaybe<ProductFamilyInput>;
  publisherId?: InputMaybe<Scalars['Int']['input']>;
  sorting?: InputMaybe<Scalars['Int']['input']>;
  targetings?: InputMaybe<Array<PublisherWebsiteTargetingInput>>;
};

export type UpdateRadiusZipsCatchmentAreaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  manualZips?: InputMaybe<Scalars['JSONB']['input']>;
  radius?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResellerCampaignSettingInput = {
  accountManagerId?: InputMaybe<Scalars['String']['input']>;
  advertiserId?: InputMaybe<Scalars['String']['input']>;
  booking?: InputMaybe<ResellerCampaignBookingSettingInput>;
  brand?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  customername?: InputMaybe<Scalars['String']['input']>;
  domainTargetingBlacklist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  domainTargetingWhitelist?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id: Scalars['ID']['input'];
  salesManagerId?: InputMaybe<Scalars['String']['input']>;
  targeting?: InputMaybe<ResellerCampaignTargetingInput>;
};

/** Payload for updating a single reseller account */
export type UpdateResellerInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  customername?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  orgId?: InputMaybe<Scalars['String']['input']>;
  tenantGateway?: InputMaybe<Scalars['String']['input']>;
  tenantUrl?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateResellerNotificationSettingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  ccEmail?: InputMaybe<Scalars['JSON']['input']>;
  channel?: InputMaybe<Scalars['String']['input']>;
  event?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  toEmail?: InputMaybe<Scalars['JSON']['input']>;
};

export type UpdateUserCustomRolesInput = {
  customRoleIds: Array<Scalars['ID']['input']>;
  userId: Scalars['ID']['input'];
};

export enum UploadContextMediaType {
  CreativeProduct = 'CREATIVE_PRODUCT',
  Generic = 'GENERIC'
}

export type UploadCreativeTempCreative = {
  adHeight?: Maybe<Scalars['Float']['output']>;
  adSlot?: Maybe<Scalars['String']['output']>;
  adWidth?: Maybe<Scalars['Float']['output']>;
  creativeHash?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['Int']['output']>;
  revision?: Maybe<Scalars['String']['output']>;
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type UploadCreativeTempPayload = MutationResponse & {
  /** @deprecated Use creatives instead */
  adHeight?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use creatives instead */
  adWidth?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  creatives?: Maybe<Array<Maybe<UploadCreativeTempCreative>>>;
  /** @deprecated Use creatives instead */
  hash?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use creatives instead */
  screenshotUrl?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  /** @deprecated Use creatives instead */
  url?: Maybe<Scalars['String']['output']>;
  zipUrl?: Maybe<Scalars['String']['output']>;
};

export type UploadFileTreeArchiveInput = {
  archive: Scalars['Upload']['input'];
  clearTargetFirst?: InputMaybe<Scalars['Boolean']['input']>;
  fileTreeId: Scalars['ID']['input'];
  pathPrefix: Scalars['String']['input'];
  removeEnclosingDirectory?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UploadFileTreeFileInput = {
  file: Scalars['Upload']['input'];
  fileTreeId: Scalars['ID']['input'];
  path: Scalars['String']['input'];
};

export type UpsertAccountDiscountGeneralAgreementInput = {
  discount: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  retroactive?: InputMaybe<Scalars['Boolean']['input']>;
  tiers?: InputMaybe<Array<UpsertAccountDiscountTieredInput>>;
  type: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertAccountDiscountInput = {
  comment: Scalars['String']['input'];
  generalAgreement?: InputMaybe<Array<UpsertAccountDiscountGeneralAgreementInput>>;
  inventory?: InputMaybe<Array<UpsertAccountDiscountInventoryInput>>;
  research?: InputMaybe<Array<UpsertAccountDiscountResearchInput>>;
  skonto?: InputMaybe<Array<UpsertAccountDiscountSkontoInput>>;
  surcharge?: InputMaybe<Array<UpsertAccountDiscountSurchargeInput>>;
};

export type UpsertAccountDiscountInventoryInput = {
  disableSkonto?: InputMaybe<Scalars['Boolean']['input']>;
  discount: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpsertAccountDiscountOutput = {
  success: Scalars['Boolean']['output'];
};

export type UpsertAccountDiscountResearchInput = {
  discount: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  tiers?: InputMaybe<Array<UpsertAccountDiscountTieredInput>>;
  type: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};

export type UpsertAccountDiscountSkontoInput = {
  deadline: Scalars['String']['input'];
  discount: Scalars['String']['input'];
  gracePeriod: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpsertAccountDiscountSurchargeInput = {
  discount: Scalars['String']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  type: Scalars['String']['input'];
  validFrom: Scalars['String']['input'];
  validTo: Scalars['String']['input'];
  value: Scalars['Float']['input'];
};

export type UpsertAccountDiscountTieredInput = {
  breakpoint: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['Int']['input']>;
  value: Scalars['Float']['input'];
};

export type UpsertAccountListPayload = {
  account: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UpsertAccountNotePayload = {
  account?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type UpsertContactPayload = MutationResponse & {
  code?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<Contact>;
  message?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type UpsertGeocodedAddressInput = {
  additionalAddress?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  city: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  id?: InputMaybe<Scalars['UUID']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  zip: Scalars['String']['input'];
};

export type UpsertGeocodedAddressesInput = {
  addresses: Array<UpsertGeocodedAddressInput>;
};

export type UpsertGeocodedAddressesResult = {
  geocodedAddresses: Array<GeocodedAddress>;
};

export type User = {
  blocked?: Maybe<Scalars['Boolean']['output']>;
  contact?: Maybe<Contact>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Get assigned image */
  image?: Maybe<Media>;
  lastFaultyLogin?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastValidLogin?: Maybe<Scalars['DateTime']['output']>;
  loginFailures?: Maybe<Scalars['Int']['output']>;
  orgId?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
  phone?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
};

export type UserEdges = {
  edges?: Maybe<Array<Maybe<UserNode>>>;
  totalCount?: Maybe<Scalars['Int']['output']>;
};

export enum UserField {
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastLoginAt = 'lastLoginAt',
  LastName = 'lastName'
}

export type UserInput = {
  createCRMContact?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** add a list of additional permissions */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
};

export type UserMutation = {
  remove?: Maybe<User>;
  upsert?: Maybe<User>;
};


export type UserMutationRemoveArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type UserMutationUpsertArgs = {
  data: UserInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type UserNode = {
  /** This is Feature for Future */
  cursor?: Maybe<Scalars['ID']['output']>;
  node?: Maybe<User>;
};

export type UserOrderBy = {
  field: UserField;
  order?: InputMaybe<OrderByDirection>;
};

export type UserRole = {
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Permission>>>;
};

export type UserRoleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** add a list of additional permissions */
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UserRoleMutation = {
  remove?: Maybe<UserRole>;
  upsert?: Maybe<UserRole>;
};


export type UserRoleMutationRemoveArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type UserRoleMutationUpsertArgs = {
  data: UserRoleInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type User_V2 = {
  customRoles: Array<CustomRole>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedBy: Scalars['String']['output'];
  isOwner: Scalars['Boolean']['output'];
  lastLoginAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  profilePicture?: Maybe<Media>;
};

export type UsersInput = {
  orderBy?: InputMaybe<Array<UserOrderBy>>;
  paginate?: InputMaybe<OffsetBasedPageInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPage = {
  items: Array<User_V2>;
  pageInfo: OffsetBasedPageInfo;
};

export type ZipGroup = {
  name?: Maybe<Scalars['String']['output']>;
  zips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ZipGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  total: ZipGroupTotalInput;
};

export type ZipGroupTotalInput = {
  ais?: InputMaybe<Scalars['Long']['input']>;
  zips: Array<Scalars['String']['input']>;
};

export type ZipPropertyAggregates = {
  age0To19?: Maybe<Scalars['BigInt']['output']>;
  age0To19SharePct?: Maybe<Scalars['Int']['output']>;
  age20To34?: Maybe<Scalars['BigInt']['output']>;
  age20To34SharePct?: Maybe<Scalars['Int']['output']>;
  age35To44?: Maybe<Scalars['BigInt']['output']>;
  age35To44SharePct?: Maybe<Scalars['Int']['output']>;
  age45To59?: Maybe<Scalars['BigInt']['output']>;
  age45To59SharePct?: Maybe<Scalars['Int']['output']>;
  age60Plus?: Maybe<Scalars['BigInt']['output']>;
  age60PlusSharePct?: Maybe<Scalars['Int']['output']>;
  ageAvg?: Maybe<Scalars['Int']['output']>;
  aiPotential?: Maybe<Scalars['BigInt']['output']>;
  areaKm2?: Maybe<Scalars['Float']['output']>;
  digitalSharePctWeighted?: Maybe<Scalars['Int']['output']>;
  household1?: Maybe<Scalars['BigInt']['output']>;
  household1SharePct?: Maybe<Scalars['Int']['output']>;
  household2?: Maybe<Scalars['BigInt']['output']>;
  household2SharePct?: Maybe<Scalars['Int']['output']>;
  household3?: Maybe<Scalars['BigInt']['output']>;
  household3SharePct?: Maybe<Scalars['Int']['output']>;
  household4?: Maybe<Scalars['BigInt']['output']>;
  household4SharePct?: Maybe<Scalars['Int']['output']>;
  household5Plus?: Maybe<Scalars['BigInt']['output']>;
  household5PlusSharePct?: Maybe<Scalars['Int']['output']>;
  households?: Maybe<Scalars['BigInt']['output']>;
  householdsWeightedAvg?: Maybe<Scalars['Int']['output']>;
  householdsWithKids?: Maybe<Scalars['BigInt']['output']>;
  householdsWithKidsSharePct?: Maybe<Scalars['Int']['output']>;
  householdsWithoutKids?: Maybe<Scalars['BigInt']['output']>;
  householdsWithoutKidsSharePct?: Maybe<Scalars['Int']['output']>;
  houses?: Maybe<Scalars['BigInt']['output']>;
  housesWith1or2FamiliesAndGarden?: Maybe<Scalars['BigInt']['output']>;
  housesWith1or2FamiliesAndGardenSharePct?: Maybe<Scalars['BigInt']['output']>;
  housesWith1or2FamiliesAndGardenSharePctWeighted?: Maybe<Scalars['Int']['output']>;
  newBorn?: Maybe<Scalars['BigInt']['output']>;
  population?: Maybe<Scalars['BigInt']['output']>;
  populationDensity?: Maybe<Scalars['Float']['output']>;
  printSharePctWeighted?: Maybe<Scalars['Int']['output']>;
  purchasePower15kTo25k?: Maybe<Scalars['BigInt']['output']>;
  purchasePower15kTo25kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePower25kTo40k?: Maybe<Scalars['BigInt']['output']>;
  purchasePower25kTo40kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePower40kTo60k?: Maybe<Scalars['BigInt']['output']>;
  purchasePower40kTo60kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePowerAbove60k?: Maybe<Scalars['BigInt']['output']>;
  purchasePowerAbove60kSharePct?: Maybe<Scalars['Int']['output']>;
  purchasePowerBelow15k?: Maybe<Scalars['BigInt']['output']>;
  purchasePowerBelow15kSharePct?: Maybe<Scalars['Int']['output']>;
};

export type ZipsByPropertiesFilter = {
  propertiesFilter?: InputMaybe<PropertiesFilter>;
  zipsFilter?: InputMaybe<ZipsFilter>;
};

export type ZipsFilter = {
  and?: InputMaybe<Array<ZipsFilter>>;
  cityName?: InputMaybe<StringFilter>;
  hasIpMapping?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<StringFilter>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  not?: InputMaybe<ZipsFilter>;
  or?: InputMaybe<Array<ZipsFilter>>;
  regionCode?: InputMaybe<StringFilter>;
  zip?: InputMaybe<StringFilter>;
};

export type ZipsGeoData = {
  centroid?: Maybe<Scalars['GeoJSON']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryCode: Scalars['String']['output'];
  featureId?: Maybe<Scalars['BigInt']['output']>;
  geometry?: Maybe<Scalars['GeoJSON']['output']>;
  hasIpMapping?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['UUID']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  onSurfaceCentroid?: Maybe<Scalars['GeoJSON']['output']>;
  property?: Maybe<Property>;
  regionCode?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type ZipsGroupedByRadius = {
  id: Scalars['String']['output'];
  zips: Array<ZipsGeoData>;
};

export type ZipsOrderByField = {
  direction: OrderDirection;
  field: ZipsOrderByFields;
};

export enum ZipsOrderByFields {
  CityName = 'CITY_NAME',
  Id = 'ID',
  RegionCode = 'REGION_CODE',
  Zip = 'ZIP'
}

export type ZipsRangeFilter = {
  center: CoordinateInput;
  countryCode: Scalars['String']['input'];
  radius: Scalars['Int']['input'];
};

export type CampaignBaseDataQueryVariables = Exact<{
  campaignId: Scalars['ID']['input'];
}>;


export type CampaignBaseDataQuery = { campaignsBaseData?: { edges?: Array<{ node?: { id: string, name: string, status?: CampaignStatus | null, pathKalkuTool?: string | null, isBooked?: boolean | null, isBookable?: boolean | null, start: any, country?: { id?: string | null, code?: string | null } | null, account?: { id: string, isBookable?: boolean | null } | null, productFamily?: { id?: string | null, code?: string | null, name?: string | null, externalCreatives?: boolean | null } | null, productVariant?: { id?: string | null, code?: string | null, name?: string | null } | null, creativesInternal?: { fullCount?: number | null, edges?: Array<{ node?: { id: string, name: string, deployments?: Array<{ id: string, stage?: CreativeInternalDeploymentStage | null, state?: CreativeInternalDeploymentState | null } | null> | null } | null } | null> | null } | null, creativesExternal?: { fullCount?: number | null, edges?: Array<{ node?: { id: string } | null } | null> | null } | null } | null } | null> | null } | null };

export type FetchCampaignsCountGqlQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchCampaignsCountGqlQuery = { active?: { fullCount?: number | null } | null, draft?: { fullCount?: number | null } | null, archived?: { fullCount?: number | null } | null, my?: { fullCount?: number | null } | null, all?: { fullCount?: number | null } | null };

export type BookmarkedCampaignsCountQueryVariables = Exact<{
  filter?: InputMaybe<CampaignsBaseDataFilter>;
}>;


export type BookmarkedCampaignsCountQuery = { campaignsBaseData?: { fullCount?: number | null } | null };

export type FetchCompaniesCountGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchCompaniesCountGqlQuery = { accounts?: { totalCount?: number | null } | null };

export type FetchContactsCountGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchContactsCountGqlQuery = { contacts?: { totalCount?: number | null } | null };

export type FetchBirthdaysCountGqlQueryVariables = Exact<{
  where?: InputMaybe<Scalars['SequelizeJSON']['input']>;
}>;


export type FetchBirthdaysCountGqlQuery = { contacts?: { totalCount?: number | null } | null };

export type FetchMeGqlQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchMeGqlQuery = { me_v2: { id: string, firstName?: string | null, lastName?: string | null, email?: string | null, profilePicture?: { id: string, uuid: string, contentType: string, width?: number | null, height?: number | null } | null } };

export type OrganizationBrandAppearanceQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationBrandAppearanceQuery = { organizationBrandAppearance?: { squareLogo?: { id: string, uuid: string } | null, landscapeLogo?: { id: string, uuid: string } | null } | null };

export type CreateCampaignInBookingPermissionQueryVariables = Exact<{ [key: string]: never; }>;


export type CreateCampaignInBookingPermissionQuery = { productFamilies?: { edges?: Array<{ node?: { code?: string | null, name?: string | null, icon?: string | null, color?: string | null, id?: string | null } | null } | null> | null } | null };


export const CampaignBaseDataDocument = gql`
    query CampaignBaseData($campaignId: ID!) {
  campaignsBaseData(where: {id: $campaignId}) {
    edges {
      node {
        id
        name
        status
        pathKalkuTool
        isBooked
        isBookable
        country {
          id
          code
        }
        start
        account {
          id
          isBookable
        }
        productFamily {
          id
          code
          name
          externalCreatives
        }
        productVariant {
          id
          code
          name
        }
        creativesInternal {
          fullCount
          edges {
            node {
              id
              name
              deployments {
                id
                stage
                state
              }
            }
          }
        }
        creativesExternal {
          fullCount
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useCampaignBaseDataQuery__
 *
 * To run a query within a React component, call `useCampaignBaseDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignBaseDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignBaseDataQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignBaseDataQuery(baseOptions: Apollo.QueryHookOptions<CampaignBaseDataQuery, CampaignBaseDataQueryVariables> & ({ variables: CampaignBaseDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>(CampaignBaseDataDocument, options);
      }
export function useCampaignBaseDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>(CampaignBaseDataDocument, options);
        }
// @ts-ignore
export function useCampaignBaseDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>;
export function useCampaignBaseDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>): Apollo.UseSuspenseQueryResult<CampaignBaseDataQuery | undefined, CampaignBaseDataQueryVariables>;
export function useCampaignBaseDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>(CampaignBaseDataDocument, options);
        }
export type CampaignBaseDataQueryHookResult = ReturnType<typeof useCampaignBaseDataQuery>;
export type CampaignBaseDataLazyQueryHookResult = ReturnType<typeof useCampaignBaseDataLazyQuery>;
export type CampaignBaseDataSuspenseQueryHookResult = ReturnType<typeof useCampaignBaseDataSuspenseQuery>;
export type CampaignBaseDataQueryResult = Apollo.QueryResult<CampaignBaseDataQuery, CampaignBaseDataQueryVariables>;
export function refetchCampaignBaseDataQuery(variables: CampaignBaseDataQueryVariables) {
      return { query: CampaignBaseDataDocument, variables: variables }
    }
export const FetchCampaignsCountGqlDocument = gql`
    query fetchCampaignsCountGql($userId: String) {
  active: campaignsBaseData(where: {status: "ACTIVE"}, limit: 1) {
    fullCount
  }
  draft: campaignsBaseData(where: {status: "DRAFT"}, limit: 1) {
    fullCount
  }
  archived: campaignsBaseData(where: {status: "ARCHIVE"}, limit: 1) {
    fullCount
  }
  my: campaignsBaseData(where: {clientServiceContact: $userId}, limit: 1) {
    fullCount
  }
  all: campaignsBaseData(limit: 1) {
    fullCount
  }
}
    `;

/**
 * __useFetchCampaignsCountGqlQuery__
 *
 * To run a query within a React component, call `useFetchCampaignsCountGqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCampaignsCountGqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCampaignsCountGqlQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useFetchCampaignsCountGqlQuery(baseOptions?: Apollo.QueryHookOptions<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>(FetchCampaignsCountGqlDocument, options);
      }
export function useFetchCampaignsCountGqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>(FetchCampaignsCountGqlDocument, options);
        }
// @ts-ignore
export function useFetchCampaignsCountGqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>;
export function useFetchCampaignsCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCampaignsCountGqlQuery | undefined, FetchCampaignsCountGqlQueryVariables>;
export function useFetchCampaignsCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>(FetchCampaignsCountGqlDocument, options);
        }
export type FetchCampaignsCountGqlQueryHookResult = ReturnType<typeof useFetchCampaignsCountGqlQuery>;
export type FetchCampaignsCountGqlLazyQueryHookResult = ReturnType<typeof useFetchCampaignsCountGqlLazyQuery>;
export type FetchCampaignsCountGqlSuspenseQueryHookResult = ReturnType<typeof useFetchCampaignsCountGqlSuspenseQuery>;
export type FetchCampaignsCountGqlQueryResult = Apollo.QueryResult<FetchCampaignsCountGqlQuery, FetchCampaignsCountGqlQueryVariables>;
export function refetchFetchCampaignsCountGqlQuery(variables?: FetchCampaignsCountGqlQueryVariables) {
      return { query: FetchCampaignsCountGqlDocument, variables: variables }
    }
export const BookmarkedCampaignsCountDocument = gql`
    query BookmarkedCampaignsCount($filter: CampaignsBaseDataFilter) {
  campaignsBaseData(filter: $filter) {
    fullCount
  }
}
    `;

/**
 * __useBookmarkedCampaignsCountQuery__
 *
 * To run a query within a React component, call `useBookmarkedCampaignsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkedCampaignsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookmarkedCampaignsCountQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useBookmarkedCampaignsCountQuery(baseOptions?: Apollo.QueryHookOptions<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>(BookmarkedCampaignsCountDocument, options);
      }
export function useBookmarkedCampaignsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>(BookmarkedCampaignsCountDocument, options);
        }
// @ts-ignore
export function useBookmarkedCampaignsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>): Apollo.UseSuspenseQueryResult<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>;
export function useBookmarkedCampaignsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>): Apollo.UseSuspenseQueryResult<BookmarkedCampaignsCountQuery | undefined, BookmarkedCampaignsCountQueryVariables>;
export function useBookmarkedCampaignsCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>(BookmarkedCampaignsCountDocument, options);
        }
export type BookmarkedCampaignsCountQueryHookResult = ReturnType<typeof useBookmarkedCampaignsCountQuery>;
export type BookmarkedCampaignsCountLazyQueryHookResult = ReturnType<typeof useBookmarkedCampaignsCountLazyQuery>;
export type BookmarkedCampaignsCountSuspenseQueryHookResult = ReturnType<typeof useBookmarkedCampaignsCountSuspenseQuery>;
export type BookmarkedCampaignsCountQueryResult = Apollo.QueryResult<BookmarkedCampaignsCountQuery, BookmarkedCampaignsCountQueryVariables>;
export function refetchBookmarkedCampaignsCountQuery(variables?: BookmarkedCampaignsCountQueryVariables) {
      return { query: BookmarkedCampaignsCountDocument, variables: variables }
    }
export const FetchCompaniesCountGqlDocument = gql`
    query fetchCompaniesCountGql {
  accounts {
    totalCount
  }
}
    `;

/**
 * __useFetchCompaniesCountGqlQuery__
 *
 * To run a query within a React component, call `useFetchCompaniesCountGqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCompaniesCountGqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCompaniesCountGqlQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCompaniesCountGqlQuery(baseOptions?: Apollo.QueryHookOptions<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>(FetchCompaniesCountGqlDocument, options);
      }
export function useFetchCompaniesCountGqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>(FetchCompaniesCountGqlDocument, options);
        }
// @ts-ignore
export function useFetchCompaniesCountGqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>;
export function useFetchCompaniesCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchCompaniesCountGqlQuery | undefined, FetchCompaniesCountGqlQueryVariables>;
export function useFetchCompaniesCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>(FetchCompaniesCountGqlDocument, options);
        }
export type FetchCompaniesCountGqlQueryHookResult = ReturnType<typeof useFetchCompaniesCountGqlQuery>;
export type FetchCompaniesCountGqlLazyQueryHookResult = ReturnType<typeof useFetchCompaniesCountGqlLazyQuery>;
export type FetchCompaniesCountGqlSuspenseQueryHookResult = ReturnType<typeof useFetchCompaniesCountGqlSuspenseQuery>;
export type FetchCompaniesCountGqlQueryResult = Apollo.QueryResult<FetchCompaniesCountGqlQuery, FetchCompaniesCountGqlQueryVariables>;
export function refetchFetchCompaniesCountGqlQuery(variables?: FetchCompaniesCountGqlQueryVariables) {
      return { query: FetchCompaniesCountGqlDocument, variables: variables }
    }
export const FetchContactsCountGqlDocument = gql`
    query fetchContactsCountGql {
  contacts {
    totalCount
  }
}
    `;

/**
 * __useFetchContactsCountGqlQuery__
 *
 * To run a query within a React component, call `useFetchContactsCountGqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchContactsCountGqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchContactsCountGqlQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchContactsCountGqlQuery(baseOptions?: Apollo.QueryHookOptions<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>(FetchContactsCountGqlDocument, options);
      }
export function useFetchContactsCountGqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>(FetchContactsCountGqlDocument, options);
        }
// @ts-ignore
export function useFetchContactsCountGqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>;
export function useFetchContactsCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchContactsCountGqlQuery | undefined, FetchContactsCountGqlQueryVariables>;
export function useFetchContactsCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>(FetchContactsCountGqlDocument, options);
        }
export type FetchContactsCountGqlQueryHookResult = ReturnType<typeof useFetchContactsCountGqlQuery>;
export type FetchContactsCountGqlLazyQueryHookResult = ReturnType<typeof useFetchContactsCountGqlLazyQuery>;
export type FetchContactsCountGqlSuspenseQueryHookResult = ReturnType<typeof useFetchContactsCountGqlSuspenseQuery>;
export type FetchContactsCountGqlQueryResult = Apollo.QueryResult<FetchContactsCountGqlQuery, FetchContactsCountGqlQueryVariables>;
export function refetchFetchContactsCountGqlQuery(variables?: FetchContactsCountGqlQueryVariables) {
      return { query: FetchContactsCountGqlDocument, variables: variables }
    }
export const FetchBirthdaysCountGqlDocument = gql`
    query fetchBirthdaysCountGql($where: SequelizeJSON) {
  contacts(where: $where) {
    totalCount
  }
}
    `;

/**
 * __useFetchBirthdaysCountGqlQuery__
 *
 * To run a query within a React component, call `useFetchBirthdaysCountGqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBirthdaysCountGqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBirthdaysCountGqlQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useFetchBirthdaysCountGqlQuery(baseOptions?: Apollo.QueryHookOptions<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>(FetchBirthdaysCountGqlDocument, options);
      }
export function useFetchBirthdaysCountGqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>(FetchBirthdaysCountGqlDocument, options);
        }
// @ts-ignore
export function useFetchBirthdaysCountGqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>;
export function useFetchBirthdaysCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchBirthdaysCountGqlQuery | undefined, FetchBirthdaysCountGqlQueryVariables>;
export function useFetchBirthdaysCountGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>(FetchBirthdaysCountGqlDocument, options);
        }
export type FetchBirthdaysCountGqlQueryHookResult = ReturnType<typeof useFetchBirthdaysCountGqlQuery>;
export type FetchBirthdaysCountGqlLazyQueryHookResult = ReturnType<typeof useFetchBirthdaysCountGqlLazyQuery>;
export type FetchBirthdaysCountGqlSuspenseQueryHookResult = ReturnType<typeof useFetchBirthdaysCountGqlSuspenseQuery>;
export type FetchBirthdaysCountGqlQueryResult = Apollo.QueryResult<FetchBirthdaysCountGqlQuery, FetchBirthdaysCountGqlQueryVariables>;
export function refetchFetchBirthdaysCountGqlQuery(variables?: FetchBirthdaysCountGqlQueryVariables) {
      return { query: FetchBirthdaysCountGqlDocument, variables: variables }
    }
export const FetchMeGqlDocument = gql`
    query fetchMeGql {
  me_v2 {
    id
    firstName
    lastName
    email
    profilePicture {
      id
      uuid
      contentType
      width
      height
    }
  }
}
    `;

/**
 * __useFetchMeGqlQuery__
 *
 * To run a query within a React component, call `useFetchMeGqlQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchMeGqlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchMeGqlQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchMeGqlQuery(baseOptions?: Apollo.QueryHookOptions<FetchMeGqlQuery, FetchMeGqlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchMeGqlQuery, FetchMeGqlQueryVariables>(FetchMeGqlDocument, options);
      }
export function useFetchMeGqlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchMeGqlQuery, FetchMeGqlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchMeGqlQuery, FetchMeGqlQueryVariables>(FetchMeGqlDocument, options);
        }
// @ts-ignore
export function useFetchMeGqlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<FetchMeGqlQuery, FetchMeGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchMeGqlQuery, FetchMeGqlQueryVariables>;
export function useFetchMeGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchMeGqlQuery, FetchMeGqlQueryVariables>): Apollo.UseSuspenseQueryResult<FetchMeGqlQuery | undefined, FetchMeGqlQueryVariables>;
export function useFetchMeGqlSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchMeGqlQuery, FetchMeGqlQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchMeGqlQuery, FetchMeGqlQueryVariables>(FetchMeGqlDocument, options);
        }
export type FetchMeGqlQueryHookResult = ReturnType<typeof useFetchMeGqlQuery>;
export type FetchMeGqlLazyQueryHookResult = ReturnType<typeof useFetchMeGqlLazyQuery>;
export type FetchMeGqlSuspenseQueryHookResult = ReturnType<typeof useFetchMeGqlSuspenseQuery>;
export type FetchMeGqlQueryResult = Apollo.QueryResult<FetchMeGqlQuery, FetchMeGqlQueryVariables>;
export function refetchFetchMeGqlQuery(variables?: FetchMeGqlQueryVariables) {
      return { query: FetchMeGqlDocument, variables: variables }
    }
export const OrganizationBrandAppearanceDocument = gql`
    query organizationBrandAppearance {
  organizationBrandAppearance {
    squareLogo {
      id
      uuid
    }
    landscapeLogo {
      id
      uuid
    }
  }
}
    `;

/**
 * __useOrganizationBrandAppearanceQuery__
 *
 * To run a query within a React component, call `useOrganizationBrandAppearanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBrandAppearanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBrandAppearanceQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationBrandAppearanceQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>(OrganizationBrandAppearanceDocument, options);
      }
export function useOrganizationBrandAppearanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>(OrganizationBrandAppearanceDocument, options);
        }
// @ts-ignore
export function useOrganizationBrandAppearanceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>;
export function useOrganizationBrandAppearanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>): Apollo.UseSuspenseQueryResult<OrganizationBrandAppearanceQuery | undefined, OrganizationBrandAppearanceQueryVariables>;
export function useOrganizationBrandAppearanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>(OrganizationBrandAppearanceDocument, options);
        }
export type OrganizationBrandAppearanceQueryHookResult = ReturnType<typeof useOrganizationBrandAppearanceQuery>;
export type OrganizationBrandAppearanceLazyQueryHookResult = ReturnType<typeof useOrganizationBrandAppearanceLazyQuery>;
export type OrganizationBrandAppearanceSuspenseQueryHookResult = ReturnType<typeof useOrganizationBrandAppearanceSuspenseQuery>;
export type OrganizationBrandAppearanceQueryResult = Apollo.QueryResult<OrganizationBrandAppearanceQuery, OrganizationBrandAppearanceQueryVariables>;
export function refetchOrganizationBrandAppearanceQuery(variables?: OrganizationBrandAppearanceQueryVariables) {
      return { query: OrganizationBrandAppearanceDocument, variables: variables }
    }
export const CreateCampaignInBookingPermissionDocument = gql`
    query createCampaignInBookingPermission {
  productFamilies(filter: {deprecated: false, externalCreatives: true}) {
    edges {
      node {
        id: code
        code
        name
        icon
        color
      }
    }
  }
}
    `;

/**
 * __useCreateCampaignInBookingPermissionQuery__
 *
 * To run a query within a React component, call `useCreateCampaignInBookingPermissionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignInBookingPermissionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCampaignInBookingPermissionQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreateCampaignInBookingPermissionQuery(baseOptions?: Apollo.QueryHookOptions<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>(CreateCampaignInBookingPermissionDocument, options);
      }
export function useCreateCampaignInBookingPermissionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>(CreateCampaignInBookingPermissionDocument, options);
        }
// @ts-ignore
export function useCreateCampaignInBookingPermissionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>;
export function useCreateCampaignInBookingPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>): Apollo.UseSuspenseQueryResult<CreateCampaignInBookingPermissionQuery | undefined, CreateCampaignInBookingPermissionQueryVariables>;
export function useCreateCampaignInBookingPermissionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>(CreateCampaignInBookingPermissionDocument, options);
        }
export type CreateCampaignInBookingPermissionQueryHookResult = ReturnType<typeof useCreateCampaignInBookingPermissionQuery>;
export type CreateCampaignInBookingPermissionLazyQueryHookResult = ReturnType<typeof useCreateCampaignInBookingPermissionLazyQuery>;
export type CreateCampaignInBookingPermissionSuspenseQueryHookResult = ReturnType<typeof useCreateCampaignInBookingPermissionSuspenseQuery>;
export type CreateCampaignInBookingPermissionQueryResult = Apollo.QueryResult<CreateCampaignInBookingPermissionQuery, CreateCampaignInBookingPermissionQueryVariables>;
export function refetchCreateCampaignInBookingPermissionQuery(variables?: CreateCampaignInBookingPermissionQueryVariables) {
      return { query: CreateCampaignInBookingPermissionDocument, variables: variables }
    }